// Lesson quizzes — 3 multiple-choice questions per lesson, in ES/EN/SK
// Auto-generated by /app/scripts/build_quiz_js.py — do not edit by hand.

export const QUIZZES = {
  L0_0: {
    es: [
      {
        q: `¿Cuánto poder adquisitivo ha perdido el dólar desde 1971 según la lección?`,
        options: [`50% de su valor original`, `75% de su valor original`, `93% de su valor original`, `80% de su valor original`],
        correct: 2,
      },
      {
        q: `¿Qué problema fundamental resolvió Bitcoin según el Whitepaper de Satoshi?`,
        options: [`El problema de la velocidad de transacción bancaria`, `El problema del doble gasto en dinero digital`, `El problema de la privacidad en pagos físicos`, `El problema de las comisiones bancarias altas`],
        correct: 1,
      },
      {
        q: `¿Cuál afirmación sobre el bloque génesis de Bitcoin es INCORRECTA?`,
        options: [`Fue creado el 3 de enero de 2009`, `Contenía un titular del Times sobre rescates bancarios`, `Fue minado después de aprobarse los ETF de Bitcoin`, `Coincidió con anuncios de rescates bancarios masivos`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `How much purchasing power has the dollar lost since 1971 according to the lesson?`,
        options: [`50% of its original value`, `75% of its original value`, `93% of its original value`, `80% of its original value`],
        correct: 2,
      },
      {
        q: `What fundamental problem did Bitcoin solve according to Satoshi's Whitepaper?`,
        options: [`The problem of slow banking transaction speed`, `The double-spending problem in digital money`, `The problem of privacy in physical payments`, `The problem of high banking fees`],
        correct: 1,
      },
      {
        q: `Which statement about Bitcoin's genesis block is INCORRECT?`,
        options: [`It was created on January 3, 2009`, `It contained a Times headline about bank bailouts`, `It was mined after Bitcoin ETFs were approved`, `It coincided with announcements of massive bank bailouts`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Koľko kúpnej sily stratil dolár od roku 1971 podľa lekcie?`,
        options: [`50% svojej pôvodnej hodnoty`, `75% svojej pôvodnej hodnoty`, `93% svojej pôvodnej hodnoty`, `80% svojej pôvodnej hodnoty`],
        correct: 2,
      },
      {
        q: `Aký zásadný problém vyriešil Bitcoin podľa Satoshi Whitepaper?`,
        options: [`Problém pomalej rýchlosti bankových transakcií`, `Problém dvojitého míňania v digitálnych peniazoch`, `Problém súkromia pri fyzických platbách`, `Problém vysokých bankových poplatkov`],
        correct: 1,
      },
      {
        q: `Ktoré tvrdenie o genesis bloku Bitcoinu je NESPRÁVNE?`,
        options: [`Bol vytvorený 3. januára 2009`, `Obsahoval titulok z Times o bankových záchranách`, `Bol vyťažený po schválení Bitcoin ETF`, `Zhodoval sa s oznámeniami masívnych bankových záchrán`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Wie viel Kaufkraft hat der Dollar seit 1971 laut der Lektion verloren?`,
        options: [`50% seines ursprünglichen Wertes`, `75% seines ursprünglichen Wertes`, `93% seines ursprünglichen Wertes`, `80% seines ursprünglichen Wertes`],
        correct: 2,
      },
      {
        q: `Welches grundlegende Problem löste Bitcoin laut Satoshis Whitepaper?`,
        options: [`Das Problem der Geschwindigkeit von Banktransaktionen`, `Das Problem der Doppelausgabe bei digitalem Geld`, `Das Problem der Privatsphäre bei physischen Zahlungen`, `Das Problem hoher Bankgebühren`],
        correct: 1,
      },
      {
        q: `Welche Aussage über den Genesis-Block von Bitcoin ist FALSCH?`,
        options: [`Er wurde am 3. Januar 2009 erstellt`, `Er enthielt eine Schlagzeile der Times über Bankenrettungen`, `Er wurde nach der Genehmigung der Bitcoin-ETFs gemint`, `Er fiel mit Ankündigungen massiver Bankenrettungen zusammen`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `根据课程内容，自1971年以来美元损失了多少购买力？`,
        options: [`原始价值的50%`, `原始价值的75%`, `原始价值的93%`, `原始价值的80%`],
        correct: 2,
      },
      {
        q: `根据中本聪白皮书，Bitcoin解决了什么根本问题？`,
        options: [`银行交易速度问题`, `数字货币的双重支付问题`, `实物支付的隐私问题`, `高额银行手续费问题`],
        correct: 1,
      },
      {
        q: `关于Bitcoin创世区块，以下哪项陈述是错误的？`,
        options: [`创建于2009年1月3日`, `包含了泰晤士报关于银行救助的标题`, `在Bitcoin ETF获批后被挖出`, `与大规模银行救助公告同时发生`],
        correct: 2,
      },
    ],
  },
  L0_1: {
    es: [
      {
        q: `¿Qué garantiza la resiliencia de la red Bitcoin?`,
        options: [`Miles de nodos mantienen copia idéntica de toda la historia de transacciones`, `Un servidor central protegido con máxima seguridad`, `Los mineros guardan copias de seguridad en la nube`, `Las exchanges centralizadas sincronizan los datos`],
        correct: 0,
      },
      {
        q: `¿Qué ocurre cada 210,000 bloques en Bitcoin?`,
        options: [`Se duplica la dificultad de minería permanentemente`, `La recompensa por bloque se reduce a la mitad (halving)`, `Se reinicia la blockchain para mayor eficiencia`, `Los nodos completos deben actualizarse obligatoriamente`],
        correct: 1,
      },
      {
        q: `¿Cuál afirmación sobre claves criptográficas es INCORRECTA?`,
        options: [`La clave privada es un número aleatorio de 256 bits`, `La clave pública se deriva matemáticamente de la privada`, `La clave pública debe mantenerse en secreto absoluto`, `Tu dirección Bitcoin es un hash de tu clave pública`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `What guarantees Bitcoin network resilience?`,
        options: [`Thousands of nodes maintain identical copy of entire transaction history`, `A central server protected with maximum security`, `Miners store cloud backups of all data`, `Centralized exchanges synchronize the data`],
        correct: 0,
      },
      {
        q: `What happens every 210,000 blocks in Bitcoin?`,
        options: [`Mining difficulty doubles permanently`, `Block reward is cut in half (halving)`, `Blockchain resets for greater efficiency`, `Full nodes must update mandatorily`],
        correct: 1,
      },
      {
        q: `Which statement about cryptographic keys is INCORRECT?`,
        options: [`The private key is a random 256-bit number`, `The public key is mathematically derived from the private key`, `The public key must be kept in absolute secrecy`, `Your Bitcoin address is a hash of your public key`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Čo zaručuje odolnosť siete Bitcoin?`,
        options: [`Tisíce uzlov udržiavajú identickú kópiu celej histórie transakcií`, `Centrálny server chránený maximálnym zabezpečením`, `Ťažiari ukladajú zálohy v cloude`, `Centralizované burzy synchronizujú dáta`],
        correct: 0,
      },
      {
        q: `Čo sa stane každých 210,000 blokov v Bitcoine?`,
        options: [`Obtiažnosť ťažby sa natrvalo zdvojnásobí`, `Odmena za blok sa zníži na polovicu (halving)`, `Blockchain sa resetuje pre väčšiu efektivitu`, `Plné uzly sa musia povinne aktualizovať`],
        correct: 1,
      },
      {
        q: `Ktoré tvrdenie o kryptografických klúčoch je NESPRÁVNE?`,
        options: [`Súkromný klúč je náhodné 256-bitové číslo`, `Verejný klúč je matematicky odvodený zo súkromného`, `Verejný klúč musí byť udržiavaný v absolútnom tajomstve`, `Vaša Bitcoin adresa je hash vášho verejného klúča`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Was garantiert die Widerstandsfähigkeit des Bitcoin-Netzwerks?`,
        options: [`Tausende von Knoten halten eine identische Kopie der gesamten Transaktionshistorie`, `Ein zentraler Server, der mit maximaler Sicherheit geschützt ist`, `Die Miner speichern Backups in der Cloud`, `Zentralisierte Exchanges synchronisieren die Daten`],
        correct: 0,
      },
      {
        q: `Was geschieht alle 210.000 Blöcke bei Bitcoin?`,
        options: [`Die Mining-Schwierigkeit verdoppelt sich dauerhaft`, `Die Blockbelohnung wird halbiert (halving)`, `Die Blockchain wird für mehr Effizienz neu gestartet`, `Vollständige Knoten müssen obligatorisch aktualisiert werden`],
        correct: 1,
      },
      {
        q: `Welche Aussage über kryptografische Schlüssel ist FALSCH?`,
        options: [`Der private Schlüssel ist eine zufällige 256-Bit-Zahl`, `Der öffentliche Schlüssel wird mathematisch aus dem privaten abgeleitet`, `Der öffentliche Schlüssel muss absolut geheim gehalten werden`, `Deine Bitcoin-Adresse ist ein Hash deines öffentlichen Schlüssels`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `什么保证了Bitcoin网络的韧性？`,
        options: [`数千个节点保存着所有交易历史的相同副本`, `一个受到最高安全保护的中央服务器`, `矿工在云端保存备份副本`, `中心化交易所同步数据`],
        correct: 0,
      },
      {
        q: `Bitcoin每210,000个区块会发生什么？`,
        options: [`挖矿难度永久翻倍`, `区块奖励减半(halving)`, `区块链重启以提高效率`, `完整节点必须强制更新`],
        correct: 1,
      },
      {
        q: `关于加密密钥，以下哪项陈述是错误的？`,
        options: [`私钥是一个256位的随机数`, `公钥通过数学方式从私钥派生`, `公钥必须绝对保密`, `你的Bitcoin地址是公钥的哈希值`],
        correct: 2,
      },
    ],
  },
  L0_2: {
    es: [
      {
        q: `¿Cuál es la diferencia fundamental entre Bitcoin y las altcoins?`,
        options: [`Bitcoin es dinero digital descentralizado con escasez absoluta y 15+ años sin hackeo`, `Bitcoin es más rápido y barato que todas las altcoins`, `Bitcoin permite contratos inteligentes mientras las altcoins no`, `Bitcoin tiene mayor TVL en protocolos DeFi que las altcoins`],
        correct: 0,
      },
      {
        q: `¿Qué permite DeFi que las finanzas tradicionales NO ofrecen?`,
        options: [`Rendimientos garantizados sin riesgo de pérdida`, `Acceso a servicios financieros sin cuenta bancaria ni documentación`, `Protección completa contra hackeos y pérdidas`, `Reversión de transacciones en caso de error humano`],
        correct: 1,
      },
      {
        q: `¿Cuál afirmación sobre stablecoins es INCORRECTA?`,
        options: [`USDT y USDC están respaldadas por reservas en fiat`, `DAI está sobrecolarelizada con ETH en MakerDAO`, `Las stablecoins algorítmicas son el tipo más seguro y probado`, `Permiten salir a efectivo cripto sin abandonar la blockchain`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `What is the fundamental difference between Bitcoin and altcoins?`,
        options: [`Bitcoin is decentralized digital money with absolute scarcity and 15+ years unhacked`, `Bitcoin is faster and cheaper than all altcoins`, `Bitcoin enables smart contracts while altcoins do not`, `Bitcoin has higher TVL in DeFi protocols than altcoins`],
        correct: 0,
      },
      {
        q: `What does DeFi enable that traditional finance does NOT offer?`,
        options: [`Guaranteed returns with no risk of loss`, `Access to financial services without bank account or documentation`, `Complete protection against hacks and losses`, `Transaction reversal in case of human error`],
        correct: 1,
      },
      {
        q: `Which statement about stablecoins is INCORRECT?`,
        options: [`USDT and USDC are backed by fiat reserves`, `DAI is overcollateralized with ETH in MakerDAO`, `Algorithmic stablecoins are the safest and most proven type`, `They allow exiting to crypto cash without leaving blockchain`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Aký je zásadný rozdiel medzi Bitcoinom a altcoinmi?`,
        options: [`Bitcoin je decentralizované digitálne peniaze s absolútnou vzácnosťou a 15+ rokov bez hacku`, `Bitcoin je rýchlejší a lacnejší ako všetky altcoiny`, `Bitcoin umožňuje smart kontrakty zatiaľ čo altcoiny nie`, `Bitcoin má vyššie TVL v DeFi protokoloch ako altcoiny`],
        correct: 0,
      },
      {
        q: `Čo DeFi umožňuje, čo tradičné financie NEPONÚKAJÚ?`,
        options: [`Garantované výnosy bez rizika straty`, `Prístup k finančným službám bez bankového účtu či dokumentácie`, `Kompletnú ochranu proti hackom a stratám`, `Zrušenie transakcií v prípade ľudskej chyby`],
        correct: 1,
      },
      {
        q: `Ktoré tvrdenie o stablecoinoch je NESPRÁVNE?`,
        options: [`USDT a USDC sú kryté fiatovými rezervami`, `DAI je nadkolateralizované s ETH v MakerDAO`, `Algoritmické stablecoiny sú najbezpečnejší a najoverený typ`, `Umožňujú odchod do krypto hotovosti bez opustenia blockchainu`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Was ist der grundlegende Unterschied zwischen Bitcoin und Altcoins?`,
        options: [`Bitcoin ist dezentrales digitales Geld mit absoluter Knappheit und 15+ Jahren ohne Hack`, `Bitcoin ist schneller und günstiger als alle Altcoins`, `Bitcoin ermöglicht Smart Contracts, während Altcoins dies nicht tun`, `Bitcoin hat einen höheren TVL in DeFi-Protokollen als Altcoins`],
        correct: 0,
      },
      {
        q: `Was ermöglicht DeFi, das traditionelle Finanzen NICHT bieten?`,
        options: [`Garantierte Renditen ohne Verlustrisiko`, `Zugang zu Finanzdienstleistungen ohne Bankkonto oder Dokumentation`, `Vollständiger Schutz vor Hacks und Verlusten`, `Rückgängigmachung von Transaktionen bei menschlichem Fehler`],
        correct: 1,
      },
      {
        q: `Welche Aussage über Stablecoins ist FALSCH?`,
        options: [`USDT und USDC sind durch Fiat-Reserven gedeckt`, `DAI ist mit ETH in MakerDAO überbesichert`, `Algorithmische Stablecoins sind der sicherste und bewährteste Typ`, `Sie ermöglichen den Ausstieg in Krypto-Cash ohne die Blockchain zu verlassen`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `Bitcoin与山寨币之间的根本区别是什么？`,
        options: [`Bitcoin是去中心化的数字货币，具有绝对稀缺性且15年以上未被黑客攻击`, `Bitcoin比所有山寨币更快更便宜`, `Bitcoin支持智能合约而山寨币不支持`, `Bitcoin在DeFi协议中的TVL高于山寨币`],
        correct: 0,
      },
      {
        q: `DeFi提供了哪些传统金融无法提供的功能？`,
        options: [`无风险损失的保证收益`, `无需银行账户或文件即可获得金融服务`, `完全防止黑客攻击和损失`, `人为错误时可撤销交易`],
        correct: 1,
      },
      {
        q: `关于稳定币，以下哪项陈述是错误的？`,
        options: [`USDT和USDC由法币储备支持`, `DAI在MakerDAO中由ETH超额抵押`, `算法稳定币是最安全且经过验证的类型`, `允许在不离开区块链的情况下退出到加密现金`],
        correct: 2,
      },
    ],
  },
  L0_3: {
    es: [
      {
        q: `¿Qué almacena realmente una wallet de criptomonedas?`,
        options: [`Las claves privadas que prueban tu derecho a gastar fondos`, `Las monedas digitales en un archivo encriptado local`, `Una copia completa de la blockchain con tus transacciones`, `Los tokens en formato digital dentro del dispositivo`],
        correct: 0,
      },
      {
        q: `¿Cuál es la forma MÁS segura de almacenar tu seed phrase?`,
        options: [`En una foto encriptada guardada en la nube privada`, `En un documento de texto protegido con contraseña fuerte`, `Grabada en placa de acero en múltiples ubicaciones físicas`, `En un gestor de contraseñas offline de alta seguridad`],
        correct: 2,
      },
      {
        q: `¿Qué afirmación sobre hot wallets y cold wallets es INCORRECTA?`,
        options: [`Hot wallets son más convenientes para trading activo diario`, `Cold wallets mantienen claves en dispositivos offline aislados`, `Hardware wallets eliminan completamente todo riesgo de pérdida`, `Hot wallets son más vulnerables a malware y phishing`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `What does a cryptocurrency wallet actually store?`,
        options: [`The private keys proving your right to spend funds`, `The digital coins in an encrypted local file`, `A full blockchain copy with your transaction history`, `The tokens in digital format inside the device`],
        correct: 0,
      },
      {
        q: `What is the MOST secure way to store your seed phrase?`,
        options: [`In an encrypted photo saved in private cloud storage`, `In a text document protected with a strong password`, `Engraved on steel plates in multiple physical locations`, `In an offline high-security password manager application`],
        correct: 2,
      },
      {
        q: `Which statement about hot wallets and cold wallets is INCORRECT?`,
        options: [`Hot wallets are more convenient for daily active trading`, `Cold wallets keep keys on isolated offline devices`, `Hardware wallets completely eliminate all risk of loss`, `Hot wallets are more vulnerable to malware and phishing`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Čo v skutočnosti ukladá kryptomenová peňaženka?`,
        options: [`Súkromné kľúče dokazujúce právo minúť prostriedky`, `Digitálne mince v zašifrovanom lokálnom súbore`, `Úplnú kópiu blockchainu s vašimi transakciami`, `Tokeny v digitálnom formáte vnútri zariadenia`],
        correct: 0,
      },
      {
        q: `Aký je NAJBEZPEČNEJŠÍ sposob uloženia seed phrase?`,
        options: [`V zašifrovanej fotografii uloženej v súkromnom cloude`, `V textovom dokumente chránenom silným heslom`, `Vyrytá na oceľových doskách na viacerých miestach`, `V offline správcovi hesiel s vysokou bezpečnosťou`],
        correct: 2,
      },
      {
        q: `Ktoré tvrdenie o hot wallets a cold wallets je NESPRÁVNE?`,
        options: [`Hot wallets sú pohodlnejšie pre každodenný aktívny trading`, `Cold wallets uchovávajú kľúče na izolovaných offline zariadeniach`, `Hardware wallets úplne eliminujú všetko riziko straty`, `Hot wallets sú zraniteľnejšie voči malvéru a phishingu`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Was speichert eine Krypto-Wallet tatsächlich?`,
        options: [`Die privaten Schlüssel, die dein Recht zum Ausgeben von Geldern beweisen`, `Die digitalen Münzen in einer lokal verschlüsselten Datei`, `Eine vollständige Kopie der Blockchain mit deinen Transaktionen`, `Die Token in digitalem Format innerhalb des Geräts`],
        correct: 0,
      },
      {
        q: `Was ist die SICHERSTE Art, deine Seed Phrase aufzubewahren?`,
        options: [`In einem verschlüsselten Foto, das in der privaten Cloud gespeichert ist`, `In einem Textdokument, das mit einem starken Passwort geschützt ist`, `Eingraviert auf Stahlplatten an mehreren physischen Orten`, `In einem Offline-Passwort-Manager mit hoher Sicherheit`],
        correct: 2,
      },
      {
        q: `Welche Aussage über Hot Wallets und Cold Wallets ist FALSCH?`,
        options: [`Hot Wallets sind praktischer für aktives tägliches Trading`, `Cold Wallets halten Schlüssel auf isolierten Offline-Geräten`, `Hardware Wallets eliminieren jedes Verlustrisiko vollständig`, `Hot Wallets sind anfälliger für Malware und Phishing`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `加密货币钱包实际存储的是什么？`,
        options: [`证明你有权使用资金的私钥`, `本地加密文件中的数字货币`, `包含你交易记录的完整区块链副本`, `设备内数字格式的代币`],
        correct: 0,
      },
      {
        q: `存储助记词最安全的方式是什么？`,
        options: [`保存在私有云端的加密照片中`, `用强密码保护的文本文档`, `刻在钢板上并存放在多个物理位置`, `离线高安全性密码管理器中`],
        correct: 2,
      },
      {
        q: `关于热钱包和冷钱包，哪个说法是错误的？`,
        options: [`热钱包更适合日常活跃交易`, `冷钱包将私钥保存在离线隔离设备中`, `硬件钱包完全消除了所有丢失风险`, `热钱包更容易受到恶意软件和钓鱼攻击`],
        correct: 2,
      },
    ],
  },
  L0_4: {
    es: [
      {
        q: `¿Cuál es la principal diferencia entre un CEX y un DEX?`,
        options: [`El CEX custodia tus fondos; el DEX te deja las claves privadas`, `El DEX siempre tiene mayor liquidez que el CEX`, `El CEX usa AMM; el DEX usa libro de órdenes`, `El DEX requiere KYC obligatorio; el CEX no`],
        correct: 0,
      },
      {
        q: `¿Qué tipo de orden usarías para vender BTC a $50,000 exactos?`,
        options: [`Market order, porque ejecuta al mejor precio`, `Limit order, porque especifica tu precio deseado`, `Stop-Loss, porque protege tu capital`, `OCO, porque combina dos órdenes automáticas`],
        correct: 1,
      },
      {
        q: `En un AMM, ¿qué determina el precio de los tokens en el pool?`,
        options: [`El promedio de precios de todos los CEX globales`, `La ratio entre las reservas de ambos tokens (x*y=k)`, `El libro de órdenes del DEX más cercano`, `Los votos de los proveedores de liquidez`],
        correct: 1,
      },
    ],
    en: [
      {
        q: `What is the main difference between a CEX and a DEX?`,
        options: [`CEX custodies your funds; DEX leaves you the private keys`, `DEX always has higher liquidity than CEX`, `CEX uses AMM; DEX uses order book`, `DEX requires mandatory KYC; CEX does not`],
        correct: 0,
      },
      {
        q: `Which order type would you use to sell BTC at exactly $50,000?`,
        options: [`Market order, because it executes at best price`, `Limit order, because it specifies your desired price`, `Stop-Loss, because it protects your capital`, `OCO, because it combines two automatic orders`],
        correct: 1,
      },
      {
        q: `In an AMM, what determines the price of tokens in the pool?`,
        options: [`The average price of all global CEXs`, `The ratio between reserves of both tokens (x*y=k)`, `The order book of the nearest DEX`, `Votes from liquidity providers`],
        correct: 1,
      },
    ],
    sk: [
      {
        q: `Aký je hlavný rozdiel medzi CEX a DEX?`,
        options: [`CEX ukladá tvoje prostriedky; DEX ti necháva súkromné kľúče`, `DEX má vždy vyššiu likviditu ako CEX`, `CEX používa AMM; DEX používa knihu príkazov`, `DEX vyžaduje povinné KYC; CEX nie`],
        correct: 0,
      },
      {
        q: `Aký typ príkazu použiješ na predaj BTC presne za $50,000?`,
        options: [`Market order, pretože sa vykoná za najlepšiu cenu`, `Limit order, pretože špecifikuje tvoju požadovanú cenu`, `Stop-Loss, pretože chráni tvoj kapitál`, `OCO, pretože kombinuje dva automatické príkazy`],
        correct: 1,
      },
      {
        q: `Čo určuje cenu tokenov v AMM poole?`,
        options: [`Priemerná cena zo všetkých globálnych CEX`, `Pomer medzi rezervami oboch tokenov (x*y=k)`, `Kniha príkazov najbližšieho DEX`, `Hlasy poskytovateľov likvidity`],
        correct: 1,
      },
    ],
    de: [
      {
        q: `Was ist der Hauptunterschied zwischen einem CEX und einem DEX?`,
        options: [`Der CEX verwahrt deine Gelder; der DEX lässt dir die privaten Schlüssel`, `Der DEX hat immer höhere Liquidität als der CEX`, `Der CEX nutzt AMM; der DEX nutzt Orderbuch`, `Der DEX erfordert obligatorisches KYC; der CEX nicht`],
        correct: 0,
      },
      {
        q: `Welchen Ordertyp würdest du verwenden, um BTC zu genau $50.000 zu verkaufen?`,
        options: [`Market Order, weil sie zum besten Preis ausgeführt wird`, `Limit Order, weil sie deinen gewünschten Preis festlegt`, `Stop-Loss, weil sie dein Kapital schützt`, `OCO, weil sie zwei automatische Orders kombiniert`],
        correct: 1,
      },
      {
        q: `Was bestimmt in einem AMM den Preis der Token im Pool?`,
        options: [`Der Durchschnittspreis aller globalen CEX`, `Das Verhältnis zwischen den Reserven beider Token (x*y=k)`, `Das Orderbuch des nächstgelegenen DEX`, `Die Abstimmungen der Liquiditätsanbieter`],
        correct: 1,
      },
    ],
    "zh-CN": [
      {
        q: `CEX和DEX的主要区别是什么？`,
        options: [`CEX托管你的资金；DEX让你保留私钥`, `DEX的流动性总是高于CEX`, `CEX使用AMM；DEX使用订单簿`, `DEX要求强制KYC；CEX不需要`],
        correct: 0,
      },
      {
        q: `如果要以正好50,000美元卖出BTC，你会使用哪种订单？`,
        options: [`市价单，因为它以最佳价格执行`, `限价单，因为它指定你想要的价格`, `止损单，因为它保护你的资金`, `OCO单，因为它组合两个自动订单`],
        correct: 1,
      },
      {
        q: `在AMM中，是什么决定了池中代币的价格？`,
        options: [`所有全球CEX的平均价格`, `两种代币储备量之间的比率(x*y=k)`, `最近的DEX订单簿`, `流动性提供者的投票`],
        correct: 1,
      },
    ],
  },
  L0_5: {
    es: [
      {
        q: `¿Por qué se usa escala logarítmica para analizar Bitcoin?`,
        options: [`Porque muestra los mismos porcentajes de cambio con igual distancia visual`, `Porque hace que los gráficos se vean más profesionales`, `Porque la escala lineal no funciona en TradingView`, `Porque reduce el ruido en timeframes bajos`],
        correct: 0,
      },
      {
        q: `Según la regla MTF, ¿cuál es la función del timeframe medio?`,
        options: [`Determinar el sesgo direccional principal`, `Dar la entrada precisa al mercado`, `Identificar el setup de trading`, `Confirmar la tendencia macro mensual`],
        correct: 2,
      },
      {
        q: `Un trader opera en 1H alcista ignorando que el diario es bajista. ¿Qué error comete?`,
        options: [`Usa un timeframe demasiado alto para scalping`, `Opera contra el sesgo del timeframe superior`, `No configura alertas de precio correctamente`, `Usa escala lineal en lugar de logarítmica`],
        correct: 1,
      },
    ],
    en: [
      {
        q: `Why is logarithmic scale used to analyze Bitcoin?`,
        options: [`Because it shows equal percentage changes with equal visual distance`, `Because it makes charts look more professional`, `Because linear scale doesn't work on TradingView`, `Because it reduces noise on lower timeframes`],
        correct: 0,
      },
      {
        q: `According to the MTF rule, what is the medium timeframe's function?`,
        options: [`Determine the main directional bias`, `Provide the precise market entry`, `Identify the trading setup`, `Confirm the monthly macro trend`],
        correct: 2,
      },
      {
        q: `A trader goes long on 1H ignoring the daily is bearish. What mistake are they making?`,
        options: [`Using a timeframe too high for scalping`, `Trading against the higher timeframe bias`, `Not setting price alerts correctly`, `Using linear scale instead of logarithmic`],
        correct: 1,
      },
    ],
    sk: [
      {
        q: `Prečo sa používa logaritmická škála na analýzu Bitcoinu?`,
        options: [`Pretože zobrazuje rovnaké percentuálne zmeny s rovnakou vizuálnou vzdialenosťou`, `Pretože grafy vyzerajú profesionálnejšie`, `Pretože lineárna škála nefunguje na TradingView`, `Pretože redukuje šum na nízkych timeframe-och`],
        correct: 0,
      },
      {
        q: `Podľa MTF pravidla, aká je funkcia stredného timeframe-u?`,
        options: [`Určiť hlavné smerové skreslenie (bias)`, `Poskytnúť presný vstup do trhu`, `Identifikovať obchodný setup`, `Potvrdiť mesačný makro trend`],
        correct: 2,
      },
      {
        q: `Obchodník ide long na 1H, ignorujúc, že denný je bearish. Akú chybu robí?`,
        options: [`Používa príliš vysoký timeframe na scalping`, `Obchoduje proti skresleniu vyššieho timeframe-u`, `Nenastavuje cenové upozornenia správne`, `Používa lineárnu škálu namiesto logaritmickej`],
        correct: 1,
      },
    ],
    de: [
      {
        q: `Warum wird die logarithmische Skala zur Analyse von Bitcoin verwendet?`,
        options: [`Weil sie die gleichen prozentualen Veränderungen mit gleichem visuellen Abstand zeigt`, `Weil sie die Charts professioneller aussehen lässt`, `Weil die lineare Skala in TradingView nicht funktioniert`, `Weil sie das Rauschen in niedrigen Timeframes reduziert`],
        correct: 0,
      },
      {
        q: `Was ist laut MTF-Regel die Funktion des mittleren Timeframes?`,
        options: [`Die hauptsächliche Richtungstendenz bestimmen`, `Den präzisen Markteintritt geben`, `Das Trading-Setup identifizieren`, `Den monatlichen Makro-Trend bestätigen`],
        correct: 2,
      },
      {
        q: `Ein Trader handelt auf 1H bullisch und ignoriert, dass der Tageschart bärisch ist. Welchen Fehler begeht er?`,
        options: [`Er verwendet einen zu hohen Timeframe für Scalping`, `Er handelt gegen die Ausrichtung des höheren Timeframes`, `Er konfiguriert Preisalarme nicht korrekt`, `Er verwendet lineare statt logarithmische Skala`],
        correct: 1,
      },
    ],
    "zh-CN": [
      {
        q: `为什么使用对数刻度来分析Bitcoin？`,
        options: [`因为它用相同的视觉距离显示相同的百分比变化`, `因为它让图表看起来更专业`, `因为线性刻度在TradingView上不起作用`, `因为它减少了低时间周期的噪音`],
        correct: 0,
      },
      {
        q: `根据MTF规则，中等时间周期的功能是什么？`,
        options: [`确定主要方向偏向`, `给出精确的市场入场点`, `识别交易设置`, `确认宏观月度趋势`],
        correct: 2,
      },
      {
        q: `一个交易者在1H看涨时操作，却忽略了日线是看跌的。他犯了什么错误？`,
        options: [`使用了过高的时间周期进行剥头皮交易`, `逆着更高时间周期的偏向操作`, `没有正确设置价格警报`, `使用线性刻度而不是对数刻度`],
        correct: 1,
      },
    ],
  },
  L0_6: {
    es: [
      {
        q: `¿Qué representa el cuerpo de una vela japonesa?`,
        options: [`La distancia entre apertura y cierre del período`, `Los intentos fallidos de compradores y vendedores`, `El volumen total negociado en el período`, `La volatilidad máxima alcanzada en la sesión`],
        correct: 0,
      },
      {
        q: `Un Martillo (Hammer) es más efectivo cuando aparece:`,
        options: [`En el centro de una zona de consolidación sin volumen`, `En zona de soporte mayor con confluencia y volumen`, `En cualquier punto de una tendencia alcista fuerte`, `Cerca de resistencias con mechas superiores largas`],
        correct: 1,
      },
      {
        q: `¿Cuál afirmación sobre el patrón Morning Star es INCORRECTA?`,
        options: [`Consiste en tres velas: roja grande, pequeña/doji, verde grande`, `Es considerado el giro de 180 grados más fiable`, `La vela central debe tener cuerpo largo y mechas cortas`, `Señala un cambio de momentum de bajista a alcista`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `What does the body of a Japanese candlestick represent?`,
        options: [`The distance between open and close of the period`, `The failed attempts of buyers and sellers`, `The total volume traded during the period`, `The maximum volatility reached in the session`],
        correct: 0,
      },
      {
        q: `A Hammer pattern is most effective when it appears:`,
        options: [`In the center of consolidation zone without volume`, `At major support zone with confluence and volume`, `At any point in a strong uptrend`, `Near resistance levels with long upper wicks`],
        correct: 1,
      },
      {
        q: `Which statement about the Morning Star pattern is INCORRECT?`,
        options: [`It consists of three candles: large red, small/doji, large green`, `It is considered the most reliable 180-degree reversal`, `The middle candle must have long body and short wicks`, `It signals a momentum change from bearish to bullish`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Čo predstavuje telo japonskej sviečky?`,
        options: [`Vzdialenosť medzi otvorením a zatvorením obdobia`, `Neúspešné pokusy kupcov a predajcov`, `Celkový objem obchodovaný v období`, `Maximálnu volatilitu dosiahnutú v relácii`],
        correct: 0,
      },
      {
        q: `Vzor Kladivo (Hammer) je najefektívnejší, keď sa objaví:`,
        options: [`V strede konsolidačnej zóny bez objemu`, `V zóne väčšej podpory s konfluenciou a objemom`, `V ktoromkoľvek bode silného býčieho trendu`, `Blízko odporov s dlhými hornými knôtmi`],
        correct: 1,
      },
      {
        q: `Ktoré tvrdenie o vzore Morning Star je NESPRÁVNE?`,
        options: [`Pozostáva z troch sviečok: veľká červená, malá/doji, veľká zelená`, `Je považovaný za najspoľahlivejší obrat o 180 stupňov`, `Stredná sviečka musí mať dlhé telo a krátke knôty`, `Signalizuje zmenu momentu z medvedieho na býčie`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Was stellt der Körper einer japanischen Kerze dar?`,
        options: [`Die Distanz zwischen Eröffnung und Schlusskurs der Periode`, `Die gescheiterten Versuche von Käufern und Verkäufern`, `Das gesamte gehandelte Volumen in der Periode`, `Die maximale Volatilität, die in der Sitzung erreicht wurde`],
        correct: 0,
      },
      {
        q: `Ein Hammer ist am effektivsten, wenn er erscheint:`,
        options: [`In der Mitte einer Konsolidierungszone ohne Volumen`, `In einer größeren Unterstützungszone mit Konfluenz und Volumen`, `An jedem Punkt eines starken Aufwärtstrends`, `In der Nähe von Widerständen mit langen oberen Dochten`],
        correct: 1,
      },
      {
        q: `Welche Aussage über das Morning Star Muster ist FALSCH?`,
        options: [`Es besteht aus drei Kerzen: große rote, kleine/Doji, große grüne`, `Es gilt als die zuverlässigste 180-Grad-Wende`, `Die mittlere Kerze muss einen langen Körper und kurze Dochte haben`, `Es signalisiert einen Momentum-Wechsel von bärisch zu bullisch`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `日本蜡烛图的实体代表什么?`,
        options: [`该周期开盘价和收盘价之间的距离`, `买方和卖方的失败尝试`, `该周期的总交易量`, `该交易时段达到的最大波动率`],
        correct: 0,
      },
      {
        q: `锤子线(Hammer)在以下哪种情况下最有效:`,
        options: [`在没有成交量的盘整区间中心`, `在主要支撑位区域有汇聚点和成交量`, `在任何强劲上升趋势的点位`, `在阻力位附近有长上影线`],
        correct: 1,
      },
      {
        q: `关于启明星形态,以下哪项陈述是错误的?`,
        options: [`由三根蜡烛组成:大阴线、小实体/十字星、大阳线`, `被认为是最可靠的180度反转形态`, `中间蜡烛必须有长实体和短影线`, `标志着动能从看跌转为看涨`],
        correct: 2,
      },
    ],
  },
  L0_7: {
    es: [
      {
        q: `¿Cuál es la principal diferencia entre SMA y EMA?`,
        options: [`SMA da más peso a precios recientes, EMA promedia todo igual`, `EMA da más peso a precios recientes y reacciona más rápido`, `SMA usa 50 períodos, EMA usa 200 períodos`, `EMA solo funciona en timeframes diarios`],
        correct: 1,
      },
      {
        q: `Una divergencia bajista RSI ocurre cuando:`,
        options: [`Precio y RSI hacen nuevos máximos juntos`, `RSI cae por debajo de 30 en sobreventa`, `Precio hace nuevo máximo pero RSI hace máximo inferior`, `El MACD cruza por encima de su Signal Line`],
        correct: 2,
      },
      {
        q: `¿Cuál afirmación sobre el uso institucional de medias móviles es INCORRECTA?`,
        options: [`EMA 50 se usa como referencia de sesgo intermedio`, `SMA 200 es el indicador más seguido globalmente`, `Golden Cross ocurre cuando 50 cruza sobre 200`, `EMA 8 y 21 son irrelevantes para traders profesionales`],
        correct: 3,
      },
    ],
    en: [
      {
        q: `What is the main difference between SMA and EMA?`,
        options: [`SMA gives more weight to recent prices, EMA averages equally`, `EMA gives more weight to recent prices and reacts faster`, `SMA uses 50 periods, EMA uses 200 periods`, `EMA only works on daily timeframes`],
        correct: 1,
      },
      {
        q: `A bearish RSI divergence occurs when:`,
        options: [`Price and RSI make new highs together`, `RSI drops below 30 into oversold territory`, `Price makes new high but RSI makes lower high`, `MACD crosses above its Signal Line`],
        correct: 2,
      },
      {
        q: `Which statement about institutional use of moving averages is INCORRECT?`,
        options: [`EMA 50 is used as intermediate bias reference`, `SMA 200 is the most globally followed indicator`, `Golden Cross occurs when 50 crosses above 200`, `EMA 8 and 21 are irrelevant for professional traders`],
        correct: 3,
      },
    ],
    sk: [
      {
        q: `Aký je hlavný rozdiel medzi SMA a EMA?`,
        options: [`SMA prikladá väčšiu váhu nedávnym cenám, EMA spriemeruje rovnako`, `EMA prikladá väčšiu váhu nedávnym cenám a reaguje rýchlejšie`, `SMA používa 50 období, EMA používa 200 období`, `EMA funguje len na denných timeframoch`],
        correct: 1,
      },
      {
        q: `Medvedia divergencia RSI nastáva, keď:`,
        options: [`Cena a RSI robia nové maximá spoločne`, `RSI klesne pod 30 do prepredanosti`, `Cena robí nové maximum, ale RSI robí nižšie maximum`, `MACD prekročí nad svoju Signal Line`],
        correct: 2,
      },
      {
        q: `Ktoré tvrdenie o inštitucionálnom použití kĺzavých priemerov je NESPRÁVNE?`,
        options: [`EMA 50 sa používa ako referencia stredného zaujatia`, `SMA 200 je globálne najsledovanejší indikátor`, `Golden Cross nastáva, keď 50 prekročí nad 200`, `EMA 8 a 21 sú irelevantné pre profesionálnych traderov`],
        correct: 3,
      },
    ],
    de: [
      {
        q: `Was ist der Hauptunterschied zwischen SMA und EMA?`,
        options: [`SMA gewichtet aktuelle Preise stärker, EMA mittelt alles gleich`, `EMA gewichtet aktuelle Preise stärker und reagiert schneller`, `SMA verwendet 50 Perioden, EMA verwendet 200 Perioden`, `EMA funktioniert nur in täglichen Timeframes`],
        correct: 1,
      },
      {
        q: `Eine bärische RSI-Divergenz tritt auf, wenn:`,
        options: [`Preis und RSI zusammen neue Höchststände erreichen`, `RSI unter 30 in den überverkauften Bereich fällt`, `Der Preis ein neues Hoch macht, aber RSI ein niedrigeres Hoch macht`, `Der MACD über seine Signal Line kreuzt`],
        correct: 2,
      },
      {
        q: `Welche Aussage über die institutionelle Nutzung gleitender Durchschnitte ist FALSCH?`,
        options: [`EMA 50 wird als Referenz für mittelfristige Tendenz verwendet`, `SMA 200 ist der weltweit am meisten beachtete Indikator`, `Golden Cross tritt auf, wenn 50 über 200 kreuzt`, `EMA 8 und 21 sind für professionelle Trader irrelevant`],
        correct: 3,
      },
    ],
    "zh-CN": [
      {
        q: `SMA和EMA之间的主要区别是什么?`,
        options: [`SMA对近期价格赋予更多权重,EMA平均所有价格`, `EMA对近期价格赋予更多权重并反应更快`, `SMA使用50个周期,EMA使用200个周期`, `EMA仅在日线时间框架上有效`],
        correct: 1,
      },
      {
        q: `RSI看跌背离发生在:`,
        options: [`价格和RSI一起创新高`, `RSI跌破30进入超卖区`, `价格创新高但RSI形成较低高点`, `MACD向上穿越其信号线`],
        correct: 2,
      },
      {
        q: `关于机构使用移动平均线,以下哪项陈述是错误的?`,
        options: [`EMA 50被用作中期趋势参考`, `SMA 200是全球最受关注的指标`, `黄金交叉发生在50穿越200上方时`, `EMA 8和21对专业交易者无关紧要`],
        correct: 3,
      },
    ],
  },
  L0_8: {
    es: [
      {
        q: `¿Cuánto capital arriesga el trader profesional en una sola operación?`,
        options: [`Máximo 1-2% del capital total`, `Máximo 5% del capital total`, `Máximo 10% del capital total`, `Depende de la confianza en el setup`],
        correct: 0,
      },
      {
        q: `Un trader pierde 50% de su cuenta. ¿Qué ganancia necesita para volver al punto inicial?`,
        options: [`50% de ganancia`, `75% de ganancia`, `100% de ganancia`, `25% de ganancia`],
        correct: 2,
      },
      {
        q: `¿Qué afirmación sobre el stop loss es INCORRECTA?`,
        options: [`Se debe definir antes de abrir la posición`, `Es la diferencia entre trader y apostador`, `Es opcional si tienes suficiente experiencia`, `Invalida tu análisis cuando se alcanza`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `How much capital does a professional trader risk on a single trade?`,
        options: [`Maximum 1-2% of total capital`, `Maximum 5% of total capital`, `Maximum 10% of total capital`, `It depends on setup confidence`],
        correct: 0,
      },
      {
        q: `A trader loses 50% of their account. What gain is needed to break even?`,
        options: [`50% gain`, `75% gain`, `100% gain`, `25% gain`],
        correct: 2,
      },
      {
        q: `Which statement about stop loss is INCORRECT?`,
        options: [`Must be defined before opening the position`, `It's the difference between trader and gambler`, `It's optional if you have enough experience`, `Invalidates your analysis when reached`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Koľko kapitálu riskuje profesionálny trader v jednom obchode?`,
        options: [`Maximum 1-2 % z celkového kapitálu`, `Maximum 5 % z celkového kapitálu`, `Maximum 10 % z celkového kapitálu`, `Závisí od dôvery v setup`],
        correct: 0,
      },
      {
        q: `Trader stratí 50 % svojho účtu. Aký zisk potrebuje na návrat na nulu?`,
        options: [`50 % zisk`, `75 % zisk`, `100 % zisk`, `25 % zisk`],
        correct: 2,
      },
      {
        q: `Ktoré tvrdenie o stop loss je NESPRÁVNE?`,
        options: [`Musí byť definovaný pred otvorením pozície`, `Je rozdiel medzi traderom a stávkarom`, `Je voliteľný, ak máte dostatok skúseností`, `Zneplatňuje vašu analýzu, keď je dosiahnutý`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Wie viel Kapital riskiert der professionelle Trader in einem einzelnen Trade?`,
        options: [`Maximal 1-2% des Gesamtkapitals`, `Maximal 5% des Gesamtkapitals`, `Maximal 10% des Gesamtkapitals`, `Abhängig vom Vertrauen in das Setup`],
        correct: 0,
      },
      {
        q: `Ein Trader verliert 50% seines Kontos. Welchen Gewinn benötigt er, um zum Ausgangspunkt zurückzukehren?`,
        options: [`50% Gewinn`, `75% Gewinn`, `100% Gewinn`, `25% Gewinn`],
        correct: 2,
      },
      {
        q: `Welche Aussage über den Stop Loss ist FALSCH?`,
        options: [`Er sollte vor Eröffnung der Position definiert werden`, `Er ist der Unterschied zwischen Trader und Spieler`, `Er ist optional, wenn man genug Erfahrung hat`, `Er invalidiert deine Analyse, wenn er erreicht wird`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `专业交易者在单笔交易中冒险多少资金?`,
        options: [`总资金的最多1-2%`, `总资金的最多5%`, `总资金的最多10%`, `取决于对设置的信心`],
        correct: 0,
      },
      {
        q: `交易者损失了账户的50%。需要多少收益才能回到起点?`,
        options: [`50%的收益`, `75%的收益`, `100%的收益`, `25%的收益`],
        correct: 2,
      },
      {
        q: `关于止损,以下哪项陈述是错误的?`,
        options: [`应在开仓前确定`, `这是交易者和赌徒的区别`, `如果有足够经验则可选`, `触及时使你的分析失效`],
        correct: 2,
      },
    ],
  },
  L0_9: {
    es: [
      {
        q: `¿Cuál es el nivel de retroceso Fibonacci más importante y por qué se le llama 'Golden Ratio'?`,
        options: [`0.382 porque es el primer nivel de soporte institucional`, `0.5 porque es el nivel psicológico medio del movimiento`, `0.618 porque históricamente los retrocesos se detienen cerca de este nivel`, `0.786 porque marca el límite entre tendencia fuerte y débil`],
        correct: 2,
      },
      {
        q: `¿Qué hace que una zona de confluencia Fibonacci sea de alta probabilidad para institucionales?`,
        options: [`Solo necesita tocar un nivel Fibonacci exacto del 61.8%`, `Debe coincidir Fibonacci con soporte horizontal, media móvil y POC de volumen`, `Requiere al menos 5 niveles Fibonacci en la misma zona`, `Tiene que estar en marco temporal diario o superior`],
        correct: 1,
      },
      {
        q: `Las extensiones Fibonacci proyectan objetivos de precio. ¿Cuál afirmación es INCORRECTA?`,
        options: [`El nivel 1.272 es el primer objetivo de impulso`, `El 1.618 es la 'Golden Extension' usada en Elliott Wave`, `El 2.618 marca el retroceso máximo antes de invalidación`, `Las extensiones miden hasta dónde puede viajar el precio en dirección del trend`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `Which is the most important Fibonacci retracement level and why is it called the 'Golden Ratio'?`,
        options: [`0.382 because it is the first institutional support level`, `0.5 because it is the psychological midpoint of the move`, `0.618 because historically retracements tend to halt near this level`, `0.786 because it marks the boundary between strong and weak trend`],
        correct: 2,
      },
      {
        q: `What makes a Fibonacci confluence zone high-probability for institutions?`,
        options: [`Only needs to touch an exact 61.8% Fibonacci level`, `Must combine Fibonacci with horizontal support, moving average and volume POC`, `Requires at least 5 Fibonacci levels in the same zone`, `Must be on daily timeframe or higher`],
        correct: 1,
      },
      {
        q: `Fibonacci extensions project price targets. Which statement is INCORRECT?`,
        options: [`The 1.272 level is the first impulse target`, `The 1.618 is the 'Golden Extension' used in Elliott Wave`, `The 2.618 marks the maximum retracement before invalidation`, `Extensions measure how far price can travel in the trend direction`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Ktorá je najdôležitejšia úroveň Fibonacciho retracementu a prečo sa nazýva 'Golden Ratio'?`,
        options: [`0.382 pretože je to prvá inštitucionálna úroveň podpory`, `0.5 pretože je to psychologická stredná úroveň pohybu`, `0.618 pretože historicky sa retracementy zvyčajne zastavia blízko tejto úrovne`, `0.786 pretože označuje hranicu medzi silným a slabým trendom`],
        correct: 2,
      },
      {
        q: `Čo robí zónu Fibonacciho konfluencie vysoko pravdepodobnou pre inštitúcie?`,
        options: [`Stačí dotknúť sa presnej 61.8% Fibonacciho úrovne`, `Musí kombinovať Fibonacci s horizontálnou podporou, kĺzavým priemerom a volume POC`, `Vyžaduje aspoň 5 Fibonacciho úrovní v rovnakej zóne`, `Musí byť na dennom timeframe alebo vyššom`],
        correct: 1,
      },
      {
        q: `Fibonacciho extenzie projektujú cenové ciele. Ktoré tvrdenie je NESPRÁVNE?`,
        options: [`Úroveň 1.272 je prvý impulzný cieľ`, `1.618 je 'Golden Extension' používaná v Elliott Wave`, `2.618 označuje maximálny retracement pred invalidáciou`, `Extenzie merajú, ako ďaleko môže cena cestovať v smere trendu`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Was ist das wichtigste Fibonacci-Retracement-Level und warum wird es 'Golden Ratio' genannt?`,
        options: [`0.382, weil es das erste institutionelle Unterstützungslevel ist`, `0.5, weil es das psychologische Mittellevel der Bewegung ist`, `0.618, weil historisch gesehen Retracements in der Nähe dieses Levels stoppen`, `0.786, weil es die Grenze zwischen starkem und schwachem Trend markiert`],
        correct: 2,
      },
      {
        q: `Was macht eine Fibonacci-Konfluenzzone zu einer Zone mit hoher Wahrscheinlichkeit für institutionelle Akteure?`,
        options: [`Sie muss nur ein exaktes Fibonacci-Level von 61.8% berühren`, `Fibonacci muss mit horizontaler Unterstützung, gleitendem Durchschnitt und Volumen-POC zusammenfallen`, `Sie erfordert mindestens 5 Fibonacci-Levels in derselben Zone`, `Sie muss im Tages-Zeitrahmen oder höher liegen`],
        correct: 1,
      },
      {
        q: `Fibonacci-Erweiterungen projizieren Preisziele. Welche Aussage ist FALSCH?`,
        options: [`Das Level 1.272 ist das erste Impulsziel`, `Das 1.618 ist die 'Golden Extension', die in Elliott Wave verwendet wird`, `Das 2.618 markiert das maximale Retracement vor Invalidierung`, `Erweiterungen messen, wie weit der Preis in Trendrichtung reisen kann`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `哪个斐波那契回撤位最重要，为什么被称为"黄金比例"？`,
        options: [`0.382，因为它是第一个机构支撑位`, `0.5，因为它是价格波动的心理中位水平`, `0.618，因为历史上回撤往往在此水平附近停止`, `0.786，因为它标志着强趋势与弱趋势的分界线`],
        correct: 2,
      },
      {
        q: `什么使得斐波那契汇合区对机构而言具有高概率？`,
        options: [`只需触及61.8%的精确斐波那契水平`, `必须是斐波那契与水平支撑位、移动平均线和交易量POC的重合`, `需要至少5个斐波那契水平在同一区域`, `必须在日线或更高时间框架上`],
        correct: 1,
      },
      {
        q: `斐波那契扩展用于预测价格目标。哪个陈述是错误的？`,
        options: [`1.272水平是第一个冲动目标`, `1.618是艾略特波浪理论中使用的"黄金扩展"`, `2.618标志着失效前的最大回撤`, `扩展衡量价格在趋势方向上可以运行多远`],
        correct: 2,
      },
    ],
  },
  L0_10: {
    es: [
      {
        q: `¿Por qué el cerebro humano tiende a vender en mínimos y comprar en máximos?`,
        options: [`Porque evolucionó con respuestas de supervivencia inadecuadas para el trading`, `Porque los traders principiantes carecen de educación financiera formal`, `Porque los mercados están manipulados por instituciones`, `Porque el análisis técnico no funciona en criptomonedas`],
        correct: 0,
      },
      {
        q: `Según el sesgo de aversión a la pérdida, ¿qué relación tiene el dolor de perder con la alegría de ganar?`,
        options: [`Son exactamente iguales en intensidad psicológica`, `El dolor de perder es el doble de intenso que la alegría de ganar`, `La alegría de ganar es tres veces más intensa que el dolor de perder`, `Depende del monto exacto de la pérdida o ganancia`],
        correct: 1,
      },
      {
        q: `¿Cuál afirmación sobre el Revenge Trading es INCORRECTA?`,
        options: [`Ocurre después de una gran pérdida por urgencia de recuperarla`, `Lleva a operar impulsivamente y amplifica el daño`, `Es una estrategia válida si se usa con stop-loss ajustados`, `Es uno de los siete sesgos cognitivos que destruyen traders`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `Why does the human brain tend to sell at lows and buy at highs?`,
        options: [`Because it evolved with survival responses unsuitable for trading`, `Because beginner traders lack formal financial education`, `Because markets are manipulated by institutions`, `Because technical analysis doesn't work in cryptocurrencies`],
        correct: 0,
      },
      {
        q: `According to loss aversion bias, what is the relationship between losing pain and winning pleasure?`,
        options: [`They are exactly equal in psychological intensity`, `The pain of losing is twice as intense as the pleasure of winning`, `The pleasure of winning is three times more intense than losing pain`, `It depends on the exact amount of the loss or gain`],
        correct: 1,
      },
      {
        q: `Which statement about Revenge Trading is INCORRECT?`,
        options: [`It occurs after a large loss from urgency to recover it`, `It leads to impulsive trading and amplifies the damage`, `It is a valid strategy if used with tight stop-losses`, `It is one of the seven cognitive biases that destroy traders`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Prečo ľudský mozog má tendenciu predávať na minimách a kupovať na maximách?`,
        options: [`Pretože sa vyvinul s reakciami prežitia nevhodnými pre trading`, `Pretože začínajúcim traderom chýba formálne finančné vzdelanie`, `Pretože trhy sú manipulované inštitúciami`, `Pretože technická analýza nefunguje v kryptomenách`],
        correct: 0,
      },
      {
        q: `Podľa averzii voči strate, aký je vzťah medzi bolesťou zo straty a radosťou zo zisku?`,
        options: [`Sú presne rovnako intenzívne psychologicky`, `Bolesť zo straty je dvakrát intenzívnejšia ako radosť zo zisku`, `Radosť zo zisku je trikrát intenzívnejšia ako bolesť zo straty`, `Závisí to od presnej výšky straty alebo zisku`],
        correct: 1,
      },
      {
        q: `Ktoré tvrdenie o Revenge Trading je NESPRÁVNE?`,
        options: [`Nastáva po veľkej strate z túžby vrátiť ju späť`, `Vedie k impulzívnemu tradingu a amplifikuje škody`, `Je to platná stratégia ak sa používa s prísnymi stop-lossmi`, `Je to jedno zo siedmich kognitívnych skreslení ničiacich traderov`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Warum neigt das menschliche Gehirn dazu, bei Tiefstständen zu verkaufen und bei Höchstständen zu kaufen?`,
        options: [`Weil es sich mit Überlebensreaktionen entwickelt hat, die für das Trading ungeeignet sind`, `Weil Anfänger-Trader keine formale Finanzbildung haben`, `Weil die Märkte von Institutionen manipuliert werden`, `Weil technische Analyse bei Kryptowährungen nicht funktioniert`],
        correct: 0,
      },
      {
        q: `Laut dem Verlustaversions-Bias, welches Verhältnis besteht zwischen dem Schmerz des Verlierens und der Freude des Gewinnens?`,
        options: [`Sie sind in ihrer psychologischen Intensität genau gleich`, `Der Schmerz des Verlierens ist doppelt so intensiv wie die Freude des Gewinnens`, `Die Freude des Gewinnens ist dreimal intensiver als der Schmerz des Verlierens`, `Es hängt vom genauen Betrag des Verlustes oder Gewinns ab`],
        correct: 1,
      },
      {
        q: `Welche Aussage über Revenge Trading ist FALSCH?`,
        options: [`Es tritt nach einem großen Verlust aufgrund des Drangs auf, ihn zurückzugewinnen`, `Es führt zu impulsivem Handeln und verstärkt den Schaden`, `Es ist eine gültige Strategie, wenn sie mit engen Stop-Loss verwendet wird`, `Es ist einer der sieben kognitiven Verzerrungen, die Trader zerstören`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `为什么人类大脑倾向于在低点卖出、在高点买入?`,
        options: [`因为大脑进化出的生存反应机制不适合交易`, `因为新手交易者缺乏正规的金融教育`, `因为市场被机构操纵`, `因为技术分析在加密货币中不起作用`],
        correct: 0,
      },
      {
        q: `根据损失厌恶偏差,损失的痛苦与获利的喜悦之间是什么关系?`,
        options: [`在心理强度上完全相同`, `损失的痛苦是获利喜悦的两倍强烈`, `获利的喜悦是损失痛苦的三倍强烈`, `取决于损失或获利的具体金额`],
        correct: 1,
      },
      {
        q: `关于复仇交易(Revenge Trading),以下哪项陈述是错误的?`,
        options: [`发生在重大损失后,出于急于挽回损失的冲动`, `导致冲动交易并放大损失`, `如果配合严格的止损使用,是一种有效策略`, `是摧毁交易者的七大认知偏差之一`],
        correct: 2,
      },
    ],
  },
  L1_0: {
    es: [
      {
        q: `¿Qué define estructuralmente una tendencia alcista?`,
        options: [`Una secuencia de Higher Highs (HH) y Higher Lows (HL)`, `Una secuencia de Lower Highs (LH) y Lower Lows (LL)`, `Un Break of Structure seguido de un CHoCH`, `Una secuencia de swing highs con mínimos iguales`],
        correct: 0,
      },
      {
        q: `¿Qué señala un Change of Character (CHoCH) en tendencia alcista?`,
        options: [`Confirmación de que la tendencia alcista continúa con fuerza`, `Ruptura del Higher Low más reciente, primera señal de alerta`, `Creación de un nuevo Higher High por encima del anterior`, `Formación de un rango lateral sin dirección clara`],
        correct: 1,
      },
      {
        q: `¿Cuál es la diferencia clave entre BOS y CHoCH?`,
        options: [`BOS solo ocurre en gráficos de 1 hora o superior`, `CHoCH siempre confirma una reversión total del mercado`, `BOS confirma continuación de tendencia, CHoCH alerta posible reversión`, `CHoCH requiere al menos 5 velas de confirmación adicional`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `What structurally defines an uptrend?`,
        options: [`A sequence of Higher Highs (HH) and Higher Lows (HL)`, `A sequence of Lower Highs (LH) and Lower Lows (LL)`, `A Break of Structure followed by a CHoCH`, `A sequence of swing highs with equal lows`],
        correct: 0,
      },
      {
        q: `What does a Change of Character (CHoCH) signal in an uptrend?`,
        options: [`Confirmation that the uptrend continues with strength`, `Break of the most recent Higher Low, first warning signal`, `Creation of a new Higher High above the previous one`, `Formation of a sideways range with no clear direction`],
        correct: 1,
      },
      {
        q: `What is the key difference between BOS and CHoCH?`,
        options: [`BOS only occurs on 1-hour charts or higher timeframes`, `CHoCH always confirms a full market reversal`, `BOS confirms trend continuation, CHoCH warns of possible reversal`, `CHoCH requires at least 5 additional confirmation candles`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Čo štrukturálne definuje vzostupný trend?`,
        options: [`Postupnosť Higher Highs (HH) a Higher Lows (HL)`, `Postupnosť Lower Highs (LH) a Lower Lows (LL)`, `Break of Structure nasledovaný CHoCH signálom`, `Postupnosť swing highs s rovnakými minimami`],
        correct: 0,
      },
      {
        q: `Čo signalizuje Change of Character (CHoCH) vo vzostupnom trende?`,
        options: [`Potvrdenie, že vzostupný trend pokračuje so silou`, `Prelomenie najnovšieho Higher Low, prvý varovný signál`, `Vytvorenie nového Higher High nad predchádzajúcim`, `Formovanie bočného rozsahu bez jasného smeru`],
        correct: 1,
      },
      {
        q: `Aký je kľúčový rozdiel medzi BOS a CHoCH?`,
        options: [`BOS sa vyskytuje len na 1-hodinových alebo vyšších timeframe`, `CHoCH vždy potvrdzuje úplný trhový zvrat`, `BOS potvrdzuje pokračovanie trendu, CHoCH varuje pred zvratom`, `CHoCH vyžaduje aspoň 5 ďalších potvrdzujúcich sviečok`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Was definiert strukturell einen Aufwärtstrend?`,
        options: [`Eine Sequenz von Higher Highs (HH) und Higher Lows (HL)`, `Eine Sequenz von Lower Highs (LH) und Lower Lows (LL)`, `Ein Break of Structure gefolgt von einem CHoCH`, `Eine Sequenz von Swing Highs mit gleichen Tiefs`],
        correct: 0,
      },
      {
        q: `Was signalisiert ein Change of Character (CHoCH) in einem Aufwärtstrend?`,
        options: [`Bestätigung, dass der Aufwärtstrend stark weitergeht`, `Bruch des jüngsten Higher Low, erstes Warnsignal`, `Bildung eines neuen Higher High über dem vorherigen`, `Bildung einer Seitwärtsrange ohne klare Richtung`],
        correct: 1,
      },
      {
        q: `Was ist der entscheidende Unterschied zwischen BOS und CHoCH?`,
        options: [`BOS tritt nur in Charts ab 1 Stunde oder höher auf`, `CHoCH bestätigt immer eine vollständige Marktumkehr`, `BOS bestätigt Trendfortsetzung, CHoCH warnt vor möglicher Umkehr`, `CHoCH erfordert mindestens 5 zusätzliche Bestätigungskerzen`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `什么在结构上定义了上升趋势？`,
        options: [`一系列更高的高点 (HH) 和更高的低点 (HL)`, `一系列更低的高点 (LH) 和更低的低点 (LL)`, `一个 Break of Structure 后跟一个 CHoCH`, `一系列摆动高点且低点相等`],
        correct: 0,
      },
      {
        q: `在上升趋势中，Change of Character (CHoCH) 表示什么？`,
        options: [`确认上升趋势强劲持续`, `突破最近的 Higher Low，第一个警示信号`, `在前一个高点之上创建新的 Higher High`, `形成没有明确方向的横向盘整区间`],
        correct: 1,
      },
      {
        q: `BOS 和 CHoCH 之间的关键区别是什么？`,
        options: [`BOS 仅发生在 1 小时或更高时间框架的图表上`, `CHoCH 总是确认市场完全反转`, `BOS 确认趋势延续，CHoCH 警示可能反转`, `CHoCH 需要至少 5 根 K 线的额外确认`],
        correct: 2,
      },
    ],
  },
  L1_1: {
    es: [
      {
        q: `¿Qué sucede cuando un soporte se rompe con fuerza según el concepto de Polarity Flip?`,
        options: [`Se convierte en resistencia porque los compradores atrapados venden en ese nivel`, `Desaparece del gráfico y ya no tiene validez técnica`, `Se refuerza como soporte aún más fuerte en el futuro`, `Automáticamente se crea un nuevo soporte justo debajo`],
        correct: 0,
      },
      {
        q: `¿Por qué el retest de un nivel roto ofrece entradas con buen RRR?`,
        options: [`Porque permite comprar en el precio más bajo posible del día`, `Porque el punto de invalidación es claro y el stop puede ser ajustado`, `Porque garantiza que el precio nunca volverá a ese nivel`, `Porque los algoritmos siempre ejecutan órdenes en retests`],
        correct: 1,
      },
      {
        q: `¿Cuál afirmación sobre zonas de confluencia es INCORRECTA?`,
        options: [`Son áreas donde múltiples factores de soporte/resistencia coinciden`, `Cuantos más factores coinciden, mayor la probabilidad de reacción significativa`, `Un solo nivel horizontal fuerte siempre supera a una confluencia`, `Las instituciones buscan zonas de confluencia para sus grandes trades`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `What happens when support breaks with force according to the Polarity Flip concept?`,
        options: [`It becomes resistance because trapped buyers sell at that level`, `It disappears from the chart and loses technical validity`, `It strengthens as an even stronger support in the future`, `A new support automatically forms just below it`],
        correct: 0,
      },
      {
        q: `Why does a broken level retest offer entries with good RRR?`,
        options: [`Because it allows buying at the day's lowest possible price`, `Because the invalidation point is clear and stop can be tight`, `Because it guarantees price will never return to that level`, `Because algorithms always execute orders on retests`],
        correct: 1,
      },
      {
        q: `Which statement about confluence zones is INCORRECT?`,
        options: [`They are areas where multiple support/resistance factors coincide`, `The more factors coinciding, the higher the probability of significant reaction`, `A single strong horizontal level always outperforms a confluence zone`, `Institutions seek confluence zones for their large trades`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Čo sa stane, keď sa podpora prelomí so silou podľa konceptu Polarity Flip?`,
        options: [`Stáva sa rezistenciou, pretože zachytení kupujúci predávajú na tejto úrovni`, `Zmizne z grafu a stratí technickú platnosť`, `Posilní sa ako ešte silnejšia podpora v budúcnosti`, `Automaticky sa vytvorí nová podpora tesne pod ňou`],
        correct: 0,
      },
      {
        q: `Prečo retest prelomenej úrovne ponúka vstupy s dobrým RRR?`,
        options: [`Pretože umožňuje nákup za najnižšiu možnú cenu dňa`, `Pretože bod invalidácie je jasný a stop môže byť tesný`, `Pretože garantuje, že sa cena už nikdy nevráti k tej úrovni`, `Pretože algoritmy vždy vykonávajú príkazy pri retestoch`],
        correct: 1,
      },
      {
        q: `Ktoré tvrdenie o zónach konfluencie je NESPRÁVNE?`,
        options: [`Sú to oblasti, kde splýva viacero faktorov podpory/rezistencie`, `Čím viac faktorov splýva, tým vyššia pravdepodobnosť významnej reakcie`, `Jediná silná horizontálna úroveň vždy prekoná zónu konfluencie`, `Inštitúcie hľadajú zóny konfluencie pre svoje veľké obchody`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Was passiert, wenn eine Unterstützung mit Kraft durchbrochen wird, gemäß dem Konzept des Polarity Flip?`,
        options: [`Sie wird zum Widerstand, weil gefangene Käufer auf diesem Niveau verkaufen`, `Sie verschwindet aus dem Chart und hat keine technische Gültigkeit mehr`, `Sie verstärkt sich als noch stärkere Unterstützung in der Zukunft`, `Automatisch entsteht eine neue Unterstützung direkt darunter`],
        correct: 0,
      },
      {
        q: `Warum bietet der Retest eines durchbrochenen Niveaus Einstiege mit gutem RRR?`,
        options: [`Weil man zum niedrigstmöglichen Preis des Tages kaufen kann`, `Weil der Invalidierungspunkt klar ist und der Stop angepasst werden kann`, `Weil garantiert ist, dass der Preis nie wieder zu diesem Niveau zurückkehrt`, `Weil Algorithmen immer Orders bei Retests ausführen`],
        correct: 1,
      },
      {
        q: `Welche Aussage über Konfluenzzonen ist FALSCH?`,
        options: [`Es sind Bereiche, in denen mehrere Unterstützungs-/Widerstandsfaktoren zusammentreffen`, `Je mehr Faktoren zusammentreffen, desto höher die Wahrscheinlichkeit einer signifikanten Reaktion`, `Ein einzelnes starkes horizontales Niveau übertrifft immer eine Konfluenz`, `Institutionen suchen Konfluenzzonen für ihre großen Trades`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `根据极性翻转（Polarity Flip）概念，当支撑位被强力突破时会发生什么？`,
        options: [`它会转变为阻力位，因为被套牢的买家会在该水平卖出`, `它会从图表上消失，不再具有技术有效性`, `它会在未来作为更强的支撑位得到加强`, `会自动在正下方创建一个新的支撑位`],
        correct: 0,
      },
      {
        q: `为什么回测突破水平能提供良好风险回报比的入场机会？`,
        options: [`因为它允许以当天最低价格买入`, `因为失效点明确，止损可以精确设置`, `因为它保证价格永远不会回到该水平`, `因为算法总是在回测时执行订单`],
        correct: 1,
      },
      {
        q: `关于汇合区域，以下哪项陈述是错误的？`,
        options: [`它们是多个支撑位/阻力位因素重合的区域`, `重合的因素越多，发生重大反应的概率越高`, `单一强劲的水平位总是优于汇合区域`, `机构会寻找汇合区域来进行大额交易`],
        correct: 2,
      },
    ],
  },
  L1_2: {
    es: [
      {
        q: `¿Qué porcentaje de tiempo pasan los mercados aproximadamente en rango lateral?`,
        options: [`30-40% del tiempo`, `50% del tiempo`, `60-70% del tiempo`, `80% del tiempo`],
        correct: 2,
      },
      {
        q: `¿Qué indica un ADX por debajo de 20?`,
        options: [`Tendencia alcista fuerte`, `Mercado en rango lateral`, `Tendencia bajista confirmada`, `Ruptura de canal inminente`],
        correct: 1,
      },
      {
        q: `¿Cuántos toques mínimos se requieren para validar una trendline profesional?`,
        options: [`2 toques son suficientes`, `Al menos 5 toques`, `Al menos 3 toques`, `Solo 1 toque en timeframe alto`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `What percentage of time do markets approximately spend in sideways ranges?`,
        options: [`30-40% of the time`, `50% of the time`, `60-70% of the time`, `80% of the time`],
        correct: 2,
      },
      {
        q: `What does an ADX below 20 indicate?`,
        options: [`Strong uptrend`, `Ranging market`, `Confirmed downtrend`, `Imminent channel breakout`],
        correct: 1,
      },
      {
        q: `How many minimum touches are required to validate a professional trendline?`,
        options: [`2 touches are sufficient`, `At least 5 touches`, `At least 3 touches`, `Only 1 touch on high timeframe`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Aké percento času trávia trhy približne v bočnom rozsahu?`,
        options: [`30-40% času`, `50% času`, `60-70% času`, `80% času`],
        correct: 2,
      },
      {
        q: `Čo signalizuje ADX pod 20?`,
        options: [`Silný rastúci trend`, `Bočný trh`, `Potvrdený klesajúci trend`, `Blížiace sa prelomenie kanála`],
        correct: 1,
      },
      {
        q: `Koľko minimálnych dotykov sa vyžaduje na validáciu profesionálnej trendovej línie?`,
        options: [`2 dotyky sú dostačujúce`, `Aspoň 5 dotykov`, `Aspoň 3 dotyky`, `Len 1 dotyk na vysokom timeframe`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Wie viel Prozent der Zeit verbringen die Märkte ungefähr in seitlicher Range?`,
        options: [`30-40% der Zeit`, `50% der Zeit`, `60-70% der Zeit`, `80% der Zeit`],
        correct: 2,
      },
      {
        q: `Was zeigt ein ADX unter 20 an?`,
        options: [`Starker Aufwärtstrend`, `Markt in seitlicher Range`, `Bestätigter Abwärtstrend`, `Unmittelbar bevorstehender Kanalausbruch`],
        correct: 1,
      },
      {
        q: `Wie viele Berührungen sind mindestens erforderlich, um eine professionelle Trendline zu validieren?`,
        options: [`2 Berührungen sind ausreichend`, `Mindestens 5 Berührungen`, `Mindestens 3 Berührungen`, `Nur 1 Berührung im hohen Timeframe`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `市场大约有多少时间处于横盘整理状态？`,
        options: [`30-40%的时间`, `50%的时间`, `60-70%的时间`, `80%的时间`],
        correct: 2,
      },
      {
        q: `ADX低于20表示什么？`,
        options: [`强劲上涨趋势`, `市场处于盘整区间`, `确认下跌趋势`, `通道突破即将发生`],
        correct: 1,
      },
      {
        q: `验证专业趋势线至少需要多少个触点？`,
        options: [`2个触点就足够了`, `至少5个触点`, `至少3个触点`, `在高时间框架上只需1个触点`],
        correct: 2,
      },
    ],
  },
  L1_3: {
    es: [
      {
        q: `¿Qué confirma la reversión bajista en el patrón Hombro-Cabeza-Hombro?`,
        options: [`La ruptura del neckline hacia abajo`, `El máximo de la cabeza superando ambos hombros`, `El volumen en el segundo hombro duplicándose`, `La resistencia horizontal entre los dos hombros`],
        correct: 0,
      },
      {
        q: `Un Triángulo Ascendente con resistencia horizontal y mínimos crecientes señala:`,
        options: [`Patrón de reversión bajista inminente`, `Ruptura alcista probable, patrón de continuación`, `Consolidación sin dirección definida del precio`, `Señal de fallo de patrón y cambio de tendencia`],
        correct: 1,
      },
      {
        q: `¿Cuál de estas afirmaciones sobre Cuñas es INCORRECTA?`,
        options: [`Ambas líneas de tendencia se inclinan en el mismo sentido`, `La cuña ascendente es señal bajista con ruptura violenta a la baja`, `La cuña descendente es señal bajista y ruptura esperada hacia abajo`, `Las cuñas son tipos de triángulos con ambas líneas inclinadas`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `What confirms the bearish reversal in the Head and Shoulders pattern?`,
        options: [`The downward breakout of the neckline`, `The head's peak exceeding both shoulders`, `Volume doubling on the second shoulder formation`, `Horizontal resistance between the two shoulders`],
        correct: 0,
      },
      {
        q: `An Ascending Triangle with horizontal resistance and rising lows signals:`,
        options: [`Imminent bearish reversal pattern forming`, `Probable bullish breakout, continuation pattern`, `Consolidation with no defined price direction`, `Pattern failure signal and trend change ahead`],
        correct: 1,
      },
      {
        q: `Which statement about Wedges is INCORRECT?`,
        options: [`Both trendlines slope in the same direction`, `Rising wedge is bearish with violent downside breakout`, `Falling wedge is bearish with expected downward breakout`, `Wedges are triangle types with both lines sloping`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Čo potvrdzuje medvediu reverziu vo formácii Hlava a ramená?`,
        options: [`Prelom neckline smerom nadol`, `Vrchol hlavy prevyšujúci obe ramená`, `Objem na druhom ramene zdvojnásobený`, `Horizontálny odpor medzi dvoma ramenami`],
        correct: 0,
      },
      {
        q: `Stúpajúci trojuholník s horizontálnym odporom a rastúcimi minimami signalizuje:`,
        options: [`Blížiacu sa medvediu reverznú formáciu`, `Pravdepodobný býčí prelom, pokračovacia formácia`, `Konsolidáciu bez definovaného smeru ceny`, `Signál zlyhania formácie a zmenu trendu`],
        correct: 1,
      },
      {
        q: `Ktoré tvrdenie o Klinoch je NESPRÁVNE?`,
        options: [`Obe trendové línie sú naklonené v rovnakom smere`, `Stúpajúci klin je medvedí s násilným prelomom nadol`, `Klesajúci klin je medvedí s očakávaným prelomom nadol`, `Kliny sú typy trojuholníkov s oboma naklonenými líniami`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Was bestätigt die bärische Umkehr beim SKS-Formation?`,
        options: [`Der Durchbruch der Nackenlinie nach unten`, `Das Maximum des Kopfes übersteigt beide Schultern`, `Das Volumen bei der zweiten Schulter verdoppelt sich`, `Der horizontale Widerstand zwischen den beiden Schultern`],
        correct: 0,
      },
      {
        q: `Ein aufsteigendes Dreieck mit horizontalem Widerstand und steigenden Tiefs signalisiert:`,
        options: [`Unmittelbar bevorstehendes bärisches Umkehrmuster`, `Wahrscheinlicher bullischer Ausbruch, Fortsetzungsmuster`, `Konsolidierung ohne definierte Preisrichtung`, `Signal für Musterversagen und Trendwechsel`],
        correct: 1,
      },
      {
        q: `Welche dieser Aussagen über Keile ist FALSCH?`,
        options: [`Beide Trendlinien neigen sich in dieselbe Richtung`, `Der aufsteigende Keil ist ein bärisches Signal mit gewaltsamen Ausbruch nach unten`, `Der absteigende Keil ist ein bärisches Signal und erwarteter Ausbruch nach unten`, `Keile sind Dreiecksarten mit beiden geneigten Linien`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `头肩顶形态中什么确认了看跌反转？`,
        options: [`向下突破颈线`, `头部的最高点超过两个肩部`, `第二个肩部的成交量翻倍`, `两个肩部之间的水平阻力位`],
        correct: 0,
      },
      {
        q: `具有水平阻力位和上升低点的上升三角形表示：`,
        options: [`即将出现看跌反转形态`, `可能向上突破，延续形态`, `价格没有明确方向的盘整`, `形态失败和趋势变化的信号`],
        correct: 1,
      },
      {
        q: `关于楔形，以下哪项陈述是错误的？`,
        options: [`两条趋势线都朝同一方向倾斜`, `上升楔形是看跌信号，会出现剧烈向下突破`, `下降楔形是看跌信号，预期向下突破`, `楔形是两条线都倾斜的三角形类型`],
        correct: 2,
      },
    ],
  },
  L1_4: {
    es: [
      {
        q: `¿Por qué el volumen es más confiable que el precio según la lección?`,
        options: [`Porque el volumen requiere participación real de muchos actores`, `Porque el volumen siempre predice el futuro del precio`, `Porque el precio nunca puede ser manipulado`, `Porque el volumen es más fácil de calcular`],
        correct: 0,
      },
      {
        q: `Un precio sube con volumen decreciente. ¿Qué señala esta divergencia precio-volumen?`,
        options: [`Fortaleza alcista y continuación probable del rally`, `Debilidad alcista y posible reversión pronta`, `Fortaleza bajista y caída inminente garantizada`, `Neutral, no aporta información relevante`],
        correct: 1,
      },
      {
        q: `¿Qué representa el Point of Control (POC) en Volume Profile?`,
        options: [`El precio más alto alcanzado en el período`, `El nivel donde se negoció el mayor volumen`, `La zona donde ocurrió el 70% del volumen total`, `El área de bajo volumen con poco interés institucional`],
        correct: 1,
      },
    ],
    en: [
      {
        q: `Why is volume more reliable than price according to the lesson?`,
        options: [`Because volume requires real participation from many actors`, `Because volume always predicts the future price`, `Because price can never be manipulated`, `Because volume is easier to calculate`],
        correct: 0,
      },
      {
        q: `Price rises with decreasing volume. What does this price-volume divergence signal?`,
        options: [`Bullish strength and probable rally continuation`, `Bullish weakness and possible reversal soon`, `Bearish strength and imminent drop guaranteed`, `Neutral, provides no relevant information`],
        correct: 1,
      },
      {
        q: `What does the Point of Control (POC) represent in Volume Profile?`,
        options: [`The highest price reached in the period`, `The level where the highest volume was traded`, `The zone where 70% of total volume occurred`, `The low volume area with little institutional interest`],
        correct: 1,
      },
    ],
    sk: [
      {
        q: `Prečo je objem spoľahlivejší ako cena podľa lekcie?`,
        options: [`Pretože objem vyžaduje skutočnú účasť mnohých aktérov`, `Pretože objem vždy predpovedá budúcu cenu`, `Pretože cena nikdy nemôže byť manipulovaná`, `Pretože objem je jednoduchšie vypočítať`],
        correct: 0,
      },
      {
        q: `Cena rastie s klesajúcim objemom. Čo signalizuje táto divergencia cena-objem?`,
        options: [`Býčiu silu a pravdepodobnú pokračovanie rally`, `Býčiu slabosť a možný skorý obrat`, `Medvediu silu a zaručený okamžitý pokles`, `Neutrálne, neposkytuje relevantnú informáciu`],
        correct: 1,
      },
      {
        q: `Čo predstavuje Point of Control (POC) vo Volume Profile?`,
        options: [`Najvyššiu cenu dosiahnutú v období`, `Úroveň, kde sa obchodoval najväčší objem`, `Zónu, kde došlo k 70% celkového objemu`, `Oblasť nízkeho objemu s malým inštitucionálnym záujmom`],
        correct: 1,
      },
    ],
    de: [
      {
        q: `Warum ist das Volumen laut der Lektion zuverlässiger als der Preis?`,
        options: [`Weil das Volumen echte Beteiligung vieler Akteure erfordert`, `Weil das Volumen immer die Zukunft des Preises vorhersagt`, `Weil der Preis niemals manipuliert werden kann`, `Weil das Volumen einfacher zu berechnen ist`],
        correct: 0,
      },
      {
        q: `Ein Preis steigt bei abnehmendem Volumen. Was signalisiert diese Preis-Volumen-Divergenz?`,
        options: [`Bullische Stärke und wahrscheinliche Fortsetzung der Rally`, `Bullische Schwäche und mögliche baldige Umkehr`, `Bärische Stärke und garantierter bevorstehender Fall`, `Neutral, liefert keine relevanten Informationen`],
        correct: 1,
      },
      {
        q: `Was repräsentiert der Point of Control (POC) im Volume Profile?`,
        options: [`Der höchste im Zeitraum erreichte Preis`, `Das Niveau, auf dem das größte Volumen gehandelt wurde`, `Die Zone, in der 70% des Gesamtvolumens stattfand`, `Der Bereich mit geringem Volumen und wenig institutionellem Interesse`],
        correct: 1,
      },
    ],
    "zh-CN": [
      {
        q: `根据本课，为什么成交量比价格更可靠？`,
        options: [`因为成交量需要众多参与者的真实参与`, `因为成交量总是能预测价格的未来`, `因为价格永远不会被操纵`, `因为成交量更容易计算`],
        correct: 0,
      },
      {
        q: `价格上涨但成交量递减。这种价量背离预示着什么？`,
        options: [`看涨力量强劲，上涨行情可能持续`, `看涨力量疲弱，可能即将反转`, `看跌力量强劲，保证即将下跌`, `中性，不提供相关信息`],
        correct: 1,
      },
      {
        q: `Volume Profile中的Point of Control (POC)代表什么？`,
        options: [`该时期内达到的最高价格`, `成交量最大的价格水平`, `发生70%总成交量的区域`, `机构兴趣较低的低成交量区域`],
        correct: 1,
      },
    ],
  },
  L1_5: {
    es: [
      {
        q: `¿Cuál es la jerarquía correcta de timeframes para trading de criptomonedas según la lección?`,
        options: [`Semanal → Diario → 4H → 1H → 15M`, `Diario → Semanal → 1H → 4H → 15M`, `15M → 1H → 4H → Diario → Semanal`, `4H → Diario → Semanal → 1H → 15M`],
        correct: 0,
      },
      {
        q: `En un trade perfecto MTF, ¿qué confirma el timeframe de 1H?`,
        options: [`La tendencia alcista establecida con HH y HL claros`, `CHoCH alcista que confirma reanudación del impulso diario`, `Formación de estructura de acumulación en soporte`, `La entrada precisa con stop bajo el mínimo del swing`],
        correct: 1,
      },
      {
        q: `¿Cuál afirmación sobre alineación de timeframes es INCORRECTA?`,
        options: [`Cuando tres TFs están alineados la probabilidad aumenta significativamente`, `Si dos de tres TFs están en contra, es mejor esperar`, `Empezar análisis en TF menor y subir evita sesgo por ruido`, `La alineación ocurre cuando múltiples TFs indican misma dirección`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `What is the correct timeframe hierarchy for crypto trading according to the lesson?`,
        options: [`Weekly → Daily → 4H → 1H → 15M`, `Daily → Weekly → 1H → 4H → 15M`, `15M → 1H → 4H → Daily → Weekly`, `4H → Daily → Weekly → 1H → 15M`],
        correct: 0,
      },
      {
        q: `In a perfect MTF trade, what does the 1H timeframe confirm?`,
        options: [`The established uptrend with clear HH and HL`, `Bullish CHoCH confirming daily impulse resumes`, `Accumulation structure formation at support`, `Precise entry with stop below swing low`],
        correct: 1,
      },
      {
        q: `Which statement about timeframe alignment is INCORRECT?`,
        options: [`When three TFs align, probability increases significantly`, `If two of three TFs are against you, better wait`, `Starting analysis on lower TF and working up avoids noise bias`, `Alignment occurs when multiple TFs indicate same direction`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Aká je správna hierarchia timeframe-ov pre krypto trading podľa lekcie?`,
        options: [`Týždenný → Denný → 4H → 1H → 15M`, `Denný → Týždenný → 1H → 4H → 15M`, `15M → 1H → 4H → Denný → Týždenný`, `4H → Denný → Týždenný → 1H → 15M`],
        correct: 0,
      },
      {
        q: `V perfektnom MTF trade, čo potvrdzuje timeframe 1H?`,
        options: [`Etablovaný uptrend s jasnými HH a HL`, `Bullish CHoCH potvrdzujúci pokračovanie denného impulzu`, `Formovanie akumulačnej štruktúry na podpore`, `Presný vstup so stopom pod swing low`],
        correct: 1,
      },
      {
        q: `Ktoré tvrdenie o zarovnaní timeframe-ov je NESPRÁVNE?`,
        options: [`Keď sú tri TF zarovnané, pravdepodobnosť sa výrazne zvyšuje`, `Ak sú dva z troch TF proti vám, lepšie počkať`, `Začatie analýzy na nižšom TF a postupovanie hore vyhýba sa šumu`, `Zarovnanie nastáva, keď viacero TF indikuje rovnaký smer`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Was ist die korrekte Hierarchie der Timeframes für Krypto-Trading laut der Lektion?`,
        options: [`Wöchentlich → Täglich → 4H → 1H → 15M`, `Täglich → Wöchentlich → 1H → 4H → 15M`, `15M → 1H → 4H → Täglich → Wöchentlich`, `4H → Täglich → Wöchentlich → 1H → 15M`],
        correct: 0,
      },
      {
        q: `Was bestätigt der 1H-Timeframe in einem perfekten MTF-Trade?`,
        options: [`Der etablierte bullische Trend mit klaren HH und HL`, `Bullischer CHoCH, der die Wiederaufnahme des täglichen Impulses bestätigt`, `Bildung einer Akkumulationsstruktur bei Unterstützung`, `Der präzise Einstieg mit Stop unter dem Swing-Tief`],
        correct: 1,
      },
      {
        q: `Welche Aussage über Timeframe-Ausrichtung ist FALSCH?`,
        options: [`Wenn drei TFs ausgerichtet sind, steigt die Wahrscheinlichkeit erheblich`, `Wenn zwei von drei TFs dagegen sind, ist es besser zu warten`, `Die Analyse im kleineren TF zu beginnen und aufzusteigen vermeidet Verzerrung durch Rauschen`, `Ausrichtung tritt auf, wenn mehrere TFs dieselbe Richtung anzeigen`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `根据本课，加密货币交易的正确时间周期层级是什么？`,
        options: [`周线 → 日线 → 4H → 1H → 15M`, `日线 → 周线 → 1H → 4H → 15M`, `15M → 1H → 4H → 日线 → 周线`, `4H → 日线 → 周线 → 1H → 15M`],
        correct: 0,
      },
      {
        q: `在完美的MTF交易中，1H时间周期确认什么？`,
        options: [`已确立的看涨趋势，具有明确的HH和HL`, `看涨CHoCH，确认日线动能恢复`, `在支撑位形成积累结构`, `精确入场点，止损设在摆动低点下方`],
        correct: 1,
      },
      {
        q: `关于时间周期对齐，哪个说法是错误的？`,
        options: [`当三个TF对齐时，概率显著提高`, `如果三个TF中有两个相反，最好等待`, `从较小TF开始分析并向上推进可避免噪音偏差`, `当多个TF指向同一方向时发生对齐`],
        correct: 2,
      },
    ],
  },
  L1_6: {
    es: [
      {
        q: `¿Qué representa el Composite Man en el método Wyckoff?`,
        options: [`La acción colectiva del dinero inteligente que mueve el mercado`, `Un trader individual que opera contra las instituciones`, `El volumen promedio del mercado en una sesión`, `La suma de todos los inversores minoristas activos`],
        correct: 0,
      },
      {
        q: `¿Cuál es el propósito principal del Spring en la Fase C de acumulación?`,
        options: [`Confirmar la resistencia del rango establecido`, `Incrementar el volumen para atraer compradores minoristas`, `Liquidar los últimos stop losses antes de reversión alcista`, `Marcar el final definitivo de la fase de distribución`],
        correct: 2,
      },
      {
        q: `Durante el Selling Climax (SC), ¿qué están haciendo realmente las instituciones?`,
        options: [`Vendiendo masivamente por pánico antes del colapso final`, `Observando sin participar hasta que el volumen normalice`, `Acumulando posiciones mientras minoristas capitulando venden`, `Distribuyendo sus posiciones a otros institucionales grandes`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `What does the Composite Man represent in the Wyckoff method?`,
        options: [`The collective action of smart money that moves the market`, `An individual trader operating against institutions`, `The average market volume in a trading session`, `The sum of all active retail investors`],
        correct: 0,
      },
      {
        q: `What is the primary purpose of the Spring in accumulation Phase C?`,
        options: [`To confirm the resistance of the established range`, `To increase volume to attract retail buyers`, `To liquidate the last stop losses before bullish reversal`, `To mark the definitive end of the distribution phase`],
        correct: 2,
      },
      {
        q: `During the Selling Climax (SC), what are institutions actually doing?`,
        options: [`Panic selling massively before the final collapse`, `Observing without participating until volume normalizes`, `Accumulating positions while capitulating retail sells`, `Distributing their positions to other large institutions`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Čo reprezentuje Composite Man vo Wyckoffovej metóde?`,
        options: [`Kolektívne konanie smart money, ktoré hýbe trhom`, `Individuálneho tradera obchodujúceho proti inštitúciám`, `Priemerný objem trhu počas obchodnej relácie`, `Súčet všetkých aktívnych retailových investorov`],
        correct: 0,
      },
      {
        q: `Aký je hlavný účel Spring vo fáze C akumulácie?`,
        options: [`Potvrdiť odpor stanoveného rozpätia`, `Zvýšiť objem pre pritiahnutie retailových kupujúcich`, `Zlikvidovať posledné stop lossy pred bullovským otočením`, `Označiť definitívny koniec distribučnej fázy`],
        correct: 2,
      },
      {
        q: `Počas Selling Climax (SC), čo inštitúcie skutočne robia?`,
        options: [`Panicky masívne predávajú pred finálnym kolapsom`, `Pozorujú bez účasti, kým sa objem nenormalizuje`, `Akumulujú pozície, zatiaľ čo kapitulujúci retail predáva`, `Distribuujú svoje pozície iným veľkým inštitúciám`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Was repräsentiert der Composite Man in der Wyckoff-Methode?`,
        options: [`Die kollektive Aktion des Smart Money, das den Markt bewegt`, `Ein einzelner Trader, der gegen die Institutionen handelt`, `Das durchschnittliche Marktvolumen in einer Sitzung`, `Die Summe aller aktiven Kleinanleger`],
        correct: 0,
      },
      {
        q: `Was ist der Hauptzweck des Spring in Phase C der Akkumulation?`,
        options: [`Den Widerstand der etablierten Range zu bestätigen`, `Das Volumen zu erhöhen, um Kleinanleger-Käufer anzuziehen`, `Die letzten Stop Losses vor bullischer Umkehr zu liquidieren`, `Das definitive Ende der Distributionsphase zu markieren`],
        correct: 2,
      },
      {
        q: `Was tun die Institutionen während des Selling Climax (SC) wirklich?`,
        options: [`Massiv aus Panik vor dem finalen Kollaps verkaufen`, `Beobachten ohne Teilnahme, bis sich das Volumen normalisiert`, `Positionen akkumulieren, während kapitulierende Kleinanleger verkaufen`, `Ihre Positionen an andere große Institutionen verteilen`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `Wyckoff方法中的Composite Man代表什么？`,
        options: [`推动市场的聪明资金的集体行为`, `与机构对抗操作的个人交易者`, `市场在一个交易时段的平均成交量`, `所有活跃散户投资者的总和`],
        correct: 0,
      },
      {
        q: `积累阶段C期的Spring主要目的是什么？`,
        options: [`确认已建立盘整区间的阻力位`, `增加成交量以吸引散户买家`, `在看涨反转前清除最后的止损单`, `标志分配阶段的最终结束`],
        correct: 2,
      },
      {
        q: `在Selling Climax (SC)期间，机构实际在做什么？`,
        options: [`在最终崩盘前因恐慌大量抛售`, `观望不参与，直到成交量正常化`, `在恐慌性抛售的散户手中积累仓位`, `向其他大型机构分配他们的仓位`],
        correct: 2,
      },
    ],
  },
  L1_7: {
    es: [
      {
        q: `¿Cuál es la regla que NUNCA puede violarse en la onda 3 de Elliott?`,
        options: [`La onda 3 nunca puede ser la más corta de las ondas de impulso`, `La onda 3 siempre debe ser exactamente 1.618 × onda 1`, `La onda 3 debe durar más tiempo que las otras ondas`, `La onda 3 nunca puede retroceder más del 50%`],
        correct: 0,
      },
      {
        q: `Si entras en la corrección de onda 2, ¿qué rango de retroceso Fibonacci ofrece mayor probabilidad?`,
        options: [`23.6% - 38.2% de la onda 1`, `50% - 61.8% de la onda 1`, `78.6% - 100% de la onda 1`, `161.8% - 261.8% de la onda 1`],
        correct: 1,
      },
      {
        q: `¿Qué afirmación sobre las ondas correctivas A-B-C es INCORRECTA?`,
        options: [`La onda A es bajista, B alcista, C bajista final`, `La onda C suele llegar al rango de la onda 4 anterior`, `La onda B siempre supera el máximo de la onda 5 previa`, `La onda B es una trampa alcista dentro de la corrección`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `Which rule can NEVER be violated regarding Elliott wave 3?`,
        options: [`Wave 3 can never be the shortest of the impulse waves`, `Wave 3 must always be exactly 1.618 × wave 1`, `Wave 3 must take longer in time than other waves`, `Wave 3 can never retrace more than 50%`],
        correct: 0,
      },
      {
        q: `If entering on wave 2 correction, which Fibonacci retracement range offers highest probability?`,
        options: [`23.6% - 38.2% of wave 1`, `50% - 61.8% of wave 1`, `78.6% - 100% of wave 1`, `161.8% - 261.8% of wave 1`],
        correct: 1,
      },
      {
        q: `Which statement about corrective A-B-C waves is INCORRECT?`,
        options: [`Wave A is bearish, B bullish, C final bearish`, `Wave C usually reaches the range of the previous wave 4`, `Wave B always exceeds the high of the previous wave 5`, `Wave B is a bullish trap within the correction`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Ktoré pravidlo NIKDY nemožno porušiť ohľadom Elliottovej vlny 3?`,
        options: [`Vlna 3 nikdy nemôže byť najkratšia z impulzných vĺn`, `Vlna 3 musí byť vždy presne 1,618 × vlna 1`, `Vlna 3 musí trvať dlhšie ako ostatné vlny`, `Vlna 3 nikdy nemôže prekresliť viac ako 50%`],
        correct: 0,
      },
      {
        q: `Pri vstupe do korekcie vlny 2, ktorý Fibonacci rozsah ponúka najvyššiu pravdepodobnosť?`,
        options: [`23,6% - 38,2% vlny 1`, `50% - 61,8% vlny 1`, `78,6% - 100% vlny 1`, `161,8% - 261,8% vlny 1`],
        correct: 1,
      },
      {
        q: `Ktoré tvrdenie o korekčných vlnách A-B-C je NESPRÁVNE?`,
        options: [`Vlna A je medvedia, B býčia, C finálna medvedia`, `Vlna C zvyčajne dosiahne rozsah predchádzajúcej vlny 4`, `Vlna B vždy prekročí maximum predchádzajúcej vlny 5`, `Vlna B je býčia pasca v rámci korekcie`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Welche Regel darf bei Welle 3 von Elliott NIEMALS verletzt werden?`,
        options: [`Welle 3 darf niemals die kürzeste der Impulswellen sein`, `Welle 3 muss immer genau 1.618 × Welle 1 sein`, `Welle 3 muss länger dauern als die anderen Wellen`, `Welle 3 darf niemals mehr als 50% zurückverfolgen`],
        correct: 0,
      },
      {
        q: `Wenn du in die Korrektur von Welle 2 einsteigst, welcher Fibonacci-Retracement-Bereich bietet die höchste Wahrscheinlichkeit?`,
        options: [`23,6% - 38,2% von Welle 1`, `50% - 61,8% von Welle 1`, `78,6% - 100% von Welle 1`, `161,8% - 261,8% von Welle 1`],
        correct: 1,
      },
      {
        q: `Welche Aussage über die Korrekturwellen A-B-C ist FALSCH?`,
        options: [`Welle A ist bärisch, B bullisch, C abschließend bärisch`, `Welle C erreicht normalerweise den Bereich der vorherigen Welle 4`, `Welle B übertrifft immer das Maximum der vorherigen Welle 5`, `Welle B ist eine bullische Falle innerhalb der Korrektur`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `艾略特波浪理论中，第3浪绝对不能违反的规则是什么？`,
        options: [`第3浪永远不能是推动浪中最短的一浪`, `第3浪必须恰好是第1浪的1.618倍`, `第3浪的持续时间必须比其他浪更长`, `第3浪的回撤永远不能超过50%`],
        correct: 0,
      },
      {
        q: `如果在第2浪回调时入场，哪个斐波那契回撤区间提供更高概率？`,
        options: [`第1浪的23.6% - 38.2%`, `第1浪的50% - 61.8%`, `第1浪的78.6% - 100%`, `第1浪的161.8% - 261.8%`],
        correct: 1,
      },
      {
        q: `关于A-B-C调整浪，以下哪个说法是错误的？`,
        options: [`A浪看跌，B浪看涨，C浪最终看跌`, `C浪通常会到达前一个第4浪的区间`, `B浪总是会超过前一个第5浪的高点`, `B浪是调整中的看涨陷阱`],
        correct: 2,
      },
    ],
  },
  L1_8: {
    es: [
      {
        q: `¿Cuál es la principal ventaja del swing trading en cripto frente al scalping?`,
        options: [`Permite capturar movimientos amplios sin monitorización constante`, `Genera más ganancias diarias garantizadas`, `Elimina completamente el riesgo de volatilidad`, `Requiere menos capital inicial que el day trading`],
        correct: 0,
      },
      {
        q: `En una tendencia alcista establecida, ¿dónde debe colocarse el stop loss al comprar un HL?`,
        options: [`Justo encima del último HH registrado`, `Debajo del Higher Low identificado`, `En el nivel Fibonacci 61.8% del impulso`, `Exactamente en la EMA50 del gráfico diario`],
        correct: 1,
      },
      {
        q: `¿Qué requiere un setup de swing de alta probabilidad según la lección?`,
        options: [`Sesgo diario claro, nivel relevante, señal 4H/1H, volumen, RRR mínimo 1:3`, `Únicamente análisis de volumen y correlación con Bitcoin`, `Tres indicadores técnicos confirmando simultáneamente`, `Sesgo horario, cualquier soporte, y ejecución inmediata`],
        correct: 0,
      },
    ],
    en: [
      {
        q: `What is the main advantage of swing trading crypto over scalping?`,
        options: [`It captures large moves without constant monitoring`, `It generates more guaranteed daily profits`, `It completely eliminates volatility risk`, `It requires less initial capital than day trading`],
        correct: 0,
      },
      {
        q: `In an established uptrend, where should the stop loss be placed when buying an HL?`,
        options: [`Just above the last recorded HH`, `Below the identified Higher Low`, `At the Fibonacci 61.8% level of the impulse`, `Exactly at the daily chart EMA50`],
        correct: 1,
      },
      {
        q: `What does a high-probability swing setup require according to the lesson?`,
        options: [`Clear daily bias, relevant level, 4H/1H signal, volume, minimum 1:3 RRR`, `Only volume analysis and correlation with Bitcoin`, `Three technical indicators confirming simultaneously`, `Hourly bias, any support, and immediate execution`],
        correct: 0,
      },
    ],
    sk: [
      {
        q: `Aká je hlavná výhoda swing tradingu v krypto oproti scalpingu?`,
        options: [`Zachytáva veľké pohyby bez neustáleho monitorovania`, `Generuje viac garantovaných denných ziskov`, `Úplne eliminuje riziko volatility`, `Vyžaduje menej počiatočného kapitálu ako day trading`],
        correct: 0,
      },
      {
        q: `V etablovanom rastúcom trende, kde by mal byť umiestnený stop loss pri kúpe HL?`,
        options: [`Tesne nad posledným zaznamenaným HH`, `Pod identifikovaným Higher Low`, `Na Fibonacci 61,8% úrovni impulzu`, `Presne na dennej EMA50`],
        correct: 1,
      },
      {
        q: `Čo vyžaduje vysoko pravdepodobný swing setup podľa lekcie?`,
        options: [`Jasný denný bias, relevantnú úroveň, 4H/1H signál, objem, minimálne 1:3 RRR`, `Iba analýzu objemu a koreláciu s Bitcoinom`, `Tri technické indikátory potvrdzujúce súčasne`, `Hodinový bias, akúkoľvek podporu a okamžité vykonanie`],
        correct: 0,
      },
    ],
    de: [
      {
        q: `Was ist der Hauptvorteil des Swing-Tradings in Krypto gegenüber Scalping?`,
        options: [`Ermöglicht das Erfassen großer Bewegungen ohne ständige Überwachung`, `Generiert garantiert mehr tägliche Gewinne`, `Eliminiert das Volatilitätsrisiko vollständig`, `Erfordert weniger Anfangskapital als Day-Trading`],
        correct: 0,
      },
      {
        q: `Wo sollte in einem etablierten Aufwärtstrend der Stop-Loss beim Kauf eines HL platziert werden?`,
        options: [`Direkt über dem letzten registrierten HH`, `Unterhalb des identifizierten Higher Low`, `Auf dem Fibonacci-Niveau 61,8% des Impulses`, `Genau auf der EMA50 des Tages-Charts`],
        correct: 1,
      },
      {
        q: `Was erfordert ein Swing-Setup mit hoher Wahrscheinlichkeit laut der Lektion?`,
        options: [`Klarer Tages-Bias, relevantes Niveau, 4H/1H-Signal, Volumen, RRR mindestens 1:3`, `Ausschließlich Volumenanalyse und Korrelation mit Bitcoin`, `Drei technische Indikatoren, die gleichzeitig bestätigen`, `Stunden-Bias, beliebige Unterstützung und sofortige Ausführung`],
        correct: 0,
      },
    ],
    "zh-CN": [
      {
        q: `相比剥头皮交易，加密货币波段交易的主要优势是什么？`,
        options: [`无需持续监控即可捕捉大幅波动`, `保证每日产生更多收益`, `完全消除波动性风险`, `比日内交易需要更少的初始资金`],
        correct: 0,
      },
      {
        q: `在已确立的上升趋势中，在更高低点买入时应该将止损设在哪里？`,
        options: [`刚好在最近一个更高高点上方`, `在识别出的更高低点下方`, `在冲高的斐波那契61.8%水平`, `恰好在日线图的EMA50上`],
        correct: 1,
      },
      {
        q: `根据课程，高概率波段交易设置需要什么？`,
        options: [`明确的日线偏向、相关水平、4H/1H信号、成交量、最低1:3风险回报比`, `仅需成交量分析和与Bitcoin的相关性`, `三个技术指标同时确认`, `小时偏向、任何支撑位和立即执行`],
        correct: 0,
      },
    ],
  },
  L1_9: {
    es: [
      {
        q: `¿Cuántos componentes principales tiene el sistema Ichimoku Kinko Hyo?`,
        options: [`5 componentes: Tenkan, Kijun, Senkou A y B, y Chikou Span`, `3 componentes: Tenkan, Kijun y la Nube Kumo`, `4 componentes: dos líneas rápidas y dos lentas`, `6 componentes incluyendo el ATR y el precio`],
        correct: 0,
      },
      {
        q: `Si el ATR diario de BTC es $2,000 y entras en $42,000, ¿dónde colocarías un stop con multiplicador 1.5×ATR?`,
        options: [`$40,000 (restando 2× el ATR del precio)`, `$44,000 (sumando 1.5× ATR al precio)`, `$39,000 (restando 1.5× ATR del precio de entrada)`, `$43,000 (usando solo 0.5× ATR como margen)`],
        correct: 2,
      },
      {
        q: `¿Cuál afirmación sobre SuperTrend es INCORRECTA?`,
        options: [`Combina ATR y precio para señales direccionales dinámicas`, `El cambio de color de la línea indica cambio de tendencia`, `Funciona mejor como stop fijo sin ajuste a volatilidad`, `Actúa como trailing stop dinámico respetando el ATR`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `How many main components does the Ichimoku Kinko Hyo system have?`,
        options: [`5 components: Tenkan, Kijun, Senkou A and B, and Chikou Span`, `3 components: Tenkan, Kijun and the Kumo Cloud`, `4 components: two fast lines and two slow lines`, `6 components including ATR and price`],
        correct: 0,
      },
      {
        q: `If BTC's daily ATR is $2,000 and you enter at $42,000, where would you place a 1.5×ATR stop?`,
        options: [`$40,000 (subtracting 2× ATR from price)`, `$44,000 (adding 1.5× ATR to price)`, `$39,000 (subtracting 1.5× ATR from entry price)`, `$43,000 (using only 0.5× ATR as margin)`],
        correct: 2,
      },
      {
        q: `Which statement about SuperTrend is INCORRECT?`,
        options: [`It combines ATR and price for dynamic directional signals`, `The line's color change indicates a trend change`, `It works best as a fixed stop without volatility adjustment`, `It acts as a dynamic trailing stop respecting ATR`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Koľko hlavných komponentov má systém Ichimoku Kinko Hyo?`,
        options: [`5 komponentov: Tenkan, Kijun, Senkou A a B, a Chikou Span`, `3 komponenty: Tenkan, Kijun a Oblak Kumo`, `4 komponenty: dve rýchle a dve pomalé línie`, `6 komponentov vrátane ATR a ceny`],
        correct: 0,
      },
      {
        q: `Ak je denný ATR BTC $2,000 a vstupujete na $42,000, kam umiestnite stop s multiplikátorom 1.5×ATR?`,
        options: [`$40,000 (odpočítaním 2× ATR od ceny)`, `$44,000 (pripočítaním 1.5× ATR k cene)`, `$39,000 (odpočítaním 1.5× ATR od vstupnej ceny)`, `$43,000 (použitím len 0.5× ATR ako marže)`],
        correct: 2,
      },
      {
        q: `Ktoré tvrdenie o SuperTrend je NESPRÁVNE?`,
        options: [`Kombinuje ATR a cenu pre dynamické smerové signály`, `Zmena farby línie indikuje zmenu trendu`, `Funguje najlepšie ako fixný stop bez úpravy volatility`, `Funguje ako dynamický trailing stop rešpektujúci ATR`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Wie viele Hauptkomponenten hat das Ichimoku Kinko Hyo-System?`,
        options: [`5 Komponenten: Tenkan, Kijun, Senkou A und B, und Chikou Span`, `3 Komponenten: Tenkan, Kijun und die Kumo-Wolke`, `4 Komponenten: zwei schnelle und zwei langsame Linien`, `6 Komponenten einschließlich ATR und Preis`],
        correct: 0,
      },
      {
        q: `Wenn der tägliche ATR von BTC $2.000 beträgt und du bei $42.000 einsteigst, wo würdest du einen Stop mit 1,5×ATR-Multiplikator platzieren?`,
        options: [`$40.000 (Abzug von 2× ATR vom Preis)`, `$44.000 (Addition von 1,5× ATR zum Preis)`, `$39.000 (Abzug von 1,5× ATR vom Einstiegspreis)`, `$43.000 (nur 0,5× ATR als Marge verwenden)`],
        correct: 2,
      },
      {
        q: `Welche Aussage über SuperTrend ist FALSCH?`,
        options: [`Kombiniert ATR und Preis für dynamische Richtungssignale`, `Der Farbwechsel der Linie zeigt einen Trendwechsel an`, `Funktioniert am besten als fester Stop ohne Anpassung an Volatilität`, `Wirkt als dynamischer Trailing-Stop unter Berücksichtigung des ATR`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `Ichimoku Kinko Hyo系统有多少个主要组成部分？`,
        options: [`5个组成部分：Tenkan、Kijun、Senkou A和B、以及Chikou Span`, `3个组成部分：Tenkan、Kijun和云带Kumo`, `4个组成部分：两条快线和两条慢线`, `6个组成部分，包括ATR和价格`],
        correct: 0,
      },
      {
        q: `如果BTC的日线ATR为$2,000，你在$42,000入场，使用1.5×ATR乘数，止损应设在哪里？`,
        options: [`$40,000（从价格中减去2×ATR）`, `$44,000（在价格上加1.5×ATR）`, `$39,000（从入场价减去1.5×ATR）`, `$43,000（仅使用0.5×ATR作为缓冲）`],
        correct: 2,
      },
      {
        q: `关于SuperTrend，以下哪个说法是错误的？`,
        options: [`结合ATR和价格产生动态方向信号`, `线条颜色变化表示趋势变化`, `作为固定止损效果最好，无需根据波动性调整`, `作为动态追踪止损，遵循ATR`],
        correct: 2,
      },
    ],
  },
  L2_0: {
    es: [
      {
        q: `¿Cuál es la premisa fundamental del marco Smart Money Concepts (SMC)?`,
        options: [`El mercado está diseñado para transferir capital del retail al institucional`, `El mercado es completamente aleatorio y eficiente`, `Los traders minoristas tienen ventaja de información sobre institucionales`, `El precio siempre sigue las noticias fundamentales`],
        correct: 0,
      },
      {
        q: `¿Qué debería hacer un trader SMC cuando ve una ruptura de rango evidente?`,
        options: [`Entrar inmediatamente siguiendo el momentum de ruptura`, `Esperar la reversión post-manipulación antes de entrar`, `Colocar stops justo debajo del soporte obvio`, `Vender todo porque las rupturas siempre fallan`],
        correct: 1,
      },
      {
        q: `¿Cuál NO es una fase correcta del ciclo institucional SMC?`,
        options: [`Consolidación/Acumulación con precio lateral`, `Manipulación con movimiento falso opuesto`, `Validación con volumen retail creciente`, `Distribución/Markup con momentum fuerte`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `What is the fundamental premise of the Smart Money Concepts (SMC) framework?`,
        options: [`The market is designed to transfer capital from retail to institutional`, `The market is completely random and efficient`, `Retail traders have information advantage over institutions`, `Price always follows fundamental news events`],
        correct: 0,
      },
      {
        q: `What should an SMC trader do when seeing an obvious range breakout?`,
        options: [`Enter immediately following the breakout momentum`, `Wait for the post-manipulation reversal before entering`, `Place stops just below the obvious support`, `Sell everything because breakouts always fail`],
        correct: 1,
      },
      {
        q: `Which is NOT a correct phase of the institutional SMC cycle?`,
        options: [`Consolidation/Accumulation with sideways price`, `Manipulation with false move in opposite direction`, `Validation with increasing retail volume`, `Distribution/Markup with strong momentum`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Aká je základná premisa rámca Smart Money Concepts (SMC)?`,
        options: [`Trh je navrhnutý tak, aby prenášal kapitál z retail na inštitucionálne`, `Trh je úplne náhodný a efektívny`, `Retailoví traderi mají informačnú výhodu oproti inštitúciám`, `Cena vždy nasleduje fundamentálne správy`],
        correct: 0,
      },
      {
        q: `Čo by mal robiť SMC trader, keď vidí zrejmý breakout z rangu?`,
        options: [`Vstúpiť okamžite podľa momentum breakoutu`, `Počkať na zvrat po manipulácii pred vstupom`, `Umiestniť stopy tesne pod zrejmou podporu`, `Predať všetko, pretože breakouty vždy zlyhajú`],
        correct: 1,
      },
      {
        q: `Ktorá NIE JE správna fáza inštitucionálneho cyklu SMC?`,
        options: [`Konsolidácia/Akumulácia s bočným pohybom ceny`, `Manipulácia s falošným pohybom v opačnom smere`, `Validácia s rastúcim retailovým objemom`, `Distribúcia/Markup so silným momentum`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Was ist die grundlegende Prämisse des Smart Money Concepts (SMC) Frameworks?`,
        options: [`Der Markt ist darauf ausgelegt, Kapital vom Retail zum institutionellen Bereich zu transferieren`, `Der Markt ist vollständig zufällig und effizient`, `Retail-Trader haben einen Informationsvorteil gegenüber institutionellen Akteuren`, `Der Preis folgt immer den fundamentalen Nachrichten`],
        correct: 0,
      },
      {
        q: `Was sollte ein SMC-Trader tun, wenn er einen offensichtlichen Range-Ausbruch sieht?`,
        options: [`Sofort einsteigen und dem Ausbruchs-Momentum folgen`, `Auf die Umkehr nach der Manipulation warten, bevor man einsteigt`, `Stops direkt unter der offensichtlichen Unterstützung platzieren`, `Alles verkaufen, weil Ausbrüche immer scheitern`],
        correct: 1,
      },
      {
        q: `Welche ist KEINE korrekte Phase des institutionellen SMC-Zyklus?`,
        options: [`Konsolidierung/Akkumulation mit seitwärts gerichtetem Preis`, `Manipulation mit falscher entgegengesetzter Bewegung`, `Validierung mit steigendem Retail-Volumen`, `Distribution/Markup mit starkem Momentum`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `Smart Money Concepts (SMC) 框架的基本前提是什么？`,
        options: [`市场的设计目的是将资金从散户转移到机构`, `市场完全随机且有效`, `散户交易者比机构拥有信息优势`, `价格总是跟随基本面新闻`],
        correct: 0,
      },
      {
        q: `当 SMC 交易者看到明显的区间突破时应该怎么做？`,
        options: [`立即跟随突破动能入场`, `等待操纵后的反转再入场`, `将止损设置在明显支撑位正下方`, `全部卖出，因为突破总是失败`],
        correct: 1,
      },
      {
        q: `以下哪项不是 SMC 机构周期的正确阶段？`,
        options: [`横盘价格的盘整/吸筹阶段`, `反向虚假突破的操纵阶段`, `散户成交量增长的验证阶段`, `强劲动能的派发/拉升阶段`],
        correct: 2,
      },
    ],
  },
  L2_1: {
    es: [
      {
        q: `¿Dónde se acumula típicamente la Stop Loss Liquidity en equal highs?`,
        options: [`Justo por encima de los máximos iguales`, `Exactamente en los máximos iguales`, `Debajo de los máximos previos`, `En el centro del rango de consolidación`],
        correct: 0,
      },
      {
        q: `¿Qué señal confirma un barrido válido de equal highs/lows?`,
        options: [`Volumen alto sin rechazo posterior`, `Consolidación prolongada en el nivel`, `Vela de rechazo inmediata con mecha larga`, `Rotura definitiva sin retroceso`],
        correct: 2,
      },
      {
        q: `¿Cuál NO es uno de los tres tipos principales de liquidez mencionados?`,
        options: [`Liquidez de Book (órdenes limit existentes)`, `Liquidez de Stop (stop-loss acumulados)`, `Liquidez de Volumen (trades ejecutados)`, `Liquidez de Time (zonas revisitadas)`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `Where does Stop Loss Liquidity typically accumulate at equal highs?`,
        options: [`Just above the equal highs`, `Exactly at the equal highs`, `Below the previous highs`, `In the center of the consolidation range`],
        correct: 0,
      },
      {
        q: `What signal confirms a valid sweep of equal highs/lows?`,
        options: [`High volume without subsequent rejection`, `Extended consolidation at the level`, `Immediate rejection candle with long wick`, `Definitive breakout without pullback`],
        correct: 2,
      },
      {
        q: `Which is NOT one of the three main types of liquidity mentioned?`,
        options: [`Book Liquidity (existing limit orders)`, `Stop Liquidity (accumulated stop-losses)`, `Volume Liquidity (executed trades)`, `Time Liquidity (revisited zones)`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Kde sa typicky hromadí Stop Loss Liquidity pri equal highs?`,
        options: [`Tesne nad equal highs`, `Presne na equal highs`, `Pod predchádzajúcimi maximami`, `V strede konsolidačného rozsahu`],
        correct: 0,
      },
      {
        q: `Aké znamenie potvrdzuje platný sweep equal highs/lows?`,
        options: [`Vysoký objem bez následného odmietnutia`, `Predĺžená konsolidácia na úrovni`, `Okamžitá odmietacia sviečka s dlhým knôtom`, `Definitívny prelom bez návratu`],
        correct: 2,
      },
      {
        q: `Ktorý NIE JE jeden z troch hlavných typov likvidity?`,
        options: [`Knižná Likvidita (existujúce limitné príkazy)`, `Stop Likvidita (nahromadené stop-lossy)`, `Objemová Likvidita (vykonané obchody)`, `Časová Likvidita (opätovne navštívené zóny)`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Wo akkumuliert sich typischerweise die Stop Loss Liquidity bei Equal Highs?`,
        options: [`Direkt über den gleichen Hochs`, `Genau auf den gleichen Hochs`, `Unter den vorherigen Hochs`, `In der Mitte der Konsolidierungs-Range`],
        correct: 0,
      },
      {
        q: `Welches Signal bestätigt einen gültigen Sweep von Equal Highs/Lows?`,
        options: [`Hohes Volumen ohne anschließende Ablehnung`, `Längere Konsolidierung auf dem Niveau`, `Sofortige Ablehnungskerze mit langem Docht`, `Definitiver Durchbruch ohne Rücksetzer`],
        correct: 2,
      },
      {
        q: `Welche ist KEINE der drei genannten Hauptarten von Liquidität?`,
        options: [`Book-Liquidität (bestehende Limit-Orders)`, `Stop-Liquidität (akkumulierte Stop-Loss)`, `Volumen-Liquidität (ausgeführte Trades)`, `Zeit-Liquidität (erneut besuchte Zonen)`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `在相等高点（equal highs）处，止损流动性通常积累在哪里？`,
        options: [`相等高点正上方`, `正好在相等高点处`, `前期高点下方`, `盘整区间的中心`],
        correct: 0,
      },
      {
        q: `什么信号确认了对相等高点/低点的有效扫荡？`,
        options: [`高成交量且无后续拒绝`, `在该水平长时间盘整`, `立即出现长影线的拒绝K线`, `无回撤的确定性突破`],
        correct: 2,
      },
      {
        q: `以下哪项不是提到的三种主要流动性类型之一？`,
        options: [`订单簿流动性（现有限价单）`, `止损流动性（累积的止损单）`, `成交量流动性（已执行的交易）`, `时间流动性（重访区域）`],
        correct: 2,
      },
    ],
  },
  L2_2: {
    es: [
      {
        q: `¿Qué representa un Bullish Order Block (BOB)?`,
        options: [`La última vela bajista antes de un impulso alcista fuerte`, `La última vela alcista antes de un impulso bajista fuerte`, `El punto medio de un Fair Value Gap alcista`, `Un Order Block que ha sido completamente roto por el precio`],
        correct: 0,
      },
      {
        q: `¿Qué es el Consequent Encroachment (CE) en un Fair Value Gap?`,
        options: [`El límite superior del FVG donde ocurre la mayor reacción`, `La zona donde el FVG se convierte en Breaker Block`, `El punto medio del FVG, nivel más probable de reacción`, `El límite inferior del FVG donde termina la mitigación`],
        correct: 2,
      },
      {
        q: `¿Cuál afirmación sobre los FVG es INCORRECTA?`,
        options: [`Son zonas de ineficiencia que el mercado tiende a llenar`, `Se forman cuando hay un gap de tres velas sin superposición`, `Los FVG en timeframes bajos son más significativos que los diarios`, `Representan mean reversion a nivel de microestructura del mercado`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `What does a Bullish Order Block (BOB) represent?`,
        options: [`The last bearish candle before a strong bullish impulse`, `The last bullish candle before a strong bearish impulse`, `The midpoint of a bullish Fair Value Gap`, `An Order Block that has been completely broken by price`],
        correct: 0,
      },
      {
        q: `What is the Consequent Encroachment (CE) in a Fair Value Gap?`,
        options: [`The upper boundary of the FVG where strongest reaction occurs`, `The zone where the FVG converts into a Breaker Block`, `The midpoint of the FVG, most likely reaction level`, `The lower boundary of the FVG where mitigation ends`],
        correct: 2,
      },
      {
        q: `Which statement about FVGs is INCORRECT?`,
        options: [`They are inefficiency zones the market tends to fill`, `They form when there's a three-candle gap without overlap`, `FVGs on lower timeframes are more significant than daily ones`, `They represent mean reversion at market microstructure level`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Čo reprezentuje Bullish Order Block (BOB)?`,
        options: [`Poslednú klesajúcu sviečku pred silným rastúcim impulzom`, `Poslednú rastúcu sviečku pred silným klesajúcim impulzom`, `Stredný bod bullish Fair Value Gap`, `Order Block, ktorý bol úplne prelomený cenou`],
        correct: 0,
      },
      {
        q: `Čo je Consequent Encroachment (CE) vo Fair Value Gap?`,
        options: [`Horná hranica FVG, kde nastáva najsilnejšia reakcia`, `Zóna, kde sa FVG mení na Breaker Block`, `Stredný bod FVG, najpravdepodobnejšia úroveň reakcie`, `Dolná hranica FVG, kde končí mitigácia`],
        correct: 2,
      },
      {
        q: `Ktoré tvrdenie o FVG je NESPRÁVNE?`,
        options: [`Sú to zóny neefektívnosti, ktoré trh má tendenciu vyplniť`, `Vytvárajú sa pri trojsviečkovom gape bez prekrytia`, `FVG na nižších timeframe-och sú významnejšie ako denné`, `Reprezentujú mean reversion na úrovni mikroštruktúry trhu`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Was repräsentiert ein Bullish Order Block (BOB)?`,
        options: [`Die letzte bärische Kerze vor einem starken bullischen Impuls`, `Die letzte bullische Kerze vor einem starken bärischen Impuls`, `Der Mittelpunkt eines bullischen Fair Value Gap`, `Ein Order Block, der vollständig vom Preis durchbrochen wurde`],
        correct: 0,
      },
      {
        q: `Was ist das Consequent Encroachment (CE) in einem Fair Value Gap?`,
        options: [`Die obere Grenze des FVG, wo die stärkste Reaktion auftritt`, `Die Zone, wo der FVG zu einem Breaker Block wird`, `Der Mittelpunkt des FVG, das wahrscheinlichste Reaktionsniveau`, `Die untere Grenze des FVG, wo die Mitigation endet`],
        correct: 2,
      },
      {
        q: `Welche Aussage über FVGs ist FALSCH?`,
        options: [`Sie sind Ineffizienzzonen, die der Markt tendenziell füllt`, `Sie bilden sich, wenn es eine Lücke von drei Kerzen ohne Überlappung gibt`, `FVGs in niedrigen Timeframes sind bedeutender als tägliche`, `Sie repräsentieren Mean Reversion auf Mikrostrukturebene des Marktes`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `看涨订单块（Bullish Order Block, BOB）代表什么？`,
        options: [`强劲上涨前的最后一根看跌K线`, `强劲下跌前的最后一根看涨K线`, `看涨 Fair Value Gap 的中点`, `已被价格完全突破的 Order Block`],
        correct: 0,
      },
      {
        q: `Fair Value Gap 中的 Consequent Encroachment (CE) 是什么？`,
        options: [`FVG 的上限，反应最强烈的位置`, `FVG 转变为 Breaker Block 的区域`, `FVG 的中点，最可能发生反应的水平`, `FVG 的下限，缓解结束的位置`],
        correct: 2,
      },
      {
        q: `关于 FVG 的哪项陈述是错误的？`,
        options: [`它们是市场倾向于回填的低效区域`, `当三根K线之间没有重叠时形成`, `低时间周期的 FVG 比日线更重要`, `代表微观结构层面的均值回归`],
        correct: 2,
      },
    ],
  },
  L2_3: {
    es: [
      {
        q: `¿Qué muestra un Footprint Chart que las velas japonesas no muestran?`,
        options: [`El volumen de órdenes de compra y venta en cada nivel de precio dentro de cada vela`, `El precio de apertura y cierre de cada sesión de trading`, `La volatilidad histórica promedio del activo`, `El número total de traders activos en el mercado`],
        correct: 0,
      },
      {
        q: `Si el precio sube pero el Delta es negativo, ¿qué está ocurriendo?`,
        options: [`Los compradores están acumulando posiciones largas agresivamente`, `Absorción bajista: vendedores grandes absorben presión compradora sin dejar subir el precio`, `El mercado está en equilibrio perfecto entre oferta y demanda`, `Las órdenes limit de compra están dominando el orderbook`],
        correct: 1,
      },
      {
        q: `¿Cuál afirmación sobre Delta Exhaustion es INCORRECTA?`,
        options: [`Ocurre cuando delta acumulativo llega a un extremo positivo o negativo`, `Señala que el precio probablemente continuará en la misma dirección indefinidamente`, `Indica agotamiento y posible reversión de tendencia`, `Se detecta cuando el precio no puede avanzar más a pesar del delta extremo`],
        correct: 1,
      },
    ],
    en: [
      {
        q: `What does a Footprint Chart show that candlesticks do not?`,
        options: [`Buy and sell order volume at each price level within each candle`, `The opening and closing price of each trading session`, `The average historical volatility of the asset`, `The total number of active traders in the market`],
        correct: 0,
      },
      {
        q: `If price rises but Delta is negative, what is happening?`,
        options: [`Buyers are aggressively accumulating long positions`, `Bearish absorption: large sellers absorb buying pressure without letting price rise significantly`, `The market is in perfect equilibrium between supply and demand`, `Buy limit orders are dominating the orderbook`],
        correct: 1,
      },
      {
        q: `Which statement about Delta Exhaustion is INCORRECT?`,
        options: [`It occurs when cumulative delta reaches a positive or negative extreme`, `It signals that price will likely continue in the same direction indefinitely`, `It indicates exhaustion and possible trend reversal`, `It's detected when price can't advance further despite extreme delta`],
        correct: 1,
      },
    ],
    sk: [
      {
        q: `Čo zobrazuje Footprint Chart, čo japonské sviečky nezobrazujú?`,
        options: [`Objem nákupných a predajných objednávok na každej cenovej úrovni v rámci každej sviečky`, `Otváraciu a uzatváraciu cenu každej obchodnej relácie`, `Priemernú historickú volatilitu aktíva`, `Celkový počet aktívnych obchodníkov na trhu`],
        correct: 0,
      },
      {
        q: `Ak cena rastie, ale Delta je negatívna, čo sa deje?`,
        options: [`Kupujúci agresívne akumulujú dlhé pozície`, `Medvedia absorpcia: veľkí predajcovia absorbujú nákupný tlak bez výrazného rastu ceny`, `Trh je v dokonalej rovnováhe medzi ponukou a dopytom`, `Nákupné limitné objednávky dominujú orderbooku`],
        correct: 1,
      },
      {
        q: `Ktoré tvrdenie o Delta Exhaustion je NESPRÁVNE?`,
        options: [`Nastáva, keď kumulatívna delta dosiahne pozitívny alebo negatívny extrém`, `Signalizuje, že cena pravdepodobne bude pokračovať rovnakým smerom donekonečna`, `Indikuje vyčerpanie a možný obrat trendu`, `Deteguje sa, keď cena sa nedokáže posunúť ďalej napriek extrémnej delta`],
        correct: 1,
      },
    ],
    de: [
      {
        q: `Was zeigt ein Footprint Chart, das japanische Kerzen nicht zeigen?`,
        options: [`Das Volumen der Kauf- und Verkaufsaufträge auf jedem Preisniveau innerhalb jeder Kerze`, `Den Eröffnungs- und Schlusskurs jeder Trading-Sitzung`, `Die durchschnittliche historische Volatilität des Assets`, `Die Gesamtzahl der aktiven Trader im Markt`],
        correct: 0,
      },
      {
        q: `Wenn der Preis steigt, aber das Delta negativ ist, was passiert dann?`,
        options: [`Käufer akkumulieren aggressiv Long-Positionen`, `Bärische Absorption: Große Verkäufer absorbieren Kaufdruck, ohne den Preis steigen zu lassen`, `Der Markt befindet sich im perfekten Gleichgewicht zwischen Angebot und Nachfrage`, `Limit-Kaufaufträge dominieren das Orderbuch`],
        correct: 1,
      },
      {
        q: `Welche Aussage über Delta Exhaustion ist FALSCH?`,
        options: [`Tritt auf, wenn das kumulative Delta ein positives oder negatives Extremum erreicht`, `Signalisiert, dass der Preis wahrscheinlich unbegrenzt in die gleiche Richtung weitergehen wird`, `Zeigt Erschöpfung und mögliche Trendumkehr an`, `Wird erkannt, wenn der Preis trotz extremem Delta nicht weiter vorrücken kann`],
        correct: 1,
      },
    ],
    "zh-CN": [
      {
        q: `Footprint Chart 显示了哪些日本蜡烛图无法显示的信息？`,
        options: [`每根蜡烛内每个价格水平的买卖订单量`, `每个交易时段的开盘价和收盘价`, `资产的历史平均波动率`, `市场中活跃交易者的总数`],
        correct: 0,
      },
      {
        q: `如果价格上涨但 Delta 为负，这意味着什么？`,
        options: [`买方正在激进地累积多头仓位`, `看跌吸收：大卖家吸收买盘压力而不让价格上涨`, `市场在供需之间处于完美平衡`, `限价买单正在主导订单簿`],
        correct: 1,
      },
      {
        q: `关于 Delta Exhaustion，以下哪项陈述是错误的？`,
        options: [`当累积 delta 达到极端正值或负值时发生`, `表明价格可能会无限期地继续沿同一方向运行`, `表示动能耗尽和可能的趋势反转`, `当价格尽管 delta 极端但无法继续推进时被检测到`],
        correct: 1,
      },
    ],
  },
  L2_4: {
    es: [
      {
        q: `¿Qué indica un precio de Bitcoin subiendo con Open Interest subiendo?`,
        options: [`Nuevas posiciones largas entrando, rally sostenible con convicción`, `Posiciones cortas cerrándose, rally frágil sin convicción`, `Nuevas posiciones cortas entrando, caída inminente del precio`, `Posiciones largas cerrándose, capitulación del mercado alcista`],
        correct: 0,
      },
      {
        q: `Un Funding Rate muy positivo (≥0.1% cada 8h) sostenido indica:`,
        options: [`Exceso de shorts, alta probabilidad de short squeeze alcista`, `Mercado equilibrado, sin riesgo de liquidaciones masivas`, `Exceso de longs, mercado preparado para corrección bajista`, `Whale accumulation, señal de compra institucional fuerte`],
        correct: 2,
      },
      {
        q: `¿Cuál combinación señala capitulación y posible punto de compra?`,
        options: [`Precio sube con OI subiendo y Funding Rate positivo extremo`, `Precio baja con OI bajando y posiciones largas cerrándose`, `Precio sube con OI bajando y Funding Rate negativo extremo`, `Precio estable con OI máximo histórico y Exchange Inflow alto`],
        correct: 1,
      },
    ],
    en: [
      {
        q: `What does rising Bitcoin price with rising Open Interest indicate?`,
        options: [`New long positions entering, sustainable rally with conviction`, `Short positions closing, fragile rally without conviction`, `New short positions entering, imminent price decline ahead`, `Long positions closing, capitulation of bullish market participants`],
        correct: 0,
      },
      {
        q: `A sustained very positive Funding Rate (≥0.1% every 8h) indicates:`,
        options: [`Excess shorts, high probability of bullish short squeeze`, `Balanced market, no risk of mass liquidations occurring`, `Excess longs, market primed for bearish correction`, `Whale accumulation, strong institutional buy signal present`],
        correct: 2,
      },
      {
        q: `Which combination signals capitulation and a possible buying point?`,
        options: [`Price rising with OI rising and extreme positive Funding Rate`, `Price falling with OI falling and long positions closing`, `Price rising with OI falling and extreme negative Funding Rate`, `Price stable with historic OI peak and high Exchange Inflow`],
        correct: 1,
      },
    ],
    sk: [
      {
        q: `Čo naznačuje rastúca cena Bitcoinu s rastúcim Open Interest?`,
        options: [`Nové long pozície vstupujú, udržateľný rally s presvedčením`, `Short pozície sa zatvárajú, krehký rally bez presvedčenia`, `Nové short pozície vstupujú, hroziaci pokles ceny`, `Long pozície sa zatvárajú, kapitulácia bullish účastníkov trhu`],
        correct: 0,
      },
      {
        q: `Trvalo veľmi pozitívny Funding Rate (≥0.1% každých 8h) indikuje:`,
        options: [`Prebytok shortov, vysoká pravdepodobnosť bullish short squeeze`, `Vyvážený trh, žiadne riziko masových likvidácií`, `Prebytok longov, trh pripravený na bearish korekciu`, `Whale accumulation, silný inštitucionálny nákupný signál`],
        correct: 2,
      },
      {
        q: `Ktorá kombinácia signalizuje kapituláciu a možný nákupný bod?`,
        options: [`Cena rastie s OI rastúcim a extrémne pozitívnym Funding Rate`, `Cena klesá s OI klesajúcim a long pozície sa zatvárajú`, `Cena rastie s OI klesajúcim a extrémne negatívnym Funding Rate`, `Cena stabilná s historickým maximom OI a vysokým Exchange Inflow`],
        correct: 1,
      },
    ],
    de: [
      {
        q: `Was zeigt ein steigender Bitcoin-Preis mit steigendem Open Interest an?`,
        options: [`Neue Long-Positionen treten ein, nachhaltiger Rally mit Überzeugung`, `Short-Positionen werden geschlossen, fragiler Rally ohne Überzeugung`, `Neue Short-Positionen treten ein, bevorstehender Preisverfall`, `Long-Positionen werden geschlossen, Kapitulation des bullischen Marktes`],
        correct: 0,
      },
      {
        q: `Ein sehr positiver Funding Rate (≥0,1% alle 8h), der anhält, zeigt an:`,
        options: [`Überschuss an Shorts, hohe Wahrscheinlichkeit eines bullischen Short Squeeze`, `Ausgewogener Markt, kein Risiko massiver Liquidationen`, `Überschuss an Longs, Markt bereit für bärische Korrektur`, `Whale Accumulation, starkes institutionelles Kaufsignal`],
        correct: 2,
      },
      {
        q: `Welche Kombination signalisiert Kapitulation und möglichen Kaufpunkt?`,
        options: [`Preis steigt mit steigendem OI und extrem positivem Funding Rate`, `Preis fällt mit fallendem OI und Long-Positionen werden geschlossen`, `Preis steigt mit fallendem OI und extrem negativem Funding Rate`, `Preis stabil mit historischem OI-Maximum und hohem Exchange Inflow`],
        correct: 1,
      },
    ],
    "zh-CN": [
      {
        q: `Bitcoin 价格上涨且 Open Interest 上升意味着什么？`,
        options: [`新多头仓位进场，有信念支撑的可持续上涨`, `空头仓位平仓，缺乏信念的脆弱上涨`, `新空头仓位进场，价格即将下跌`, `多头仓位平仓，多头市场投降`],
        correct: 0,
      },
      {
        q: `持续的极高 Funding Rate（≥0.1% 每8小时）表明：`,
        options: [`空头过多，空头挤压上涨的高概率`, `市场平衡，没有大规模强制平仓风险`, `多头过多，市场准备看跌修正`, `巨鲸积累，强劲的机构买入信号`],
        correct: 2,
      },
      {
        q: `哪种组合表明投降和可能的买入点？`,
        options: [`价格上涨，OI 上升，Funding Rate 极端正值`, `价格下跌，OI 下降，多头仓位平仓`, `价格上涨，OI 下降，Funding Rate 极端负值`, `价格稳定，OI 历史最高，交易所流入量高`],
        correct: 1,
      },
    ],
  },
  L2_5: {
    es: [
      {
        q: `¿Qué representa el BC (Buying Climax) en la distribución Wyckoff?`,
        options: [`El primer soporte institucional que frena el rally`, `El pico de euforia con volumen climático cuando SM vende`, `El último rebote antes de la caída libre`, `La ruptura falsa al alza dentro del rango`],
        correct: 1,
      },
      {
        q: `¿Cuál es la diferencia clave entre UT y UTAD?`,
        options: [`El UT ocurre antes con menor volumen que el UTAD`, `El UTAD es más pronunciado y crea el máximo final del ciclo`, `El UT siempre rompe el ATH mientras el UTAD no`, `El UTAD ocurre antes del BC y el UT después del SOW`],
        correct: 1,
      },
      {
        q: `¿Cuál afirmación sobre LPSY (Last Point of Supply) es INCORRECTA?`,
        options: [`Ocurre generalmente al nivel del BC o soporte roto`, `Es la última oportunidad para posicionarse corto antes del markdown`, `Siempre presenta volumen climático superior al BC`, `Es el último rebote antes de la caída libre`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `What does BC (Buying Climax) represent in Wyckoff distribution?`,
        options: [`The first institutional resistance halting the rally`, `The euphoria peak with climactic volume when SM sells`, `The final bounce before free fall begins`, `The false upside breakout within the range`],
        correct: 1,
      },
      {
        q: `What is the key difference between UT and UTAD?`,
        options: [`UT occurs earlier with lower volume than UTAD`, `UTAD is more pronounced and creates the cycle's final high`, `UT always breaks ATH while UTAD does not`, `UTAD occurs before BC and UT after SOW`],
        correct: 1,
      },
      {
        q: `Which statement about LPSY (Last Point of Supply) is INCORRECT?`,
        options: [`It generally occurs at BC level or broken support`, `It's the last opportunity to position short before markdown`, `It always shows climactic volume exceeding the BC`, `It's the final bounce before the free fall`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Čo predstavuje BC (Buying Climax) v Wyckoff distribúcii?`,
        options: [`Prvú inštitucionálnu rezistenciu zastavujúcu rally`, `Vrchol eufórie s klimaktickým objemom keď SM predáva`, `Posledný odraz pred voľným pádom`, `Falošný prielom nahor v rámci rozsahu`],
        correct: 1,
      },
      {
        q: `Aký je kľúčový rozdiel medzi UT a UTAD?`,
        options: [`UT sa vyskytuje skôr s nižším objemom ako UTAD`, `UTAD je výraznejší a vytvára finálne maximum cyklu`, `UT vždy prekoná ATH zatiaľ čo UTAD nie`, `UTAD sa vyskytuje pred BC a UT po SOW`],
        correct: 1,
      },
      {
        q: `Ktoré tvrdenie o LPSY (Last Point of Supply) je NESPRÁVNE?`,
        options: [`Zvyčajne sa vyskytuje na úrovni BC alebo prelomenej podpory`, `Je to posledná príležitosť na shortovú pozíciu pred markdown`, `Vždy vykazuje klimaktický objem presahujúci BC`, `Je to posledný odraz pred voľným pádom`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Was repräsentiert der BC (Buying Climax) in der Wyckoff-Distribution?`,
        options: [`Die erste institutionelle Unterstützung, die den Rally bremst`, `Der Euphorie-Höhepunkt mit klimatischem Volumen, wenn SM verkauft`, `Der letzte Rebound vor dem freien Fall`, `Der falsche Ausbruch nach oben innerhalb der Range`],
        correct: 1,
      },
      {
        q: `Was ist der Hauptunterschied zwischen UT und UTAD?`,
        options: [`Der UT tritt früher mit geringerem Volumen als der UTAD auf`, `Der UTAD ist ausgeprägter und schafft das finale Maximum des Zyklus`, `Der UT durchbricht immer das ATH, während der UTAD dies nicht tut`, `Der UTAD tritt vor dem BC auf und der UT nach dem SOW`],
        correct: 1,
      },
      {
        q: `Welche Aussage über LPSY (Last Point of Supply) ist FALSCH?`,
        options: [`Tritt in der Regel auf dem Niveau des BC oder der gebrochenen Unterstützung auf`, `Ist die letzte Gelegenheit, sich vor dem Markdown short zu positionieren`, `Zeigt immer klimatisches Volumen, das höher ist als beim BC`, `Ist der letzte Rebound vor dem freien Fall`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `在 Wyckoff 派发阶段，BC（Buying Climax）代表什么？`,
        options: [`阻止上涨的第一个机构支撑位`, `当 SM 卖出时，伴随高潮成交量的狂热顶峰`, `自由落体前的最后一次反弹`, `盘整区间内的虚假向上突破`],
        correct: 1,
      },
      {
        q: `UT 和 UTAD 之间的关键区别是什么？`,
        options: [`UT 发生较早且成交量低于 UTAD`, `UTAD 更为显著并创造周期的最终高点`, `UT 总是突破 ATH 而 UTAD 不会`, `UTAD 发生在 BC 之前，UT 发生在 SOW 之后`],
        correct: 1,
      },
      {
        q: `关于 LPSY（Last Point of Supply），以下哪项陈述是错误的？`,
        options: [`通常发生在 BC 水平或被突破的支撑位`, `是在 markdown 之前建立空头仓位的最后机会`, `总是呈现高于 BC 的高潮成交量`, `是自由落体前的最后一次反弹`],
        correct: 2,
      },
    ],
  },
  L2_6: {
    es: [
      {
        q: `¿Qué sucede típicamente con Bitcoin cuando el DXY sube?`,
        options: [`Bitcoin tiende a caer porque los inversores prefieren activos en USD`, `Bitcoin sube porque el dólar fuerte atrae capital a cripto`, `Bitcoin se desacopla completamente del DXY en esos períodos`, `Bitcoin mantiene su valor sin cambios significativos`],
        correct: 0,
      },
      {
        q: `¿Por qué el período 2022 fue devastador para cripto según la lección?`,
        options: [`Por el colapso de exchanges centralizados y hacks masivos`, `Porque la Fed subió tasas al ritmo más agresivo desde los 80`, `Por regulaciones gubernamentales restrictivas en todo el mundo`, `Debido a la caída en adopción institucional de Bitcoin`],
        correct: 1,
      },
      {
        q: `En entornos de dólar débil, ¿qué buscan los inversores globales?`,
        options: [`Bonos del Tesoro con alto rendimiento garantizado`, `Efectivo en cuentas bancarias para proteger capital`, `Activos que preserven valor contra depreciación del USD como Bitcoin`, `Acciones de empresas tecnológicas de bajo riesgo`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `What typically happens to Bitcoin when the DXY rises?`,
        options: [`Bitcoin tends to fall as investors prefer USD-denominated assets`, `Bitcoin rises because a strong dollar attracts capital to crypto`, `Bitcoin completely decouples from the DXY during those periods`, `Bitcoin maintains its value without significant changes`],
        correct: 0,
      },
      {
        q: `Why was the 2022 period devastating for crypto according to the lesson?`,
        options: [`Due to the collapse of centralized exchanges and massive hacks`, `Because the Fed raised rates at the most aggressive pace since the 1980s`, `Due to restrictive government regulations worldwide`, `Because of a drop in institutional Bitcoin adoption`],
        correct: 1,
      },
      {
        q: `In weak dollar environments, what do global investors seek?`,
        options: [`Treasury bonds with guaranteed high yields`, `Cash in bank accounts to protect capital`, `Assets that preserve value against USD depreciation like Bitcoin`, `Low-risk technology company stocks`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Čo sa typicky deje s Bitcoinom, keď DXY rastie?`,
        options: [`Bitcoin má tendenciu klesať, lebo investori uprednostňujú aktíva v USD`, `Bitcoin rastie, pretože silný dolár priťahuje kapitál do krypta`, `Bitcoin sa v týchto obdobiach úplne odpája od DXY`, `Bitcoin si zachováva hodnotu bez významných zmien`],
        correct: 0,
      },
      {
        q: `Prečo bolo obdobie roka 2022 ničivé pre krypto podľa lekcie?`,
        options: [`Kvôli kolapsu centralizovaných búrz a masívnym hackom`, `Pretože Fed zvyšoval sadzby najagresívnejším tempom od 80. rokov`, `Kvôli reštriktívnym vládnym reguláciám na celom svete`, `Kvôli poklesu inštitucionálnej adopcie Bitcoinu`],
        correct: 1,
      },
      {
        q: `V prostrediach so slabým dolárom, čo hľadajú globálni investori?`,
        options: [`Štátne dlhopisy so zaručeným vysokým výnosom`, `Hotovosť na bankových účtoch na ochranu kapitálu`, `Aktíva zachovávajúce hodnotu proti deprecácii USD ako Bitcoin`, `Nízko-rizikové akcie technologických spoločností`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Was passiert typischerweise mit Bitcoin, wenn der DXY steigt?`,
        options: [`Bitcoin tendiert zu fallen, weil Investoren USD-Vermögenswerte bevorzugen`, `Bitcoin steigt, weil der starke Dollar Kapital in Krypto anzieht`, `Bitcoin entkoppelt sich in diesen Perioden vollständig vom DXY`, `Bitcoin behält seinen Wert ohne signifikante Veränderungen`],
        correct: 0,
      },
      {
        q: `Warum war die Periode 2022 laut der Lektion verheerend für Krypto?`,
        options: [`Wegen des Zusammenbruchs zentralisierter Börsen und massiver Hacks`, `Weil die Fed die Zinsen im aggressivsten Tempo seit den 80ern erhöhte`, `Wegen restriktiver Regierungsvorschriften weltweit`, `Aufgrund des Rückgangs der institutionellen Adoption von Bitcoin`],
        correct: 1,
      },
      {
        q: `In Umgebungen mit schwachem Dollar, wonach suchen globale Investoren?`,
        options: [`Staatsanleihen mit garantiert hoher Rendite`, `Bargeld auf Bankkonten zum Kapitalschutz`, `Vermögenswerte, die Wert gegen USD-Abwertung bewahren, wie Bitcoin`, `Aktien von Technologieunternehmen mit geringem Risiko`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `当DXY上涨时，比特币通常会发生什么？`,
        options: [`Bitcoin往往下跌，因为投资者更偏好以美元计价的资产`, `Bitcoin上涨，因为强势美元吸引资金流入加密货币`, `Bitcoin在这些时期完全与DXY脱钩`, `Bitcoin保持其价值，没有显著变化`],
        correct: 0,
      },
      {
        q: `根据课程内容，为什么2022年对加密货币来说是灾难性的？`,
        options: [`因为中心化交易所崩溃和大规模黑客攻击`, `因为美联储以80年代以来最激进的速度加息`, `因为全球范围内的政府限制性监管`, `由于Bitcoin机构采用率下降`],
        correct: 1,
      },
      {
        q: `在美元疲软的环境中，全球投资者寻求什么？`,
        options: [`具有高保证收益的国债`, `银行账户中的现金以保护资本`, `能够对抗美元贬值保值的资产，如Bitcoin`, `低风险科技公司股票`],
        correct: 2,
      },
    ],
  },
  L2_7: {
    es: [
      {
        q: `¿Qué tres elementos principales confluyen en el Setup 1 de mayor probabilidad?`,
        options: [`Spring de Wyckoff, Order Block HTF y zona Fibonacci Discount`, `Liquidity sweep, FVG alcista y funding rate negativo`, `BOS confirmado, retest de estructura y volumen alto`, `RSI divergencia, soporte roto y Golden Cross`],
        correct: 0,
      },
      {
        q: `En el Setup 2 (Liquidity Sweep), ¿cuál es la función del funding rate negativo?`,
        options: [`Indica que los longs están sobreapalancados y habrá corrección`, `Muestra que hay shorts acumulados que serán squeezed al alza`, `Confirma que el precio bajará más después del sweep`, `Señala que el mercado está en equilibrio neutral`],
        correct: 1,
      },
      {
        q: `¿Cuál afirmación sobre el Setup 3 de Continuación en Retest de BOS es INCORRECTA?`,
        options: [`Es el setup más simple pero uno de los más rentables`, `Requiere un BOS bullish confirmado en 4H previo al retest`, `Funciona mejor cuando el volumen del retest es mayor que el del BOS`, `La entrada se ejecuta en el retest de la estructura rota`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `What three main elements confluence in the highest probability Setup 1?`,
        options: [`Wyckoff Spring, HTF Order Block and Fibonacci Discount zone`, `Liquidity sweep, bullish FVG and negative funding rate`, `Confirmed BOS, structure retest and high volume`, `RSI divergence, broken support and Golden Cross`],
        correct: 0,
      },
      {
        q: `In Setup 2 (Liquidity Sweep), what is the function of negative funding rate?`,
        options: [`Indicates longs are over-leveraged and correction will occur`, `Shows accumulated shorts that will be squeezed upward`, `Confirms price will drop further after the sweep`, `Signals the market is in neutral equilibrium`],
        correct: 1,
      },
      {
        q: `Which statement about Setup 3 BOS Retest Continuation is INCORRECT?`,
        options: [`It is the simplest setup but one of the most profitable`, `Requires a confirmed bullish BOS on 4H prior to retest`, `Works best when retest volume is higher than BOS volume`, `Entry is executed on the retest of broken structure`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Aké tri hlavné prvky konfluujú v Setupe 1 s najvyššou pravdepodobnosťou?`,
        options: [`Wyckoff Spring, HTF Order Block a Fibonacci Discount zóna`, `Liquidity sweep, bullish FVG a negatívny funding rate`, `Potvrdený BOS, retest štruktúry a vysoký objem`, `RSI divergencia, prelomená podpora a Golden Cross`],
        correct: 0,
      },
      {
        q: `V Setupe 2 (Liquidity Sweep), aká je funkcia negatívneho funding rate?`,
        options: [`Indikuje, že longy sú prepákované a nastane korekcia`, `Ukazuje akumulované shorty, ktoré budú squeezed nahor`, `Potvrdzuje, že cena po sweepe ďalej klesne`, `Signalizuje, že trh je v neutrálnej rovnováhe`],
        correct: 1,
      },
      {
        q: `Ktoré tvrdenie o Setupe 3 Pokračovanie na Reteste BOS je NESPRÁVNE?`,
        options: [`Je to najjednoduchší setup, ale jeden z najziskovejších`, `Vyžaduje potvrdený bullish BOS na 4H pred retestom`, `Funguje najlepšie, keď objem retestu je vyšší ako objem BOS`, `Vstup sa vykonáva pri reteste prelomenej štruktúry`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Welche drei Hauptelemente treffen im Setup 1 mit höchster Wahrscheinlichkeit zusammen?`,
        options: [`Wyckoff Spring, HTF Order Block und Fibonacci Discount Zone`, `Liquidity sweep, bullischer FVG und negativer Funding Rate`, `Bestätigter BOS, Struktur-Retest und hohes Volumen`, `RSI-Divergenz, gebrochene Unterstützung und Golden Cross`],
        correct: 0,
      },
      {
        q: `Im Setup 2 (Liquidity Sweep), welche Funktion hat der negative Funding Rate?`,
        options: [`Zeigt an, dass Longs übergehebelt sind und eine Korrektur folgt`, `Zeigt, dass akkumulierte Shorts nach oben gesqueezed werden`, `Bestätigt, dass der Preis nach dem Sweep weiter fallen wird`, `Signalisiert, dass der Markt in neutralem Gleichgewicht ist`],
        correct: 1,
      },
      {
        q: `Welche Aussage über Setup 3 der Fortsetzung im BOS-Retest ist FALSCH?`,
        options: [`Es ist das einfachste Setup, aber eines der profitabelsten`, `Erfordert einen bestätigten bullischen BOS auf 4H vor dem Retest`, `Funktioniert am besten, wenn das Volumen des Retests größer ist als das des BOS`, `Der Einstieg erfolgt beim Retest der gebrochenen Struktur`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `在概率最高的Setup 1中，哪三个主要要素汇合？`,
        options: [`Wyckoff的Spring、HTF的Order Block和Fibonacci折扣区`, `流动性扫荡、看涨FVG和负资金费率`, `确认的BOS、结构回测和高成交量`, `RSI背离、支撑位突破和Golden Cross`],
        correct: 0,
      },
      {
        q: `在Setup 2（流动性扫荡）中，负资金费率的作用是什么？`,
        options: [`表明多头过度杠杆化，将出现回调`, `显示有空头积累将被向上挤压`, `确认价格在扫荡后会进一步下跌`, `表明市场处于中性平衡状态`],
        correct: 1,
      },
      {
        q: `关于Setup 3（BOS回测中的延续），以下哪个陈述是错误的？`,
        options: [`这是最简单但最有利可图的设置之一`, `需要在回测之前在4H上确认看涨BOS`, `当回测的成交量大于BOS的成交量时效果最好`, `入场在突破结构的回测处执行`],
        correct: 2,
      },
    ],
  },
  L3_0: {
    es: [
      {
        q: `Según Mark Douglas, ¿qué caracteriza el 'estado de flujo del mercado'?`,
        options: [`Aceptar que cualquier trade puede perder sin carga emocional`, `Predecir con exactitud el próximo movimiento del mercado`, `Operar solo en mercados alcistas para minimizar pérdidas`, `Aumentar el tamaño de posición después de ganar trades`],
        correct: 0,
      },
      {
        q: `Un trade que sigue el plan perfectamente pero pierde dinero es:`,
        options: [`Un fracaso del sistema que debe modificarse inmediatamente`, `Señal de incompetencia que requiere más formación`, `Un trade exitoso en términos de proceso`, `Resultado de no esperar suficiente tiempo antes de entrar`],
        correct: 2,
      },
      {
        q: `¿Cuál es el propósito del análisis post-mortem tras una pérdida?`,
        options: [`Castigarse psicológicamente para evitar repetir el error`, `Distinguir entre error de proceso y resultado adverso correcto`, `Encontrar culpables externos como el broker o la liquidez`, `Justificar la pérdida y olvidarla rápidamente para seguir`],
        correct: 1,
      },
    ],
    en: [
      {
        q: `According to Mark Douglas, what characterizes the 'market flow state'?`,
        options: [`Accepting that any trade can lose without emotional charge`, `Predicting the next market move with precision`, `Trading only bull markets to minimize losses`, `Increasing position size after winning trades`],
        correct: 0,
      },
      {
        q: `A trade that perfectly follows the plan but loses money is:`,
        options: [`A system failure requiring immediate modification`, `A sign of incompetence needing more training`, `A successful trade in process terms`, `Result of not waiting long enough before entry`],
        correct: 2,
      },
      {
        q: `What is the purpose of post-mortem analysis after a loss?`,
        options: [`Punishing yourself psychologically to avoid repeating the error`, `Distinguishing between process error and correct adverse outcome`, `Finding external culprits like the broker or liquidity`, `Justifying the loss and forgetting it quickly to move on`],
        correct: 1,
      },
    ],
    sk: [
      {
        q: `Podľa Marka Douglasa, čo charakterizuje 'stav trhového toku'?`,
        options: [`Akceptovanie, že akýkoľvek obchod môže stratiť bez emócií`, `Presné predpovedanie ďalšieho pohybu trhu`, `Obchodovanie len v rastúcich trhoch na minimalizáciu strát`, `Zvyšovanie veľkosti pozície po výherných obchodoch`],
        correct: 0,
      },
      {
        q: `Obchod, ktorý dokonale dodržiava plán, ale stratí peniaze, je:`,
        options: [`Zlyhanie systému vyžadujúce okamžitú modifikáciu`, `Znak neschopnosti potrebujúci viac školenia`, `Úspešný obchod z hľadiska procesu`, `Výsledok nedostatočného čakania pred vstupom`],
        correct: 2,
      },
      {
        q: `Aký je účel post-mortem analýzy po strate?`,
        options: [`Psychologicky sa potrestať, aby sa chyba neopakovala`, `Rozlíšiť medzi chybou procesu a správnym nepriaznivým výsledkom`, `Hľadať vonkajších vinníkov ako brokera alebo likviditu`, `Ospravedlniť stratu a rýchlo ju zabudnúť, aby sa pokračovalo`],
        correct: 1,
      },
    ],
    de: [
      {
        q: `Was charakterisiert laut Mark Douglas den 'Flow-Zustand des Marktes'?`,
        options: [`Akzeptieren, dass jeder Trade verlieren kann, ohne emotionale Belastung`, `Den nächsten Marktbewegung mit Genauigkeit vorhersagen`, `Nur in Bullenmärkten handeln, um Verluste zu minimieren`, `Die Positionsgröße nach gewonnenen Trades erhöhen`],
        correct: 0,
      },
      {
        q: `Ein Trade, der dem Plan perfekt folgt, aber Geld verliert, ist:`,
        options: [`Ein Systemversagen, das sofort modifiziert werden muss`, `Ein Zeichen von Inkompetenz, das mehr Ausbildung erfordert`, `Ein erfolgreicher Trade in Bezug auf den Prozess`, `Ergebnis davon, nicht lange genug vor dem Einstieg zu warten`],
        correct: 2,
      },
      {
        q: `Was ist der Zweck der Post-Mortem-Analyse nach einem Verlust?`,
        options: [`Sich psychologisch zu bestrafen, um den Fehler nicht zu wiederholen`, `Zwischen Prozessfehler und korrektem negativem Ergebnis zu unterscheiden`, `Externe Schuldige wie den Broker oder die Liquidität zu finden`, `Den Verlust zu rechtfertigen und schnell zu vergessen, um weiterzumachen`],
        correct: 1,
      },
    ],
    "zh-CN": [
      {
        q: `根据Mark Douglas的观点，什么是'市场流动状态'的特征？`,
        options: [`接受任何交易都可能亏损而不带情绪负担`, `准确预测市场的下一个走势`, `仅在牛市中操作以最小化损失`, `在盈利交易后增加仓位规模`],
        correct: 0,
      },
      {
        q: `一笔完美遵循计划但亏损的交易是：`,
        options: [`系统失败，必须立即修改`, `表明无能，需要更多培训`, `从流程角度来看是成功的交易`, `没有在入场前等待足够时间的结果`],
        correct: 2,
      },
      {
        q: `亏损后进行事后分析的目的是什么？`,
        options: [`在心理上惩罚自己以避免重复错误`, `区分流程错误和正确的不利结果`, `寻找外部责任方，如经纪商或流动性`, `为亏损辩护并迅速忘记以继续前进`],
        correct: 1,
      },
    ],
  },
  L3_1: {
    es: [
      {
        q: `Según Kahneman/Tversky, ¿cuántas veces más intenso es el dolor de perder $1,000 que la alegría de ganar $1,000?`,
        options: [`1.5-2 veces más intenso`, `3-4 veces más intenso`, `2-2.5 veces más intenso`, `Aproximadamente igual en intensidad`],
        correct: 2,
      },
      {
        q: `¿Cuál es el principal antídoto contra el Efecto Disposición y la Aversión a la Pérdida?`,
        options: [`Aumentar el tamaño de posición tras rachas ganadoras`, `Establecer reglas mecánicas de TP y SL predeterminadas`, `Confiar en tu intuición durante el trade`, `Buscar activamente información que confirme tu análisis`],
        correct: 1,
      },
      {
        q: `¿Qué afirmación sobre la Ilusión de Control es INCORRECTA?`,
        options: [`El mercado tiene una componente aleatoria irreducible`, `Un análisis perfecto puede resultar en pérdida de todos modos`, `Incluso el mejor análisis tiene solo 60-70% de probabilidad de éxito`, `Con suficiente experiencia puedes predecir el mercado con 100% de certeza`],
        correct: 3,
      },
    ],
    en: [
      {
        q: `According to Kahneman/Tversky, how much more intense is the pain of losing $1,000 than the joy of winning $1,000?`,
        options: [`1.5-2 times more intense`, `3-4 times more intense`, `2-2.5 times more intense`, `Approximately equal in intensity`],
        correct: 2,
      },
      {
        q: `What is the main antidote against the Disposition Effect and Loss Aversion?`,
        options: [`Increase position size after winning streaks`, `Establish mechanical predetermined TP and SL rules`, `Trust your intuition during the trade`, `Actively seek information confirming your analysis`],
        correct: 1,
      },
      {
        q: `Which statement about the Illusion of Control is INCORRECT?`,
        options: [`The market has an irreducible random component`, `Perfect analysis can still result in a loss`, `Even the best analysis has only 60-70% success probability`, `With enough experience you can predict the market with 100% certainty`],
        correct: 3,
      },
    ],
    sk: [
      {
        q: `Podľa Kahnemana/Tverskyho, koľkokrát intenzívnejšia je bolesť zo straty $1,000 než radosť zo zisku $1,000?`,
        options: [`1.5-2 krát intenzívnejšia`, `3-4 krát intenzívnejšia`, `2-2.5 krát intenzívnejšia`, `Približne rovnako intenzívna`],
        correct: 2,
      },
      {
        q: `Aká je hlavná protilátka proti Dispozičnému efektu a Averzii k strate?`,
        options: [`Zvýšiť veľkosť pozície po ziskových sériách`, `Stanoviť mechanické vopred určené pravidlá TP a SL`, `Spoľahnúť sa na svoju intuíciu počas obchodu`, `Aktívne hľadať informácie potvrdzujúce tvoju analýzu`],
        correct: 1,
      },
      {
        q: `Ktoré tvrdenie o Ilúzii kontroly je NESPRÁVNE?`,
        options: [`Trh má neredukovateľnú náhodnú zložku`, `Perfektná analýza môže stále skončiť stratou`, `Aj najlepšia analýza má len 60-70% pravdepodobnosť úspechu`, `S dostatočnými skúsenosťami môžeš predpovedať trh so 100% istotou`],
        correct: 3,
      },
    ],
    de: [
      {
        q: `Laut Kahneman/Tversky, wie viel intensiver ist der Schmerz, $1.000 zu verlieren, im Vergleich zur Freude, $1.000 zu gewinnen?`,
        options: [`1,5-2 mal intensiver`, `3-4 mal intensiver`, `2-2,5 mal intensiver`, `Ungefähr gleich intensiv`],
        correct: 2,
      },
      {
        q: `Was ist das wichtigste Gegenmittel gegen den Dispositionseffekt und die Verlustaversion?`,
        options: [`Positionsgröße nach Gewinnserien erhöhen`, `Mechanische TP- und SL-Regeln im Voraus festlegen`, `Während des Trades auf deine Intuition vertrauen`, `Aktiv nach Informationen suchen, die deine Analyse bestätigen`],
        correct: 1,
      },
      {
        q: `Welche Aussage über die Kontrollillusion ist FALSCH?`,
        options: [`Der Markt hat eine irreduzible zufällige Komponente`, `Eine perfekte Analyse kann trotzdem zu einem Verlust führen`, `Selbst die beste Analyse hat nur eine 60-70%ige Erfolgswahrscheinlichkeit`, `Mit ausreichend Erfahrung kannst du den Markt mit 100%iger Sicherheit vorhersagen`],
        correct: 3,
      },
    ],
    "zh-CN": [
      {
        q: `根据Kahneman/Tversky的研究，损失$1,000的痛苦强度是获得$1,000喜悦的多少倍？`,
        options: [`1.5-2倍强度`, `3-4倍强度`, `2-2.5倍强度`, `强度大致相同`],
        correct: 2,
      },
      {
        q: `对抗处置效应和损失厌恶的主要解药是什么？`,
        options: [`在连胜后增加仓位规模`, `建立预先设定的机械化TP和SL规则`, `在交易过程中相信你的直觉`, `主动寻找确认你分析的信息`],
        correct: 1,
      },
      {
        q: `关于控制错觉，以下哪项陈述是错误的？`,
        options: [`市场具有不可消除的随机成分`, `完美的分析仍可能导致亏损`, `即使是最好的分析也只有60-70%的成功概率`, `有足够经验就能以100%的确定性预测市场`],
        correct: 3,
      },
    ],
  },
  L3_2: {
    es: [
      {
        q: `¿Cuál es la diferencia clave entre un sistema de trading y un estilo vago de trading?`,
        options: [`La especificidad y claridad de las reglas`, `La rentabilidad histórica del sistema`, `El número de indicadores técnicos utilizados`, `La frecuencia de las operaciones ejecutadas`],
        correct: 0,
      },
      {
        q: `Un trader tiene definidos sus criterios de entrada, timeframes y activos, pero carece de gestión de capital explícita. ¿Cuál es el riesgo principal?`,
        options: [`Menor número de oportunidades de trading`, `Destrucción de la cuenta pese a análisis correcto`, `Imposibilidad de calcular el Profit Factor`, `Reducción del win rate del sistema`],
        correct: 1,
      },
      {
        q: `¿Qué afirmación sobre la Expectativa del Sistema es INCORRECTA?`,
        options: [`Se calcula: (Win Rate × Ganancia Media) − (Loss Rate × Pérdida Media)`, `Un resultado positivo indica ventaja matemática a largo plazo`, `Un sistema con expectativa negativa puede ser rentable si se opera más frecuentemente`, `Permite identificar si el sistema tiene edge real`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `What is the key difference between a trading system and a vague trading style?`,
        options: [`The specificity and clarity of the rules`, `The historical profitability of the system`, `The number of technical indicators used`, `The frequency of executed trades`],
        correct: 0,
      },
      {
        q: `A trader has defined entry criteria, timeframes, and assets, but lacks explicit capital management. What is the main risk?`,
        options: [`Fewer trading opportunities available`, `Account destruction despite correct analysis`, `Inability to calculate Profit Factor`, `Reduction in the system's win rate`],
        correct: 1,
      },
      {
        q: `Which statement about System Expectancy is INCORRECT?`,
        options: [`It's calculated: (Win Rate × Average Gain) − (Loss Rate × Average Loss)`, `A positive result indicates long-term mathematical edge`, `A system with negative expectancy can be profitable if traded more frequently`, `It allows identifying if the system has real edge`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Aký je kľúčový rozdiel medzi obchodným systémom a nejasným štýlom obchodovania?`,
        options: [`Špecifickosť a jasnosť pravidiel`, `Historická ziskovosť systému`, `Počet použitých technických indikátorov`, `Frekvencia vykonaných obchodov`],
        correct: 0,
      },
      {
        q: `Trader má definované kritériá vstupu, timeframy a aktíva, ale chýba mu explicitné riadenie kapitálu. Aké je hlavné riziko?`,
        options: [`Menej dostupných obchodných príležitostí`, `Zničenie účtu napriek správnej analýze`, `Nemožnosť vypočítať Profit Factor`, `Zníženie win rate systému`],
        correct: 1,
      },
      {
        q: `Ktoré tvrdenie o Očakávanej Hodnote Systému je NESPRÁVNE?`,
        options: [`Vypočíta sa: (Win Rate × Priemerný Zisk) − (Loss Rate × Priemerná Strata)`, `Pozitívny výsledok indikuje dlhodobú matematickú výhodu`, `Systém s negatívnou očakávanou hodnotou môže byť ziskový, ak sa obchoduje častejšie`, `Umožňuje identifikovať, či má systém skutočnú výhodu`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Was ist der Hauptunterschied zwischen einem Trading-System und einem vagen Trading-Stil?`,
        options: [`Die Spezifität und Klarheit der Regeln`, `Die historische Rentabilität des Systems`, `Die Anzahl der verwendeten technischen Indikatoren`, `Die Häufigkeit der ausgeführten Operationen`],
        correct: 0,
      },
      {
        q: `Ein Trader hat seine Einstiegskriterien, Timeframes und Assets definiert, verfügt aber über kein explizites Kapitalmanagement. Was ist das Hauptrisiko?`,
        options: [`Geringere Anzahl von Trading-Gelegenheiten`, `Zerstörung des Kontos trotz korrekter Analyse`, `Unmöglichkeit, den Profit Factor zu berechnen`, `Reduzierung der Win Rate des Systems`],
        correct: 1,
      },
      {
        q: `Welche Aussage über die Systemerwartung ist FALSCH?`,
        options: [`Sie wird berechnet: (Win Rate × Durchschnittlicher Gewinn) − (Loss Rate × Durchschnittlicher Verlust)`, `Ein positives Ergebnis zeigt einen mathematischen Vorteil auf lange Sicht an`, `Ein System mit negativer Erwartung kann profitabel sein, wenn es häufiger gehandelt wird`, `Sie ermöglicht die Identifizierung, ob das System einen echten Edge hat`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `交易系统与模糊交易风格之间的关键区别是什么？`,
        options: [`规则的具体性和清晰度`, `系统的历史盈利能力`, `使用的技术指标数量`, `执行交易的频率`],
        correct: 0,
      },
      {
        q: `一个交易者已定义了入场标准、时间框架和资产，但缺乏明确的资金管理。主要风险是什么？`,
        options: [`交易机会数量减少`, `尽管分析正确仍会摧毁账户`, `无法计算盈利因子`, `系统胜率降低`],
        correct: 1,
      },
      {
        q: `关于系统期望值，以下哪项陈述是错误的？`,
        options: [`计算公式：(胜率 × 平均盈利) − (败率 × 平均亏损)`, `正值结果表明长期具有数学优势`, `期望值为负的系统如果交易更频繁可以盈利`, `可以识别系统是否具有真正优势`],
        correct: 2,
      },
    ],
  },
  L3_3: {
    es: [
      {
        q: `¿Qué incluye un backtest profesional correcto?`,
        options: [`Aplicar reglas mecánicamente, simular costos reales y probar en múltiples condiciones de mercado`, `Aplicar la estrategia en el pasado y ver si genera ganancias totales`, `Usar los mejores resultados del pasado para ajustar parámetros óptimos`, `Probar solo en mercados alcistas para maximizar el win rate histórico`],
        correct: 0,
      },
      {
        q: `¿Qué indica si un sistema es robusto según la metodología out-of-sample?`,
        options: [`Los resultados mejoran significativamente en el período out-of-sample`, `Los parámetros pueden ajustarse libremente sin afectar el resultado`, `Los resultados se mantienen en datos out-of-sample sin tocar parámetros`, `El sistema funciona solo en condiciones de baja volatilidad`],
        correct: 2,
      },
      {
        q: `¿Cuál afirmación sobre Look-Ahead Bias es INCORRECTA?`,
        options: [`Es el error más común en backtesting manual y automático`, `Ocurre al usar inconscientemente información futura al marcar señales`, `Se elimina usando TradingView Replay Mode vela por vela`, `Se elimina ajustando parámetros después de ver todo el gráfico histórico`],
        correct: 3,
      },
    ],
    en: [
      {
        q: `What does proper professional backtesting include?`,
        options: [`Mechanically apply rules, simulate real costs, and test in multiple market conditions`, `Apply the strategy in the past and see if it generates total profits`, `Use the best past results to adjust optimal parameters`, `Test only in bull markets to maximize historical win rate`],
        correct: 0,
      },
      {
        q: `What indicates a system is robust according to out-of-sample methodology?`,
        options: [`Results improve significantly in the out-of-sample period`, `Parameters can be freely adjusted without affecting the result`, `Results hold on out-of-sample data without touching parameters`, `The system works only in low volatility conditions`],
        correct: 2,
      },
      {
        q: `Which statement about Look-Ahead Bias is INCORRECT?`,
        options: [`It is the most common error in manual and automated backtesting`, `It occurs when unconsciously using future information when marking signals`, `It is eliminated by using TradingView Replay Mode candle by candle`, `It is eliminated by adjusting parameters after seeing the entire historical chart`],
        correct: 3,
      },
    ],
    sk: [
      {
        q: `Čo zahŕňa správny profesionálny backtesting?`,
        options: [`Mechanicky aplikovať pravidlá, simulovať reálne náklady a testovať v rôznych trhových podmienkach`, `Aplikovať stratégiu v minulosti a zistiť, či vytvára celkové zisky`, `Použiť najlepšie minulé výsledky na úpravu optimálnych parametrov`, `Testovať len v bull trhoch na maximalizáciu historického win rate`],
        correct: 0,
      },
      {
        q: `Čo indikuje, že systém je robustný podľa out-of-sample metodológie?`,
        options: [`Výsledky sa výrazne zlepšia v out-of-sample období`, `Parametre možno voľne upravovať bez ovplyvnenia výsledku`, `Výsledky vydržia na out-of-sample dátach bez zmeny parametrov`, `Systém funguje len v podmienkach nízkej volatility`],
        correct: 2,
      },
      {
        q: `Ktoré tvrdenie o Look-Ahead Bias je NESPRÁVNE?`,
        options: [`Je to najčastejšia chyba v manuálnom a automatizovanom backtestingu`, `Vzniká pri nevedomom použití budúcich informácií pri označovaní signálov`, `Eliminuje sa používaním TradingView Replay Mode sviečka po sviečke`, `Eliminuje sa úpravou parametrov po zobrazení celého historického grafu`],
        correct: 3,
      },
    ],
    de: [
      {
        q: `Was beinhaltet ein korrekter professioneller Backtest?`,
        options: [`Regeln mechanisch anwenden, reale Kosten simulieren und unter verschiedenen Marktbedingungen testen`, `Die Strategie in der Vergangenheit anwenden und prüfen, ob sie Gesamtgewinne generiert`, `Die besten Ergebnisse aus der Vergangenheit verwenden, um optimale Parameter anzupassen`, `Nur in Bullenmärkten testen, um die historische Win Rate zu maximieren`],
        correct: 0,
      },
      {
        q: `Was zeigt an, ob ein System laut der Out-of-Sample-Methodik robust ist?`,
        options: [`Die Ergebnisse verbessern sich signifikant im Out-of-Sample-Zeitraum`, `Die Parameter können frei angepasst werden, ohne das Ergebnis zu beeinflussen`, `Die Ergebnisse bleiben in Out-of-Sample-Daten stabil, ohne Parameter zu ändern`, `Das System funktioniert nur unter Bedingungen niedriger Volatilität`],
        correct: 2,
      },
      {
        q: `Welche Aussage über Look-Ahead Bias ist FALSCH?`,
        options: [`Es ist der häufigste Fehler beim manuellen und automatischen Backtesting`, `Es tritt auf, wenn unbewusst zukünftige Informationen beim Markieren von Signalen verwendet werden`, `Es wird durch die Verwendung des TradingView Replay Mode Kerze für Kerze eliminiert`, `Es wird eliminiert, indem Parameter angepasst werden, nachdem der gesamte historische Chart gesehen wurde`],
        correct: 3,
      },
    ],
    "zh-CN": [
      {
        q: `专业的回测应包括什么？`,
        options: [`机械化应用规则、模拟真实成本并在多种市场条件下测试`, `在过去应用策略并查看是否产生总体盈利`, `使用过去的最佳结果来调整最优参数`, `仅在牛市中测试以最大化历史胜率`],
        correct: 0,
      },
      {
        q: `根据样本外方法，什么表明系统是稳健的？`,
        options: [`样本外期间的结果显著改善`, `参数可以自由调整而不影响结果`, `在样本外数据中结果保持稳定且不调整参数`, `系统仅在低波动条件下有效`],
        correct: 2,
      },
      {
        q: `关于前视偏差，以下哪项陈述是错误的？`,
        options: [`这是手动和自动回测中最常见的错误`, `发生在标记信号时无意识地使用未来信息`, `通过使用TradingView重放模式逐根K线消除`, `通过在查看所有历史图表后调整参数来消除`],
        correct: 3,
      },
    ],
  },
  L3_4: {
    es: [
      {
        q: `¿Cuál es la función principal del diario de trading profesional?`,
        options: [`Registrar ganancias y pérdidas diarias para declaración fiscal`, `Sistema de retroalimentación que acelera el aprendizaje estructurado`, `Herramienta para compartir resultados en redes sociales`, `Método para calcular impuestos sobre operaciones de Bitcoin`],
        correct: 1,
      },
      {
        q: `Si tu Average R es 0.5R, ¿qué significa?`,
        options: [`Pierdes 0.5 veces tu capital en cada trade`, `Tu Win Rate es exactamente 50% en todos los casos`, `Cada trade produce en promedio 0.5 veces el riesgo arriesgado`, `Tu Profit Factor es inferior a 1.0 y pierdes dinero`],
        correct: 2,
      },
      {
        q: `¿Qué afirmación sobre métricas de trading es INCORRECTA?`,
        options: [`Recovery Factor relaciona ganancia neta con máximo drawdown`, `Win Rate solo es informativo si se combina con RRR`, `Un Profit Factor de 1.8 indica pérdidas consistentes mensuales`, `Maximum Drawdown es el indicador de riesgo más importante`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `What is the primary function of a professional trading journal?`,
        options: [`Recording daily gains and losses for tax declaration`, `Feedback system that accelerates structured learning`, `Tool for sharing results on social media platforms`, `Method for calculating taxes on Bitcoin operations`],
        correct: 1,
      },
      {
        q: `If your Average R is 0.5R, what does this mean?`,
        options: [`You lose 0.5 times your capital on each trade`, `Your Win Rate is exactly 50% in all cases`, `Each trade produces on average 0.5 times the risked amount`, `Your Profit Factor is below 1.0 and you lose money`],
        correct: 2,
      },
      {
        q: `Which statement about trading metrics is INCORRECT?`,
        options: [`Recovery Factor relates net profit to maximum drawdown`, `Win Rate is only informative when combined with RRR`, `A Profit Factor of 1.8 indicates consistent monthly losses`, `Maximum Drawdown is the most important risk indicator`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Aká je hlavná funkcia profesionálneho obchodného denníka?`,
        options: [`Zaznamenávanie denných ziskov a strát pre daňové priznanie`, `Systém spätnej väzby, ktorý urýchľuje štruktúrované učenie`, `Nástroj na zdieľanie výsledkov na sociálnych sieťach`, `Metóda na výpočet daní z Bitcoin operácií`],
        correct: 1,
      },
      {
        q: `Ak je váš Average R 0.5R, čo to znamená?`,
        options: [`Strácate 0.5-násobok kapitálu pri každom obchode`, `Váš Win Rate je presne 50% vo všetkých prípadoch`, `Každý obchod v priemere produkuje 0.5-násobok riskovanej sumy`, `Váš Profit Factor je pod 1.0 a strácate peniaze`],
        correct: 2,
      },
      {
        q: `Ktoré tvrdenie o obchodných metrikách je NESPRÁVNE?`,
        options: [`Recovery Factor vzťahuje čistý zisk k maximálnemu drawdownu`, `Win Rate je informatívny len v kombinácii s RRR`, `Profit Factor 1.8 indikuje konzistentné mesačné straty`, `Maximum Drawdown je najdôležitejší indikátor rizika`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Was ist die Hauptfunktion eines professionellen Trading-Tagebuchs?`,
        options: [`Tägliche Gewinne und Verluste für die Steuererklärung erfassen`, `Feedback-System, das strukturiertes Lernen beschleunigt`, `Werkzeug zum Teilen von Ergebnissen in sozialen Medien`, `Methode zur Berechnung von Steuern auf Bitcoin-Transaktionen`],
        correct: 1,
      },
      {
        q: `Wenn dein Average R 0.5R beträgt, was bedeutet das?`,
        options: [`Du verlierst 0.5-mal dein Kapital bei jedem Trade`, `Deine Win Rate beträgt in allen Fällen genau 50%`, `Jeder Trade erzeugt im Durchschnitt das 0.5-fache des eingegangenen Risikos`, `Dein Profit Factor liegt unter 1.0 und du verlierst Geld`],
        correct: 2,
      },
      {
        q: `Welche Aussage über Trading-Metriken ist FALSCH?`,
        options: [`Recovery Factor setzt Nettogewinn in Beziehung zum maximalen Drawdown`, `Win Rate ist nur informativ, wenn sie mit RRR kombiniert wird`, `Ein Profit Factor von 1.8 zeigt konsistente monatliche Verluste an`, `Maximum Drawdown ist der wichtigste Risikoindikator`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `专业交易日志的主要功能是什么?`,
        options: [`记录每日盈亏用于税务申报`, `加速结构化学习的反馈系统`, `在社交媒体上分享结果的工具`, `计算Bitcoin交易税款的方法`],
        correct: 1,
      },
      {
        q: `如果你的Average R是0.5R,这意味着什么?`,
        options: [`每笔交易你损失0.5倍的资金`, `你的Win Rate在所有情况下都恰好是50%`, `每笔交易平均产生0.5倍的风险回报`, `你的Profit Factor低于1.0并且在亏损`],
        correct: 2,
      },
      {
        q: `关于交易指标,哪个说法是错误的?`,
        options: [`Recovery Factor将净收益与最大回撤关联`, `Win Rate只有与RRR结合才有参考意义`, `Profit Factor为1.8表示每月持续亏损`, `Maximum Drawdown是最重要的风险指标`],
        correct: 2,
      },
    ],
  },
  L3_5: {
    es: [
      {
        q: `¿Qué calcula el Método de Kelly en gestión de capital?`,
        options: [`El tamaño óptimo de posición para maximizar el crecimiento logarítmico del capital`, `El límite de pérdida diaria basado en volatilidad histórica`, `La correlación Pearson entre activos del portafolio`, `El umbral de beneficio acumulado para aumentar posición`],
        correct: 0,
      },
      {
        q: `¿Por qué los profesionales usan Half-Kelly en lugar de Kelly completo?`,
        options: [`Porque Kelly completo no funciona en mercados crypto`, `Para reducir la volatilidad del capital a niveles aceptables`, `Porque Half-Kelly maximiza el RRR del sistema`, `Para aumentar el win rate por encima del 55%`],
        correct: 1,
      },
      {
        q: `Si tienes 5 trades abiertos con 1% de riesgo cada uno en activos altamente correlacionados con BTC, ¿cuál es el problema real?`,
        options: [`El riesgo total aparente de 5% está correctamente calculado`, `Deberías usar Fixed Ratio en lugar de Fixed Fractional`, `Un evento adverso común puede activar el 4-5% de riesgo simultáneamente`, `La correlación Pearson debe ser mayor a 0.6 para diversificar`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `What does the Kelly Method calculate in capital management?`,
        options: [`The optimal position size to maximize logarithmic capital growth`, `The daily loss limit based on historical volatility`, `The Pearson correlation between portfolio assets`, `The accumulated profit threshold to increase position`],
        correct: 0,
      },
      {
        q: `Why do professionals use Half-Kelly instead of full Kelly?`,
        options: [`Because full Kelly doesn't work in crypto markets`, `To reduce capital volatility to acceptable levels`, `Because Half-Kelly maximizes the system's RRR`, `To increase the win rate above 55%`],
        correct: 1,
      },
      {
        q: `If you have 5 open trades with 1% risk each in assets highly correlated with BTC, what's the real problem?`,
        options: [`The apparent total risk of 5% is correctly calculated`, `You should use Fixed Ratio instead of Fixed Fractional`, `A common adverse event can trigger 4-5% risk simultaneously`, `Pearson correlation should be above 0.6 for diversification`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Čo vypočíta Kellyho metóda v riadení kapitálu?`,
        options: [`Optimálnu veľkosť pozície na maximalizáciu logaritmického rastu kapitálu`, `Denný limit straty založený na historickej volatilite`, `Pearsonovu koreláciu medzi aktívami portfólia`, `Prah akumulovaného zisku na zvýšenie pozície`],
        correct: 0,
      },
      {
        q: `Prečo profesionáli používajú Half-Kelly namiesto plného Kelly?`,
        options: [`Pretože plný Kelly nefunguje na crypto trhoch`, `Na zníženie volatility kapitálu na akceptovateľné úrovne`, `Pretože Half-Kelly maximalizuje RRR systému`, `Na zvýšenie win rate nad 55%`],
        correct: 1,
      },
      {
        q: `Ak máš 5 otvorených tradov s 1% rizikom každý v aktívach vysoko korelovaných s BTC, aký je reálny problém?`,
        options: [`Zdanlivé celkové riziko 5% je správne vypočítané`, `Mal by si použiť Fixed Ratio namiesto Fixed Fractional`, `Spoločná nepriaznivá udalosť môže aktivovať 4-5% rizika súčasne`, `Pearsonova korelácia by mala byť nad 0.6 pre diverzifikáciu`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Was berechnet die Kelly-Methode im Kapitalmanagement?`,
        options: [`Die optimale Positionsgröße zur Maximierung des logarithmischen Kapitalwachstums`, `Das tägliche Verlustlimit basierend auf historischer Volatilität`, `Die Pearson-Korrelation zwischen Portfolio-Assets`, `Die Gewinnschwelle für eine Positionserhöhung`],
        correct: 0,
      },
      {
        q: `Warum verwenden Profis Half-Kelly anstelle von vollem Kelly?`,
        options: [`Weil volles Kelly in Kryptomärkten nicht funktioniert`, `Um die Kapitalvolatilität auf akzeptable Niveaus zu reduzieren`, `Weil Half-Kelly das RRR des Systems maximiert`, `Um die Win Rate über 55% zu erhöhen`],
        correct: 1,
      },
      {
        q: `Wenn du 5 offene Trades mit jeweils 1% Risiko in Assets hast, die stark mit BTC korrelieren, was ist das eigentliche Problem?`,
        options: [`Das scheinbare Gesamtrisiko von 5% ist korrekt berechnet`, `Du solltest Fixed Ratio statt Fixed Fractional verwenden`, `Ein gemeinsames negatives Ereignis kann 4-5% Risiko gleichzeitig auslösen`, `Die Pearson-Korrelation muss über 0.6 liegen, um zu diversifizieren`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `Kelly方法在资金管理中计算什么?`,
        options: [`最优仓位大小以最大化资金的对数增长`, `基于历史波动率的每日亏损限额`, `投资组合中资产之间的Pearson相关性`, `增加仓位的累计收益阈值`],
        correct: 0,
      },
      {
        q: `为什么专业交易者使用Half-Kelly而不是完整Kelly?`,
        options: [`因为完整Kelly在crypto市场不起作用`, `为了将资金波动率降低到可接受水平`, `因为Half-Kelly最大化系统的RRR`, `为了将win rate提高到55%以上`],
        correct: 1,
      },
      {
        q: `如果你有5笔开仓交易,每笔风险1%,且资产与BTC高度相关,真正的问题是什么?`,
        options: [`表面上5%的总风险计算是正确的`, `你应该使用Fixed Ratio而不是Fixed Fractional`, `一个共同的不利事件可能同时触发4-5%的风险`, `Pearson相关性必须大于0.6才能分散风险`],
        correct: 2,
      },
    ],
  },
  L3_6: {
    es: [
      {
        q: `¿Qué ganancia necesitas para recuperarte de un drawdown del 50%?`,
        options: [`50% de ganancia`, `100% de ganancia`, `75% de ganancia`, `25% de ganancia`],
        correct: 1,
      },
      {
        q: `¿Cuál es la respuesta correcta ante un drawdown por cambio de régimen de mercado?`,
        options: [`Aumentar el tamaño de posición para recuperar más rápido`, `Cerrar todas las posiciones y abandonar el sistema`, `Reducir tamaño al 50% e identificar el régimen actual`, `Mantener el mismo tamaño hasta volver al máximo`],
        correct: 2,
      },
      {
        q: `Un sistema con 60% win rate que pierde 7-10 trades consecutivos es indicativo de:`,
        options: [`El sistema dejó de funcionar y debe ser cambiado`, `Drawdown normal estadísticamente esperado del sistema`, `Error grave de proceso que requiere pausa inmediata`, `Cambio de régimen de mercado estructural`],
        correct: 1,
      },
    ],
    en: [
      {
        q: `What gain do you need to recover from a 50% drawdown?`,
        options: [`50% gain`, `100% gain`, `75% gain`, `25% gain`],
        correct: 1,
      },
      {
        q: `What is the correct response to a market regime change drawdown?`,
        options: [`Increase position size to recover faster`, `Close all positions and abandon the system`, `Reduce size to 50% and identify current regime`, `Maintain same size until returning to peak`],
        correct: 2,
      },
      {
        q: `A system with 60% win rate losing 7-10 consecutive trades indicates:`,
        options: [`The system stopped working and must be changed`, `Normal statistically expected system drawdown`, `Serious process error requiring immediate pause`, `Structural market regime change`],
        correct: 1,
      },
    ],
    sk: [
      {
        q: `Aký zisk potrebuješ na zotavenie z 50% drawdownu?`,
        options: [`50% zisk`, `100% zisk`, `75% zisk`, `25% zisk`],
        correct: 1,
      },
      {
        q: `Aká je správna odpoveď na drawdown v dôsledku zmeny trhového režimu?`,
        options: [`Zvýšiť veľkosť pozície pre rýchlejšie zotavenie`, `Zavrieť všetky pozície a opustiť systém`, `Zmenšiť pozíciu na 50% a identifikovať aktuálny režim`, `Udržať rovnakú veľkosť až do návratu na maximum`],
        correct: 2,
      },
      {
        q: `Systém s 60% win rate strácajúci 7-10 po sebe idúcich obchodov naznačuje:`,
        options: [`Systém prestal fungovať a musí byť zmenený`, `Normálny štatisticky očakávaný systémový drawdown`, `Vážnu chybu procesu vyžadujúcu okamžitú pauzu`, `Štrukturálnu zmenu trhového režimu`],
        correct: 1,
      },
    ],
    de: [
      {
        q: `Welchen Gewinn benötigst du, um dich von einem Drawdown von 50% zu erholen?`,
        options: [`50% Gewinn`, `100% Gewinn`, `75% Gewinn`, `25% Gewinn`],
        correct: 1,
      },
      {
        q: `Was ist die richtige Reaktion auf einen Drawdown durch Marktregimewechsel?`,
        options: [`Positionsgröße erhöhen, um schneller zu erholen`, `Alle Positionen schließen und das System aufgeben`, `Größe auf 50% reduzieren und aktuelles Regime identifizieren`, `Gleiche Größe beibehalten, bis das Maximum wieder erreicht ist`],
        correct: 2,
      },
      {
        q: `Ein System mit 60% Win Rate, das 7-10 Trades hintereinander verliert, ist ein Hinweis auf:`,
        options: [`Das System funktioniert nicht mehr und muss geändert werden`, `Statistisch erwarteter normaler Drawdown des Systems`, `Schwerwiegender Prozessfehler, der sofortige Pause erfordert`, `Struktureller Marktregimewechsel`],
        correct: 1,
      },
    ],
    "zh-CN": [
      {
        q: `从50%的回撤中恢复需要多少收益?`,
        options: [`50%的收益`, `100%的收益`, `75%的收益`, `25%的收益`],
        correct: 1,
      },
      {
        q: `面对市场机制变化导致的回撤,正确的应对是什么?`,
        options: [`增加仓位大小以更快恢复`, `平掉所有仓位并放弃系统`, `将仓位减少至50%并识别当前机制`, `保持相同仓位直到回到最高点`],
        correct: 2,
      },
      {
        q: `一个60% win rate的系统连续亏损7-10笔交易表明:`,
        options: [`系统失效必须更换`, `统计上预期的正常回撤`, `需要立即暂停的严重流程错误`, `结构性市场机制变化`],
        correct: 1,
      },
    ],
  },
  L3_7: {
    es: [
      {
        q: `¿Qué componente NO es parte del umbral de rentabilidad real de un trader profesional?`,
        options: [`Fees de trading y subscripciones de plataformas`, `Hardware, monitores e internet de calidad`, `Ganancias brutas obtenidas en el año`, `Educación continua, libros y mentores`],
        correct: 2,
      },
      {
        q: `Si un trader gana $10,000 al año pero tiene $8,000 en costos operativos, ¿cuál es su beneficio neto?`,
        options: [`$18,000 — suma de ingresos y costos`, `$10,000 — las ganancias brutas`, `$2,000 — ingresos menos costos`, `$8,000 — el total de los costos`],
        correct: 2,
      },
      {
        q: `¿Cuál es la acción correcta si un trader profesional tiene sueño insuficiente antes de la sesión?`,
        options: [`Operar con menor tamaño de posición ese día`, `No operar ese día por condiciones subóptimas`, `Operar solo en timeframes más altos`, `Configurar alertas y operar de forma automática`],
        correct: 1,
      },
    ],
    en: [
      {
        q: `Which component is NOT part of a professional trader's real breakeven threshold?`,
        options: [`Trading fees and platform subscriptions`, `Hardware, monitors, and quality internet`, `Gross profits earned during the year`, `Continuing education, books, and mentors`],
        correct: 2,
      },
      {
        q: `If a trader earns $10,000 per year but has $8,000 in operating costs, what is their net profit?`,
        options: [`$18,000 — sum of revenue and costs`, `$10,000 — the gross earnings`, `$2,000 — revenue minus costs`, `$8,000 — the total costs`],
        correct: 2,
      },
      {
        q: `What is the correct action if a professional trader has insufficient sleep before the session?`,
        options: [`Trade with smaller position size that day`, `Not trade that day due to suboptimal conditions`, `Only trade on higher timeframes`, `Set alerts and trade automatically`],
        correct: 1,
      },
    ],
    sk: [
      {
        q: `Ktorý komponent NIE JE súčasťou skutočného prahu ziskovosti profesionálneho tradera?`,
        options: [`Tradingové poplatky a predplatné platforiem`, `Hardvér, monitory a kvalitný internet`, `Hrubé zisky získané počas roka`, `Kontinuálne vzdelávanie, knihy a mentori`],
        correct: 2,
      },
      {
        q: `Ak trader zarobí $10,000 ročne, ale má $8,000 prevádzkových nákladov, aký je jeho čistý zisk?`,
        options: [`$18,000 — súčet príjmov a nákladov`, `$10,000 — hrubé zisky`, `$2,000 — príjmy mínus náklady`, `$8,000 — celkové náklady`],
        correct: 2,
      },
      {
        q: `Aká je správna akcia, ak má profesionálny trader nedostatok spánku pred reláciou?`,
        options: [`Obchodovať s menšou veľkosťou pozície ten deň`, `Neobchodovať ten deň kvôli suboptimálnym podmienkam`, `Obchodovať len na vyšších timeframe-och`, `Nastaviť upozornenia a obchodovať automaticky`],
        correct: 1,
      },
    ],
    de: [
      {
        q: `Welche Komponente ist NICHT Teil der tatsächlichen Rentabilitätsschwelle eines professionellen Traders?`,
        options: [`Trading-Gebühren und Plattform-Abonnements`, `Hardware, Monitore und qualitatives Internet`, `Im Jahr erzielte Bruttogewinne`, `Kontinuierliche Weiterbildung, Bücher und Mentoren`],
        correct: 2,
      },
      {
        q: `Wenn ein Trader $10.000 pro Jahr verdient, aber $8.000 an Betriebskosten hat, wie hoch ist sein Nettogewinn?`,
        options: [`$18.000 — Summe aus Einnahmen und Kosten`, `$10.000 — die Bruttogewinne`, `$2.000 — Einnahmen minus Kosten`, `$8.000 — die Gesamtkosten`],
        correct: 2,
      },
      {
        q: `Was ist die richtige Vorgehensweise, wenn ein professioneller Trader vor der Session unzureichend geschlafen hat?`,
        options: [`An diesem Tag mit kleinerer Positionsgröße handeln`, `An diesem Tag aufgrund suboptimaler Bedingungen nicht handeln`, `Nur auf höheren Timeframes handeln`, `Alarme einrichten und automatisch handeln`],
        correct: 1,
      },
    ],
    "zh-CN": [
      {
        q: `哪个组成部分不属于专业交易员的实际盈亏平衡点？`,
        options: [`交易手续费和平台订阅费`, `硬件、显示器和优质网络`, `年度获得的总收益`, `持续教育、书籍和导师`],
        correct: 2,
      },
      {
        q: `如果一个交易员年收入$10,000但运营成本为$8,000，他的净利润是多少？`,
        options: [`$18,000 — 收入和成本的总和`, `$10,000 — 总收益`, `$2,000 — 收入减去成本`, `$8,000 — 成本总额`],
        correct: 2,
      },
      {
        q: `如果专业交易员在交易时段前睡眠不足，正确的做法是什么？`,
        options: [`当天以较小的仓位进行交易`, `因条件不理想当天不交易`, `只在更高时间框架交易`, `设置提醒并自动交易`],
        correct: 1,
      },
    ],
  },
  L4_0: {
    es: [
      {
        q: `¿Cuál es la principal diferencia entre futuros perpetuos y futuros tradicionales?`,
        options: [`Los perpetuos no tienen fecha de vencimiento y nunca expiran`, `Los perpetuos solo se pueden operar en exchanges descentralizados`, `Los perpetuos tienen menor apalancamiento disponible que los tradicionales`, `Los perpetuos no permiten posiciones cortas (short)`],
        correct: 0,
      },
      {
        q: `Con 10x de apalancamiento en BTC a $42,000, ¿aproximadamente a qué precio se liquida un long?`,
        options: [`$46,200 — un alza del 10%`, `$38,010 — una caída del 9.5%`, `$21,000 — una caída del 50%`, `$40,740 — una caída del 3%`],
        correct: 1,
      },
      {
        q: `¿Qué afirmación sobre el funding rate es INCORRECTA?`,
        options: [`Se cobra cada 8 horas entre traders de perpetuos`, `Cuando el perpetuo cotiza caro, los longs pagan a los shorts`, `El funding rate determina directamente el precio de liquidación`, `Para posiciones largas, el funding acumulado puede ser significativo`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `What is the main difference between perpetual futures and traditional futures?`,
        options: [`Perpetuals have no expiration date and never expire`, `Perpetuals can only be traded on decentralized exchanges`, `Perpetuals have lower available leverage than traditional futures`, `Perpetuals do not allow short positions`],
        correct: 0,
      },
      {
        q: `With 10x leverage on BTC at $42,000, at approximately what price is a long liquidated?`,
        options: [`$46,200 — a 10% rise`, `$38,010 — a 9.5% drop`, `$21,000 — a 50% drop`, `$40,740 — a 3% drop`],
        correct: 1,
      },
      {
        q: `Which statement about the funding rate is INCORRECT?`,
        options: [`It is charged every 8 hours between perpetual traders`, `When the perpetual trades expensive, longs pay shorts`, `The funding rate directly determines the liquidation price`, `For long-term positions, accumulated funding can be significant`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Aký je hlavný rozdiel medzi perpetuálnymi futures a tradičnými futures?`,
        options: [`Perpetuálne nemajú dátum exspirácie a nikdy nevyprší`, `Perpetuálne sa dajú obchodovať len na decentralizovaných burzách`, `Perpetuálne majú nižší dostupný pákový efekt než tradičné`, `Perpetuálne neumožňujú krátke pozície (short)`],
        correct: 0,
      },
      {
        q: `S 10x pákovým efektom na BTC pri $42,000, pri akej cene sa zlikviduje long?`,
        options: [`$46,200 — nárast o 10%`, `$38,010 — pokles o 9.5%`, `$21,000 — pokles o 50%`, `$40,740 — pokles o 3%`],
        correct: 1,
      },
      {
        q: `Ktoré tvrdenie o funding rate je NESPRÁVNE?`,
        options: [`Účtuje sa každých 8 hodín medzi obchodníkmi perpetuálov`, `Keď sa perpetuál obchoduje draho, longy platia shortom`, `Funding rate priamo určuje likvidačnú cenu pozície`, `Pri dlhodobých pozíciách môže byť akumulovaný funding významný`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Was ist der Hauptunterschied zwischen Perpetual Futures und traditionellen Futures?`,
        options: [`Perpetuals haben kein Verfallsdatum und laufen nie ab`, `Perpetuals können nur auf dezentralen Exchanges gehandelt werden`, `Perpetuals haben weniger verfügbare Hebelwirkung als traditionelle`, `Perpetuals erlauben keine SHORT-Positionen`],
        correct: 0,
      },
      {
        q: `Mit 10x Hebelwirkung bei BTC zu $42.000, bei welchem Preis wird ungefähr ein LONG liquidiert?`,
        options: [`$46.200 — ein Anstieg von 10%`, `$38.010 — ein Rückgang von 9,5%`, `$21.000 — ein Rückgang von 50%`, `$40.740 — ein Rückgang von 3%`],
        correct: 1,
      },
      {
        q: `Welche Aussage über den Funding Rate ist FALSCH?`,
        options: [`Er wird alle 8 Stunden zwischen Perpetual-Tradern berechnet`, `Wenn der Perpetual teuer notiert, zahlen LONGs an SHORTs`, `Der Funding Rate bestimmt direkt den Liquidationspreis`, `Bei langen Positionen kann der akkumulierte Funding signifikant sein`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `永续合约和传统期货的主要区别是什么？`,
        options: [`永续合约没有到期日且永不过期`, `永续合约只能在去中心化交易所交易`, `永续合约的可用杠杆低于传统期货`, `永续合约不允许做空(SHORT)`],
        correct: 0,
      },
      {
        q: `在BTC价格为$42,000时使用10x杠杆做多，大约在什么价格会被强制平仓？`,
        options: [`$46,200 — 上涨10%`, `$38,010 — 下跌9.5%`, `$21,000 — 下跌50%`, `$40,740 — 下跌3%`],
        correct: 1,
      },
      {
        q: `关于资金费率，哪个说法是错误的？`,
        options: [`永续合约交易者之间每8小时收取一次`, `当永续合约溢价时，多头向空头支付`, `资金费率直接决定强制平仓价格`, `对于多头仓位，累积的资金费用可能很可观`],
        correct: 2,
      },
    ],
  },
  L4_1: {
    es: [
      {
        q: `¿Cuál es la pérdida máxima para el comprador de una opción?`,
        options: [`La prima pagada por la opción`, `El precio del subyacente menos el strike price`, `Es ilimitada si el mercado va en contra`, `El valor total del activo subyacente`],
        correct: 0,
      },
      {
        q: `Si compras un Call con Delta 0.5 y Bitcoin sube $100, ¿cuánto aumenta aproximadamente el valor de tu opción?`,
        options: [`$100`, `$25`, `$50`, `$75`],
        correct: 2,
      },
      {
        q: `¿Cuál afirmación sobre Theta es INCORRECTA?`,
        options: [`Theta representa la pérdida de valor por paso del tiempo`, `El comprador de opciones sufre el efecto negativo de Theta`, `Theta aumenta el valor de las opciones cerca de expiración`, `El vendedor de opciones se beneficia del time decay`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `What is the maximum loss for an option buyer?`,
        options: [`The premium paid for the option`, `The underlying price minus the strike price`, `It is unlimited if the market moves against them`, `The full value of the underlying asset`],
        correct: 0,
      },
      {
        q: `If you buy a Call with Delta 0.5 and Bitcoin rises $100, how much does your option value increase approximately?`,
        options: [`$100`, `$25`, `$50`, `$75`],
        correct: 2,
      },
      {
        q: `Which statement about Theta is INCORRECT?`,
        options: [`Theta represents the value loss due to time passing`, `The option buyer suffers the negative effect of Theta`, `Theta increases option value near expiration`, `The option seller benefits from time decay`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Aká je maximálna strata pre kupujúceho opcie?`,
        options: [`Prémia zaplatená za opciu`, `Cena podkladového aktíva mínus strike price`, `Je neobmedzená, ak sa trh pohne proti nemu`, `Celková hodnota podkladového aktíva`],
        correct: 0,
      },
      {
        q: `Ak kúpite Call s Deltou 0,5 a Bitcoin vzrastie o $100, o koľko približne vzrastie hodnota vašej opcie?`,
        options: [`$100`, `$25`, `$50`, `$75`],
        correct: 2,
      },
      {
        q: `Ktoré tvrdenie o Theta je NESPRÁVNE?`,
        options: [`Theta predstavuje stratu hodnoty v dôsledku plynúceho času`, `Kupujúci opcie trpí negatívnym efektom Theta`, `Theta zvyšuje hodnotu opcií blízko expirácie`, `Predávajúci opcie profituje z time decay`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Was ist der maximale Verlust für den Käufer einer Option?`,
        options: [`Die für die Option gezahlte Prämie`, `Der Preis des Basiswerts minus Strike Price`, `Er ist unbegrenzt, wenn der Markt sich entgegen bewegt`, `Der Gesamtwert des zugrunde liegenden Vermögenswerts`],
        correct: 0,
      },
      {
        q: `Wenn du einen Call mit Delta 0,5 kaufst und Bitcoin um $100 steigt, um wie viel steigt ungefähr der Wert deiner Option?`,
        options: [`$100`, `$25`, `$50`, `$75`],
        correct: 2,
      },
      {
        q: `Welche Aussage über Theta ist FALSCH?`,
        options: [`Theta stellt den Wertverlust durch Zeitablauf dar`, `Der Optionskäufer erleidet den negativen Effekt von Theta`, `Theta erhöht den Wert der Optionen nahe dem Verfall`, `Der Optionsverkäufer profitiert vom Time Decay`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `期权买方的最大损失是多少？`,
        options: [`支付的期权费`, `标的资产价格减去行权价`, `如果市场走势相反则无限`, `标的资产的总价值`],
        correct: 0,
      },
      {
        q: `如果你买入Delta为0.5的Call期权，Bitcoin上涨$100，你的期权价值大约增加多少？`,
        options: [`$100`, `$25`, `$50`, `$75`],
        correct: 2,
      },
      {
        q: `关于Theta，哪个说法是错误的？`,
        options: [`Theta代表时间流逝造成的价值损失`, `期权买方承受Theta的负面影响`, `Theta在临近到期时增加期权价值`, `期权卖方从时间衰减中获益`],
        correct: 2,
      },
    ],
  },
  L4_2: {
    es: [
      {
        q: `¿Cuál es el objetivo principal del hedging institucional?`,
        options: [`Reducir la exposición a movimientos adversos del precio`, `Maximizar las ganancias en mercados alcistas`, `Aumentar el apalancamiento de las posiciones existentes`, `Eliminar completamente el riesgo de mercado`],
        correct: 0,
      },
      {
        q: `Si tienes 10 BTC spot y abres un short de 5 BTC en futuros, ¿qué estrategia aplicas?`,
        options: [`Delta Hedging total con posición completamente neutral`, `Delta Hedging parcial reduciendo exposición direccional al 50%`, `Pair Trading entre spot y futuros de Bitcoin`, `Cash-and-Carry Arbitrage con prima de futuros`],
        correct: 1,
      },
      {
        q: `¿Cuál afirmación sobre Delta Hedging con futuros es INCORRECTA?`,
        options: [`Neutraliza la exposición direccional al precio del activo`, `Permite capturar otros retornos como basis o funding rate`, `Elimina todos los costos incluyendo funding en mercados positivos`, `Es usada por market makers para neutralizar riesgo direccional`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `What is the primary objective of institutional hedging?`,
        options: [`Reduce exposure to adverse price movements`, `Maximize gains in bullish markets`, `Increase leverage on existing positions`, `Completely eliminate market risk`],
        correct: 0,
      },
      {
        q: `If you hold 10 BTC spot and open a 5 BTC short in futures, what strategy are you applying?`,
        options: [`Full Delta Hedging with completely neutral position`, `Partial Delta Hedging reducing directional exposure by 50%`, `Pair Trading between Bitcoin spot and futures`, `Cash-and-Carry Arbitrage with futures premium`],
        correct: 1,
      },
      {
        q: `Which statement about Delta Hedging with futures is INCORRECT?`,
        options: [`It neutralizes directional exposure to asset price`, `It allows capturing other returns like basis or funding rate`, `It eliminates all costs including funding in positive markets`, `It is used by market makers to neutralize directional risk`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Aký je hlavný cieľ inštitucionálneho hedgingu?`,
        options: [`Znížiť expozíciu voči nepriaznivým cenovým pohybom`, `Maximalizovať zisky na bullish trhoch`, `Zvýšiť páku na existujúcich pozíciách`, `Úplne eliminovať trhové riziko`],
        correct: 0,
      },
      {
        q: `Ak držíte 10 BTC spot a otvoríte short 5 BTC vo futures, akú stratégiu aplikujete?`,
        options: [`Úplný Delta Hedging s kompletne neutrálnou pozíciou`, `Čiastočný Delta Hedging znižujúci smerovú expozíciu o 50%`, `Pair Trading medzi Bitcoin spot a futures`, `Cash-and-Carry Arbitráž s prémiou futures`],
        correct: 1,
      },
      {
        q: `Ktoré tvrdenie o Delta Hedging s futures je NESPRÁVNE?`,
        options: [`Neutralizuje smerovú expozíciu voči cene aktíva`, `Umožňuje zachytiť iné výnosy ako basis alebo funding rate`, `Eliminuje všetky náklady vrátane fundingu na pozitívnych trhoch`, `Používajú ho market makers na neutralizáciu smerového rizika`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Was ist das Hauptziel des institutionellen Hedging?`,
        options: [`Reduzierung der Exposition gegenüber nachteiligen Preisbewegungen`, `Maximierung der Gewinne in Bullenmärkten`, `Erhöhung des Hebels bestehender Positionen`, `Vollständige Eliminierung des Marktrisikos`],
        correct: 0,
      },
      {
        q: `Wenn du 10 BTC spot hältst und einen SHORT von 5 BTC in Futures eröffnest, welche Strategie wendest du an?`,
        options: [`Vollständiges Delta Hedging mit komplett neutraler Position`, `Partielles Delta Hedging mit Reduzierung der direktionalen Exposition auf 50%`, `Pair Trading zwischen Spot und Bitcoin-Futures`, `Cash-and-Carry Arbitrage mit Futures-Prämie`],
        correct: 1,
      },
      {
        q: `Welche Aussage über Delta Hedging mit Futures ist FALSCH?`,
        options: [`Neutralisiert die direktionale Exposition gegenüber dem Preis des Vermögenswerts`, `Ermöglicht die Erfassung anderer Renditen wie Basis oder Funding Rate`, `Eliminiert alle Kosten einschließlich Funding in positiven Märkten`, `Wird von Market Makern zur Neutralisierung des direktionalen Risikos verwendet`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `机构对冲的主要目标是什么？`,
        options: [`降低价格不利波动的风险敞口`, `在牛市中最大化收益`, `增加现有仓位的杠杆`, `完全消除市场风险`],
        correct: 0,
      },
      {
        q: `如果你持有10 BTC现货并开设5 BTC期货空头，你采用的是什么策略？`,
        options: [`完全Delta Hedging，仓位完全中性`, `部分Delta Hedging，将方向性敞口降低50%`, `比特币现货与期货之间的配对交易`, `利用期货溢价的Cash-and-Carry套利`],
        correct: 1,
      },
      {
        q: `关于使用期货进行Delta Hedging，以下哪项陈述是错误的？`,
        options: [`中和资产价格的方向性敞口`, `允许捕获其他收益，如基差或资金费率`, `消除所有成本，包括正向市场中的资金费率`, `被做市商用于中和方向性风险`],
        correct: 2,
      },
    ],
  },
  L4_3: {
    es: [
      {
        q: `¿Cuál es la asignación típica de Bitcoin en un portfolio cripto institucional según MPT?`,
        options: [`50-60% por su madurez, liquidez y adopción institucional`, `20-25% como complemento a Ethereum`, `80-90% para maximizar retorno absoluto`, `10-15% junto con otras Large Cap Altcoins`],
        correct: 0,
      },
      {
        q: `Un portfolio con 50% BTC objetivo ahora tiene 65% BTC por apreciación. ¿Qué hace el rebalanceo?`,
        options: [`Mantiene BTC en 65% porque está ganando`, `Vende parte de BTC y compra activos bajo objetivo`, `Compra más BTC para aprovechar momentum`, `Convierte todo a stablecoins hasta que se estabilice`],
        correct: 1,
      },
      {
        q: `¿Qué limitación tiene la diversificación dentro del ecosistema cripto según la lección?`,
        options: [`Los costos de transacción son demasiado altos`, `No existen suficientes activos líquidos para diversificar`, `La correlación extremadamente alta entre activos limita los beneficios`, `Modern Portfolio Theory no aplica a activos digitales`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `What is the typical Bitcoin allocation in an institutional crypto portfolio per MPT?`,
        options: [`50-60% due to its maturity, liquidity and institutional adoption`, `20-25% as complement to Ethereum`, `80-90% to maximize absolute return`, `10-15% alongside other Large Cap Altcoins`],
        correct: 0,
      },
      {
        q: `A portfolio with 50% BTC target now has 65% BTC due to appreciation. What does rebalancing do?`,
        options: [`Keeps BTC at 65% because it is winning`, `Sells part of BTC and buys assets below target`, `Buys more BTC to capture momentum`, `Converts everything to stablecoins until it stabilizes`],
        correct: 1,
      },
      {
        q: `What limitation does diversification within the crypto ecosystem have per the lesson?`,
        options: [`Transaction costs are too high`, `Not enough liquid assets exist to diversify`, `Extremely high correlation between assets limits benefits`, `Modern Portfolio Theory does not apply to digital assets`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Aká je typická alokácia Bitcoin v inštitucionálnom krypto portfóliu podľa MPT?`,
        options: [`50-60% pre jeho zrelosť, likviditu a inštitucionálnu adopciu`, `20-25% ako doplnok k Ethereum`, `80-90% na maximalizáciu absolútneho výnosu`, `10-15% spolu s inými Large Cap Altcoins`],
        correct: 0,
      },
      {
        q: `Portfólio s 50% BTC cieľom má teraz 65% BTC kvôli zhodnoteniu. Čo robí rebalancovanie?`,
        options: [`Ponecháva BTC na 65%, pretože rastie`, `Predá časť BTC a kúpi aktíva pod cieľom`, `Nakúpi viac BTC na využitie momentum`, `Prevedie všetko na stablecoiny, kým sa nestabilizuje`],
        correct: 1,
      },
      {
        q: `Aké obmedzenie má diverzifikácia v rámci krypto ekosystému podľa lekcie?`,
        options: [`Transakčné náklady sú príliš vysoké`, `Neexistuje dostatok likvidných aktív na diverzifikáciu`, `Extrémne vysoká korelácia medzi aktívami obmedzuje výhody`, `Modern Portfolio Theory neplatí pre digitálne aktíva`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Was ist die typische Bitcoin-Allokation in einem institutionellen Krypto-Portfolio gemäß MPT?`,
        options: [`50-60% aufgrund seiner Reife, Liquidität und institutionellen Akzeptanz`, `20-25% als Ergänzung zu Ethereum`, `80-90% zur Maximierung der absoluten Rendite`, `10-15% zusammen mit anderen Large Cap Altcoins`],
        correct: 0,
      },
      {
        q: `Ein Portfolio mit 50% BTC-Ziel hat jetzt 65% BTC durch Wertsteigerung. Was bewirkt das Rebalancing?`,
        options: [`Hält BTC bei 65%, weil es gewinnt`, `Verkauft einen Teil von BTC und kauft Vermögenswerte unter dem Ziel`, `Kauft mehr BTC, um das Momentum zu nutzen`, `Konvertiert alles in Stablecoins, bis es sich stabilisiert`],
        correct: 1,
      },
      {
        q: `Welche Einschränkung hat die Diversifikation innerhalb des Krypto-Ökosystems laut der Lektion?`,
        options: [`Die Transaktionskosten sind zu hoch`, `Es gibt nicht genügend liquide Vermögenswerte zur Diversifikation`, `Die extrem hohe Korrelation zwischen Vermögenswerten begrenzt die Vorteile`, `Modern Portfolio Theory gilt nicht für digitale Vermögenswerte`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `根据MPT，比特币在机构加密货币投资组合中的典型配置是多少？`,
        options: [`50-60%，因其成熟度、流动性和机构采用度`, `20-25%，作为以太坊的补充`, `80-90%，以最大化绝对收益`, `10-15%，与其他大市值山寨币一起`],
        correct: 0,
      },
      {
        q: `一个目标为50% BTC的投资组合因升值现在有65% BTC。再平衡会做什么？`,
        options: [`保持BTC在65%，因为它正在盈利`, `卖出部分BTC并购买低于目标的资产`, `购买更多BTC以利用动量`, `将所有资产转换为稳定币，直到市场稳定`],
        correct: 1,
      },
      {
        q: `根据课程，加密货币生态系统内的多元化有什么局限性？`,
        options: [`交易成本过高`, `没有足够的流动性资产可供多元化`, `资产之间极高的相关性限制了收益`, `现代投资组合理论不适用于数字资产`],
        correct: 2,
      },
    ],
  },
  L4_4: {
    es: [
      {
        q: `¿Por qué un fondo no puede ejecutar una orden market de $50M en BTC directamente?`,
        options: [`La profundidad del orderbook no puede absorberla sin impacto de precio significativo`, `Las regulaciones prohíben órdenes superiores a $10M`, `Los exchanges limitan órdenes a $1M por transacción`, `El slippage siempre es cero en órdenes grandes`],
        correct: 0,
      },
      {
        q: `¿Qué algoritmo adapta el tamaño de las sub-órdenes al volumen de mercado actual?`,
        options: [`TWAP ejecuta en intervalos regulares fijos`, `VWAP ajusta según el volumen del momento`, `POV siempre ejecuta el 50% del volumen`, `Implementation Shortfall ignora el volumen`],
        correct: 1,
      },
      {
        q: `¿Cuál es la principal desventaja del algoritmo TWAP?`,
        options: [`Es demasiado complejo para implementar`, `Los HFTs pueden anticipar y front-run las órdenes`, `Solo funciona en mercados de bajo volumen`, `Garantiza el peor precio de ejecución posible`],
        correct: 1,
      },
    ],
    en: [
      {
        q: `Why can't a fund execute a $50M BTC market order directly?`,
        options: [`Orderbook depth cannot absorb it without significant price impact`, `Regulations prohibit orders above $10M`, `Exchanges limit orders to $1M per transaction`, `Slippage is always zero on large orders`],
        correct: 0,
      },
      {
        q: `Which algorithm adapts sub-order size to current market volume?`,
        options: [`TWAP executes at fixed regular intervals`, `VWAP adjusts according to volume at the moment`, `POV always executes 50% of volume`, `Implementation Shortfall ignores volume`],
        correct: 1,
      },
      {
        q: `What is the main disadvantage of the TWAP algorithm?`,
        options: [`It is too complex to implement`, `HFTs can anticipate and front-run the orders`, `It only works in low-volume markets`, `It guarantees the worst possible execution price`],
        correct: 1,
      },
    ],
    sk: [
      {
        q: `Prečo fond nemôže vykonať trhovú objednávku $50M v BTC priamo?`,
        options: [`Hĺbka orderbooku ju nemôže absorbovať bez významného vplyvu na cenu`, `Regulácie zakazujú objednávky nad $10M`, `Burzy limitujú objednávky na $1M na transakciu`, `Slippage je vždy nulový pri veľkých objednávkach`],
        correct: 0,
      },
      {
        q: `Ktorý algoritmus prispôsobuje veľkosť pod-objednávok aktuálnemu trhovému objemu?`,
        options: [`TWAP vykonáva v pevných pravidelných intervaloch`, `VWAP upravuje podľa objemu v danom momente`, `POV vždy vykoná 50% objemu`, `Implementation Shortfall ignoruje objem`],
        correct: 1,
      },
      {
        q: `Aká je hlavná nevýhoda algoritmu TWAP?`,
        options: [`Je príliš zložitý na implementáciu`, `HFTs môžu anticipovať a front-run objednávky`, `Funguje len na trhoch s nízkym objemom`, `Zaručuje najhoršiu možnú cenu vykonania`],
        correct: 1,
      },
    ],
    de: [
      {
        q: `Warum kann ein Fonds keine Market-Order von $50M in BTC direkt ausführen?`,
        options: [`Die Tiefe des Orderbooks kann sie nicht ohne signifikanten Preisimpakt absorbieren`, `Vorschriften verbieten Orders über $10M`, `Exchanges begrenzen Orders auf $1M pro Transaktion`, `Der Slippage ist bei großen Orders immer null`],
        correct: 0,
      },
      {
        q: `Welcher Algorithmus passt die Größe der Sub-Orders an das aktuelle Marktvolumen an?`,
        options: [`TWAP führt in festen regelmäßigen Intervallen aus`, `VWAP passt sich dem Volumen des Moments an`, `POV führt immer 50% des Volumens aus`, `Implementation Shortfall ignoriert das Volumen`],
        correct: 1,
      },
      {
        q: `Was ist der Hauptnachteil des TWAP-Algorithmus?`,
        options: [`Er ist zu komplex zur Implementierung`, `HFTs können die Orders antizipieren und front-runnen`, `Er funktioniert nur in Märkten mit geringem Volumen`, `Er garantiert den schlechtesten Ausführungspreis`],
        correct: 1,
      },
    ],
    "zh-CN": [
      {
        q: `为什么基金不能直接执行5000万美元的BTC市价订单？`,
        options: [`订单簿深度无法在不产生重大价格影响的情况下吸收该订单`, `法规禁止超过1000万美元的订单`, `交易所将订单限制在每笔交易100万美元`, `大额订单的滑点始终为零`],
        correct: 0,
      },
      {
        q: `哪种算法根据当前市场成交量调整子订单的大小？`,
        options: [`TWAP在固定的规律间隔执行`, `VWAP根据当时的成交量调整`, `POV始终执行50%的成交量`, `Implementation Shortfall忽略成交量`],
        correct: 1,
      },
      {
        q: `TWAP算法的主要缺点是什么？`,
        options: [`实施过于复杂`, `高频交易者可以预测并抢先交易订单`, `仅在低成交量市场中有效`, `保证最差的执行价格`],
        correct: 1,
      },
    ],
  },
  L4_5: {
    es: [
      {
        q: `¿Qué es el arbitraje de funding rate en cripto?`,
        options: [`Comprar spot y vender futuros simultáneamente para capturar el funding rate`, `Comprar en un exchange barato y vender en uno caro al mismo tiempo`, `Explotar diferencias entre tres pares de trading en el mismo exchange`, `Usar flash loans para liquidar posiciones subcolateralizadas en DeFi`],
        correct: 0,
      },
      {
        q: `Un trader ejecuta arbitraje de funding con BTC. ¿Qué riesgo NO enfrenta directamente?`,
        options: [`Riesgo de que el exchange colapse como FTX`, `Riesgo de movimiento direccional del precio de Bitcoin`, `Riesgo de que el funding rate se vuelva negativo`, `Riesgo de que la base futuros-spot cambie temporalmente`],
        correct: 1,
      },
      {
        q: `¿Cuál afirmación sobre arbitraje triangular es INCORRECTA?`,
        options: [`Explota inconsistencias de precio entre tres pares de trading`, `Requiere velocidad de ejecución submilisegundo para ser rentable`, `Es la estrategia de arbitraje más accesible para traders minoristas`, `Convierte entre activos para capturar diferencias de valoración`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `What is funding rate arbitrage in crypto?`,
        options: [`Buy spot and sell futures simultaneously to capture the funding rate`, `Buy on a cheap exchange and sell on expensive one at same time`, `Exploit differences among three trading pairs on the same exchange`, `Use flash loans to liquidate undercollateralized positions in DeFi`],
        correct: 0,
      },
      {
        q: `A trader executes funding arbitrage with BTC. Which risk does he NOT face directly?`,
        options: [`Risk that the exchange collapses like FTX`, `Risk of directional Bitcoin price movement`, `Risk that funding rate turns negative`, `Risk that the futures-spot basis changes temporarily`],
        correct: 1,
      },
      {
        q: `Which statement about triangular arbitrage is INCORRECT?`,
        options: [`Exploits price inconsistencies among three trading pairs`, `Requires sub-millisecond execution speed to be profitable`, `Is the most accessible arbitrage strategy for retail traders`, `Converts between assets to capture valuation differences`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Čo je arbitráž funding rate v krypto?`,
        options: [`Kúpiť spot a predať futures súčasne na zachytenie funding rate`, `Kúpiť na lacnej burze a predať na drahej v rovnakom čase`, `Využiť rozdiely medzi tromi obchodnými pármi na tej istej burze`, `Použiť flash loans na likvidáciu podkolateralizovaných pozícií v DeFi`],
        correct: 0,
      },
      {
        q: `Trader vykonáva funding arbitráž s BTC. Ktorému riziku priamo NEČELÍ?`,
        options: [`Riziku, že burza skolabuje ako FTX`, `Riziku smerového pohybu ceny Bitcoin`, `Riziku, že funding rate sa stane negatívnym`, `Riziku, že báza futures-spot sa dočasne zmení`],
        correct: 1,
      },
      {
        q: `Ktoré tvrdenie o triangulárnej arbitráži je NESPRÁVNE?`,
        options: [`Využíva cenové nekonzistencie medzi tromi obchodnými pármi`, `Vyžaduje rýchlosť exekúcie v submilisekundách aby bola zisková`, `Je najprístupnejšia arbitrážna stratégia pre retailových traderov`, `Konvertuje medzi aktívami na zachytenie rozdielov v ocenení`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Was ist Funding-Rate-Arbitrage im Krypto-Bereich?`,
        options: [`Spot kaufen und Futures gleichzeitig verkaufen, um die Funding Rate zu erfassen`, `Auf einem günstigen Exchange kaufen und auf einem teuren gleichzeitig verkaufen`, `Preisunterschiede zwischen drei Trading-Paaren auf demselben Exchange ausnutzen`, `Flash Loans nutzen, um unterbesicherte Positionen in DeFi zu liquidieren`],
        correct: 0,
      },
      {
        q: `Ein Trader führt Funding-Arbitrage mit BTC durch. Welches Risiko besteht NICHT direkt?`,
        options: [`Risiko, dass der Exchange wie FTX zusammenbricht`, `Risiko einer direktionalen Preisbewegung von Bitcoin`, `Risiko, dass die Funding Rate negativ wird`, `Risiko, dass sich die Futures-Spot-Basis vorübergehend ändert`],
        correct: 1,
      },
      {
        q: `Welche Aussage über Dreiecksarbitrage ist FALSCH?`,
        options: [`Nutzt Preisinkonsistenzen zwischen drei Trading-Paaren aus`, `Erfordert Ausführungsgeschwindigkeit im Submillisekundenbereich, um rentabel zu sein`, `Ist die zugänglichste Arbitrage-Strategie für Retail-Trader`, `Konvertiert zwischen Assets, um Bewertungsunterschiede zu erfassen`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `什么是加密货币中的资金费率套利？`,
        options: [`同时买入现货并卖出期货以捕获资金费率`, `同时在便宜的交易所买入并在贵的交易所卖出`, `利用同一交易所三个交易对之间的差异`, `使用闪电贷清算DeFi中抵押不足的仓位`],
        correct: 0,
      },
      {
        q: `交易者执行BTC资金费率套利时，不会直接面临哪种风险？`,
        options: [`交易所像FTX一样崩溃的风险`, `Bitcoin价格方向性波动的风险`, `资金费率变为负值的风险`, `期货-现货基差暂时变化的风险`],
        correct: 1,
      },
      {
        q: `关于三角套利，哪个说法是错误的？`,
        options: [`利用三个交易对之间的价格不一致`, `需要亚毫秒级执行速度才能盈利`, `是散户交易者最容易获得的套利策略`, `通过资产转换来捕获估值差异`],
        correct: 2,
      },
    ],
  },
  L4_6: {
    es: [
      {
        q: `¿Qué mide el Ciclo de Liquidez Global según Michael Howell?`,
        options: [`Suma de balances de bancos centrales principales más liquidez privada`, `Solo el balance de la Reserva Federal de EE.UU.`, `Volumen total de transacciones en criptomonedas`, `Capitalización de mercado de Bitcoin y Ethereum`],
        correct: 0,
      },
      {
        q: `¿Qué ocurre cuando el M2 Global contrae, como en 2022?`,
        options: [`Bitcoin sube con un desfase de 12-18 semanas`, `Bitcoin tiende a caer siguiendo la contracción monetaria`, `El precio de Bitcoin permanece estable sin cambios`, `Los activos de menor riesgo caen antes que Bitcoin`],
        correct: 1,
      },
      {
        q: `¿Qué señala un VIX alto para el mercado cripto?`,
        options: [`Expansión de liquidez favorable para Bitcoin`, `Momento óptimo para aumentar apalancamiento`, `Entorno risk-off con presión sobre cripto`, `Fortalecimiento del dólar y subida de Bitcoin`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `What does the Global Liquidity Cycle measure according to Michael Howell?`,
        options: [`Sum of major central bank balance sheets plus private liquidity`, `Only the Federal Reserve balance sheet`, `Total cryptocurrency transaction volume`, `Market capitalization of Bitcoin and Ethereum`],
        correct: 0,
      },
      {
        q: `What happens when Global M2 contracts, as in 2022?`,
        options: [`Bitcoin rises with a 12-18 week lag`, `Bitcoin tends to fall following monetary contraction`, `Bitcoin price remains stable with no changes`, `Lower-risk assets fall before Bitcoin`],
        correct: 1,
      },
      {
        q: `What does a high VIX signal for the crypto market?`,
        options: [`Liquidity expansion favorable for Bitcoin`, `Optimal moment to increase leverage`, `Risk-off environment with pressure on crypto`, `Dollar strengthening and Bitcoin rally`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Čo meria Globálny cyklus likvidity podľa Michaela Howella?`,
        options: [`Súčet súvah hlavných centrálnych bánk plus súkromná likvidita`, `Iba súvahu Federálneho rezervného systému USA`, `Celkový objem transakcií v kryptomenách`, `Trhovú kapitalizáciu Bitcoinu a Etherea`],
        correct: 0,
      },
      {
        q: `Čo sa deje, keď sa globálne M2 sťahuje, ako v 2022?`,
        options: [`Bitcoin stúpa s oneskorením 12-18 týždňov`, `Bitcoin má tendenciu klesať nasledujúc peňažnú kontrakciu`, `Cena Bitcoinu zostáva stabilná bez zmien`, `Menej rizikové aktíva klesajú pred Bitcoinom`],
        correct: 1,
      },
      {
        q: `Čo signalizuje vysoký VIX pre krypto trh?`,
        options: [`Expanziu likvidity priaznivú pre Bitcoin`, `Optimálny moment na zvýšenie páky`, `Risk-off prostredie s tlakom na krypto`, `Posilnenie dolára a rast Bitcoinu`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Was misst der Globale Liquiditätszyklus laut Michael Howell?`,
        options: [`Summe der Bilanzen der wichtigsten Zentralbanken plus private Liquidität`, `Nur die Bilanz der US-Notenbank Federal Reserve`, `Gesamtes Transaktionsvolumen bei Kryptowährungen`, `Marktkapitalisierung von Bitcoin und Ethereum`],
        correct: 0,
      },
      {
        q: `Was passiert, wenn das globale M2 kontrahiert, wie 2022?`,
        options: [`Bitcoin steigt mit einer Verzögerung von 12-18 Wochen`, `Bitcoin tendiert dazu, der monetären Kontraktion folgend zu fallen`, `Der Bitcoin-Preis bleibt stabil ohne Veränderungen`, `Risikoärmere Assets fallen vor Bitcoin`],
        correct: 1,
      },
      {
        q: `Was signalisiert ein hoher VIX für den Kryptomarkt?`,
        options: [`Liquiditätsexpansion günstig für Bitcoin`, `Optimaler Zeitpunkt zur Erhöhung des Hebels`, `Risk-off-Umfeld mit Druck auf Krypto`, `Dollar-Stärkung und Bitcoin-Anstieg`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `根据Michael Howell的理论，全球流动性周期衡量什么？`,
        options: [`主要央行资产负债表总和加上私人流动性`, `仅美联储的资产负债表`, `加密货币交易总量`, `Bitcoin和Ethereum的市值`],
        correct: 0,
      },
      {
        q: `当全球M2收缩时（如2022年）会发生什么？`,
        options: [`Bitcoin在12-18周后上涨`, `Bitcoin往往跟随货币收缩而下跌`, `Bitcoin价格保持稳定不变`, `低风险资产比Bitcoin更早下跌`],
        correct: 1,
      },
      {
        q: `高VIX对加密市场意味着什么？`,
        options: [`有利于Bitcoin的流动性扩张`, `增加杠杆的最佳时机`, `风险规避环境对加密货币施加压力`, `美元走强且Bitcoin上涨`],
        correct: 2,
      },
    ],
  },
  L5_0: {
    es: [
      {
        q: `¿Qué pregunta hace un trader cuantitativo sobre Bitcoin?`,
        options: [`¿Subirá BTC mañana?`, `¿Cuál es la distribución completa de resultados posibles y su expectativa matemática?`, `¿Cuál es el precio objetivo de BTC?`, `¿Qué dice el análisis técnico sobre BTC?`],
        correct: 1,
      },
      {
        q: `Si tu modelo tiene 60% win rate, ¿qué probabilidad hay de 5 pérdidas consecutivas en 100 trades?`,
        options: [`0% — el sistema está roto`, `10% — es muy raro`, `Aproximadamente 1% — ocurre varias veces al año`, `50% — es totalmente aleatorio`],
        correct: 2,
      },
      {
        q: `En el Teorema de Bayes aplicado al trading, ¿qué representa P(H|E)?`,
        options: [`La probabilidad base de que ocurra cualquier evento`, `La probabilidad de la señal dado que el precio sube`, `La probabilidad posterior de subida dado que aparece la señal`, `La frecuencia histórica de la señal en el mercado`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `What does a quantitative trader ask about Bitcoin?`,
        options: [`Will BTC go up tomorrow?`, `What's the complete distribution of possible outcomes and its mathematical expectation?`, `What's the price target for BTC?`, `What does technical analysis say about BTC?`],
        correct: 1,
      },
      {
        q: `If your model has a 60% win rate, what's the probability of 5 consecutive losses in 100 trades?`,
        options: [`0% — the system is broken`, `10% — it's very rare`, `Approximately 1% — occurs several times a year`, `50% — it's completely random`],
        correct: 2,
      },
      {
        q: `In Bayes' Theorem applied to trading, what does P(H|E) represent?`,
        options: [`The base probability of any event occurring`, `The probability of the signal given price goes up`, `The posterior probability of upside given the signal appears`, `The historical frequency of the signal in the market`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Čo sa pýta kvantitatívny trader o Bitcoine?`,
        options: [`Pôjde BTC zajtra hore?`, `Aké je kompletné rozdelenie možných výsledkov a jeho matematická stredná hodnota?`, `Aký je cenový cieľ pre BTC?`, `Čo hovorí technická analýza o BTC?`],
        correct: 1,
      },
      {
        q: `Ak má váš model 60% win rate, aká je pravdepodobnosť 5 po sebe nasledujúcich strát v 100 obchodoch?`,
        options: [`0% — systém je pokazený`, `10% — je to veľmi zriedkavé`, `Približne 1% — vyskytuje sa niekoľkokrát ročne`, `50% — je to úplne náhodné`],
        correct: 2,
      },
      {
        q: `V Bayesovej vete aplikovanej na trading, čo predstavuje P(H|E)?`,
        options: [`Základnú pravdepodobnosť výskytu akejkoľvek udalosti`, `Pravdepodobnosť signálu za podmienky, že cena rastie`, `Aposteriornu pravdepodobnosť rastu za podmienky výskytu signálu`, `Historickú frekvenciu signálu na trhu`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Welche Frage stellt ein quantitativer Trader über Bitcoin?`,
        options: [`Wird BTC morgen steigen?`, `Was ist die vollständige Verteilung möglicher Ergebnisse und ihr mathematischer Erwartungswert?`, `Was ist das Kursziel von BTC?`, `Was sagt die technische Analyse über BTC?`],
        correct: 1,
      },
      {
        q: `Wenn dein Modell eine 60% Win Rate hat, wie hoch ist die Wahrscheinlichkeit von 5 aufeinanderfolgenden Verlusten bei 100 Trades?`,
        options: [`0% — das System ist kaputt`, `10% — es ist sehr selten`, `Ungefähr 1% — tritt mehrmals im Jahr auf`, `50% — es ist völlig zufällig`],
        correct: 2,
      },
      {
        q: `Was repräsentiert P(H|E) im Bayes-Theorem angewendet auf Trading?`,
        options: [`Die Basiswahrscheinlichkeit, dass irgendein Ereignis eintritt`, `Die Wahrscheinlichkeit des Signals gegeben, dass der Preis steigt`, `Die posteriore Wahrscheinlichkeit eines Anstiegs gegeben, dass das Signal erscheint`, `Die historische Häufigkeit des Signals im Markt`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `量化交易者会如何提问关于Bitcoin？`,
        options: [`BTC明天会涨吗？`, `所有可能结果的完整分布及其数学期望是什么？`, `BTC的目标价是多少？`, `技术分析对BTC怎么说？`],
        correct: 1,
      },
      {
        q: `如果你的模型胜率为60%，在100笔交易中连续亏损5次的概率是多少？`,
        options: [`0% — 系统坏了`, `10% — 非常罕见`, `约1% — 每年会发生几次`, `50% — 完全随机`],
        correct: 2,
      },
      {
        q: `在交易中应用贝叶斯定理时，P(H|E)代表什么？`,
        options: [`任何事件发生的基础概率`, `价格上涨时出现信号的概率`, `出现信号时价格上涨的后验概率`, `信号在市场中的历史频率`],
        correct: 2,
      },
    ],
  },
  L5_1: {
    es: [
      {
        q: `¿Qué distribución captura mejor los eventos extremos en mercados financieros que la normal?`,
        options: [`Distribución de Student-t con ν < 10`, `Distribución Binomial`, `Distribución Uniforme`, `Distribución Exponencial`],
        correct: 0,
      },
      {
        q: `Si Bitcoin tiene Hurst Exponent H ≈ 0.63 en timeframe diario, ¿qué tipo de estrategia es más apropiada?`,
        options: [`Mean reversion, porque H > 0.5 indica reversión`, `Momentum, porque H > 0.5 indica tendencia moderada`, `Arbitraje estadístico puro`, `Market making neutral`],
        correct: 1,
      },
      {
        q: `La autocorrelación negativa en una serie temporal sugiere:`,
        options: [`Momentum fuerte y tendencia persistente`, `Comportamiento aleatorio tipo random walk`, `Mean reversion — si subió ayer, tiende a bajar hoy`, `Fat tails y eventos extremos frecuentes`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `Which distribution better captures extreme events in financial markets than the normal distribution?`,
        options: [`Student-t distribution with ν < 10`, `Binomial distribution`, `Uniform distribution`, `Exponential distribution`],
        correct: 0,
      },
      {
        q: `If Bitcoin has Hurst Exponent H ≈ 0.63 on daily timeframe, what type of strategy is most appropriate?`,
        options: [`Mean reversion, because H > 0.5 indicates reversion`, `Momentum, because H > 0.5 indicates moderate trend`, `Pure statistical arbitrage`, `Neutral market making`],
        correct: 1,
      },
      {
        q: `Negative autocorrelation in a time series suggests:`,
        options: [`Strong momentum and persistent trend`, `Random walk-like random behavior`, `Mean reversion — if it went up yesterday, it tends to go down today`, `Fat tails and frequent extreme events`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Ktoré rozdelenie lepšie zachytáva extrémne udalosti na finančných trhoch než normálne?`,
        options: [`Studentovo t-rozdelenie so ν < 10`, `Binomické rozdelenie`, `Uniformné rozdelenie`, `Exponenciálne rozdelenie`],
        correct: 0,
      },
      {
        q: `Ak má Bitcoin Hurst Exponent H ≈ 0.63 na dennom timeframe, aký typ stratégie je najvhodnejší?`,
        options: [`Mean reversion, lebo H > 0.5 indikuje reverziu`, `Momentum, lebo H > 0.5 indikuje mierny trend`, `Čistý štatistický arbitráž`, `Neutrálny market making`],
        correct: 1,
      },
      {
        q: `Negatívna autokorelácia v časovom rade naznačuje:`,
        options: [`Silný momentum a persistentný trend`, `Náhodné správanie typu random walk`, `Mean reversion — ak to včera rástlo, má tendenciu dnes klesať`, `Fat tails a časté extrémne udalosti`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Welche Verteilung erfasst extreme Ereignisse in Finanzmärkten besser als die Normalverteilung?`,
        options: [`Student-t-Verteilung mit ν < 10`, `Binomialverteilung`, `Gleichverteilung`, `Exponentialverteilung`],
        correct: 0,
      },
      {
        q: `Wenn Bitcoin einen Hurst Exponent H ≈ 0,63 im Tages-Timeframe hat, welche Strategie ist am geeignetsten?`,
        options: [`Mean Reversion, weil H > 0,5 Umkehr anzeigt`, `Momentum, weil H > 0,5 moderaten Trend anzeigt`, `Reine statistische Arbitrage`, `Neutrales Market Making`],
        correct: 1,
      },
      {
        q: `Negative Autokorrelation in einer Zeitreihe deutet auf:`,
        options: [`Starkes Momentum und anhaltenden Trend`, `Zufälliges Verhalten wie Random Walk`, `Mean Reversion — wenn es gestern stieg, tendiert es heute zu fallen`, `Fat Tails und häufige extreme Ereignisse`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `相比正态分布，哪种分布能更好地捕捉金融市场中的极端事件？`,
        options: [`自由度 ν < 10 的 Student-t 分布`, `二项分布`, `均匀分布`, `指数分布`],
        correct: 0,
      },
      {
        q: `如果 Bitcoin 在日线时间框架上的 Hurst Exponent H ≈ 0.63，哪种策略最合适？`,
        options: [`均值回归，因为 H > 0.5 表示反转`, `Momentum，因为 H > 0.5 表示中等趋势`, `纯统计套利`, `中性做市`],
        correct: 1,
      },
      {
        q: `时间序列中的负自相关性表明：`,
        options: [`强劲的 Momentum 和持续趋势`, `类似随机游走的随机行为`, `均值回归——如果昨天上涨，今天倾向于下跌`, `肥尾和频繁的极端事件`],
        correct: 2,
      },
    ],
  },
  L5_2: {
    es: [
      {
        q: `¿Qué componente debe estar SIEMPRE entre el Strategy Engine y el OMS?`,
        options: [`Risk Manager independiente`, `Data Feed en tiempo real`, `Execution Layer con WebSocket`, `Heartbeat Monitoring`],
        correct: 0,
      },
      {
        q: `En el flujo de un bot Python, ¿qué debe hacerse ANTES de enviar la orden al exchange?`,
        options: [`Conectar al WebSocket de orderbook`, `Procesar klines y trades históricos`, `Verificar la señal con el Risk Manager`, `Monitorizar el estado filled/partial`],
        correct: 2,
      },
      {
        q: `¿Cuál de estas afirmaciones sobre la arquitectura algorítmica es INCORRECTA?`,
        options: [`El Risk Manager debe ser simple y bien testado`, `WebSocket se usa para datos en tiempo real`, `La separación de componentes es solo cosmética`, `Knight Capital perdió $440M por fallo en OMS`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `Which component must ALWAYS sit between the Strategy Engine and the OMS?`,
        options: [`Independent Risk Manager`, `Real-time Data Feed`, `Execution Layer with WebSocket`, `Heartbeat Monitoring`],
        correct: 0,
      },
      {
        q: `In a Python bot flow, what must be done BEFORE sending the order to the exchange?`,
        options: [`Connect to orderbook WebSocket`, `Process historical klines and trades`, `Verify signal with Risk Manager`, `Monitor filled/partial order status`],
        correct: 2,
      },
      {
        q: `Which statement about algorithmic architecture is INCORRECT?`,
        options: [`Risk Manager must be simple and well-tested`, `WebSocket is used for real-time data`, `Component separation is only cosmetic`, `Knight Capital lost $440M due to OMS failure`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Ktorý komponent musí VŽDY stáť medzi Strategy Engine a OMS?`,
        options: [`Nezávislý Risk Manager`, `Data Feed v reálnom čase`, `Execution Layer s WebSocket`, `Heartbeat Monitoring`],
        correct: 0,
      },
      {
        q: `V toku Python bota, čo sa musí urobiť PRED odoslaním príkazu na burzu?`,
        options: [`Pripojiť sa na orderbook WebSocket`, `Spracovať historické klines a trades`, `Overiť signál cez Risk Manager`, `Monitorovať stav filled/partial príkazu`],
        correct: 2,
      },
      {
        q: `Ktoré tvrdenie o algoritmickej architektúre je NESPRÁVNE?`,
        options: [`Risk Manager musí byť jednoduchý a dobre otestovaný`, `WebSocket sa používa pre dáta v reálnom čase`, `Oddelenie komponentov je len kozmetické`, `Knight Capital stratil $440M kvôli zlyhaniu OMS`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Welche Komponente muss IMMER zwischen der Strategy Engine und dem OMS stehen?`,
        options: [`Unabhängiger Risk Manager`, `Echtzeit-Data Feed`, `Execution Layer mit WebSocket`, `Heartbeat Monitoring`],
        correct: 0,
      },
      {
        q: `Was muss im Ablauf eines Python-Bots getan werden, BEVOR die Order an die Exchange gesendet wird?`,
        options: [`Mit dem Orderbook-WebSocket verbinden`, `Historische Klines und Trades verarbeiten`, `Das Signal mit dem Risk Manager verifizieren`, `Den Status filled/partial überwachen`],
        correct: 2,
      },
      {
        q: `Welche dieser Aussagen über algorithmische Architektur ist FALSCH?`,
        options: [`Der Risk Manager muss einfach und gut getestet sein`, `WebSocket wird für Echtzeitdaten verwendet`, `Die Trennung von Komponenten ist nur kosmetisch`, `Knight Capital verlor $440M durch einen OMS-Fehler`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `在策略引擎和订单管理系统之间必须始终存在哪个组件?`,
        options: [`独立的风险管理器`, `实时数据源`, `带WebSocket的执行层`, `心跳监控`],
        correct: 0,
      },
      {
        q: `在Python交易机器人的流程中,向交易所发送订单之前必须做什么?`,
        options: [`连接到订单簿的WebSocket`, `处理历史K线和交易数据`, `通过风险管理器验证信号`, `监控已成交/部分成交状态`],
        correct: 2,
      },
      {
        q: `关于算法架构,以下哪个说法是错误的?`,
        options: [`风险管理器必须简单且经过充分测试`, `WebSocket用于实时数据传输`, `组件分离只是表面功夫`, `Knight Capital因订单管理系统故障损失4.4亿美元`],
        correct: 2,
      },
    ],
  },
  L5_3: {
    es: [
      {
        q: `¿Cuál es el principal problema de los modelos ML que 'funcionan' en backtesting pero fallan en producción?`,
        options: [`Han aprendido el ruido específico de los datos de entrenamiento (overfitting)`, `Utilizan demasiadas features técnicas y on-chain`, `No incluyen suficientes capas LSTM en su arquitectura`, `Requieren demasiado poder computacional para ejecutarse`],
        correct: 0,
      },
      {
        q: `Según la lección, ¿qué genera el 80% del valor en modelos ML para trading?`,
        options: [`La arquitectura del modelo (XGBoost vs LSTM)`, `Feature Engineering: crear variables de entrada relevantes`, `El tamaño del dataset de entrenamiento histórico`, `La frecuencia de reentrenamiento del modelo`],
        correct: 1,
      },
      {
        q: `¿Cuál afirmación sobre aplicaciones de ML en trading es INCORRECTA?`,
        options: [`ML puede clasificar eficazmente el régimen de mercado`, `ML puede filtrar señales para reducir falsos positivos`, `ML predice precios futuros con alta precisión consistente`, `ML funciona mejor con features basadas en lógica económica previa`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `What is the main problem with ML models that 'work' in backtesting but fail in production?`,
        options: [`They learned the specific noise of training data (overfitting)`, `They use too many technical and on-chain features`, `They don't include enough LSTM layers in their architecture`, `They require too much computational power to execute`],
        correct: 0,
      },
      {
        q: `According to the lesson, what generates 80% of the value in ML models for trading?`,
        options: [`The model architecture (XGBoost vs LSTM)`, `Feature Engineering: creating relevant input variables`, `The size of the historical training dataset`, `The frequency of model retraining`],
        correct: 1,
      },
      {
        q: `Which statement about ML applications in trading is INCORRECT?`,
        options: [`ML can effectively classify market regime`, `ML can filter signals to reduce false positives`, `ML predicts future prices with consistent high precision`, `ML works best with features based on prior economic logic`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Aký je hlavný problém ML modelov, ktoré 'fungujú' v backtestingu, ale zlyhávajú v produkcii?`,
        options: [`Naučili sa špecifický šum trénovacích dát (overfitting)`, `Používajú príliš veľa technických a on-chain features`, `Neobsahujú dostatok LSTM vrstiev v architektúre`, `Vyžadujú príliš veľký výpočtový výkon na spustenie`],
        correct: 0,
      },
      {
        q: `Podľa lekcie, čo generuje 80% hodnoty v ML modeloch pre trading?`,
        options: [`Architektúra modelu (XGBoost vs LSTM)`, `Feature Engineering: vytváranie relevantných vstupných premenných`, `Veľkosť historického trénovacieho datasetu`, `Frekvencia pretrénovávania modelu`],
        correct: 1,
      },
      {
        q: `Ktoré tvrdenie o aplikáciách ML v tradingu je NESPRÁVNE?`,
        options: [`ML vie efektívne klasifikovať trhový režim`, `ML vie filtrovať signály na zníženie falošných pozitív`, `ML predpovedá budúce ceny s konzistentnou vysokou presnosťou`, `ML funguje najlepšie s features založenými na predchádzajúcej ekonomickej logike`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Was ist das Hauptproblem von ML-Modellen, die im Backtesting „funktionieren", aber in der Produktion versagen?`,
        options: [`Sie haben das spezifische Rauschen der Trainingsdaten gelernt (Overfitting)`, `Sie verwenden zu viele technische und On-Chain-Features`, `Sie enthalten nicht genügend LSTM-Schichten in ihrer Architektur`, `Sie benötigen zu viel Rechenleistung für die Ausführung`],
        correct: 0,
      },
      {
        q: `Laut der Lektion, was generiert 80% des Wertes in ML-Modellen für Trading?`,
        options: [`Die Architektur des Modells (XGBoost vs LSTM)`, `Feature Engineering: Erstellung relevanter Eingabevariablen`, `Die Größe des historischen Trainings-Datasets`, `Die Häufigkeit des Modell-Retrainings`],
        correct: 1,
      },
      {
        q: `Welche Aussage über ML-Anwendungen im Trading ist FALSCH?`,
        options: [`ML kann das Marktregime effektiv klassifizieren`, `ML kann Signale filtern, um falsch-positive Ergebnisse zu reduzieren`, `ML sagt zukünftige Preise mit konstant hoher Präzision voraus`, `ML funktioniert besser mit Features, die auf vorheriger wirtschaftlicher Logik basieren`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `在回测中"有效"但在实盘中失败的机器学习模型的主要问题是什么?`,
        options: [`它们学习了训练数据中的特定噪声(过拟合)`, `使用了过多的技术指标和链上特征`, `架构中没有包含足够的LSTM层`, `执行时需要过多的计算能力`],
        correct: 0,
      },
      {
        q: `根据课程内容,交易机器学习模型中80%的价值来自什么?`,
        options: [`模型架构(XGBoost vs LSTM)`, `特征工程:创建相关的输入变量`, `历史训练数据集的大小`, `模型重新训练的频率`],
        correct: 1,
      },
      {
        q: `关于机器学习在交易中的应用,哪个说法是错误的?`,
        options: [`机器学习可以有效地分类市场状态`, `机器学习可以过滤信号以减少假阳性`, `机器学习能够持续高精度地预测未来价格`, `机器学习在基于先验经济逻辑的特征上表现更好`],
        correct: 2,
      },
    ],
  },
  L5_4: {
    es: [
      {
        q: `¿Por qué el mercado cripto es más sensible al sentimiento que mercados tradicionales?`,
        options: [`Alta proporción de retail emocionalmente motivado y ausencia de fundamentales objetivos claros`, `Porque las criptomonedas solo se comercian en exchanges descentralizados sin regulación`, `Los hedge funds manipulan el sentimiento con bots y algoritmos avanzados en redes`, `El volumen de trading es menor y los precios son más volátiles por definición`],
        correct: 0,
      },
      {
        q: `Un fondo cuantitativo quiere clasificar tweets como bullish/bearish con 85-90% de precisión. ¿Qué técnica es óptima?`,
        options: [`Bag of Words con frecuencia simple de palabras clave como 'moon' y 'dump'`, `FinBERT o CryptoBERT fine-tuned en datos específicos de cripto`, `TF-IDF con diccionario de términos financieros ponderados manualmente`, `Word2Vec entrenado solo en tweets históricos de influencers cripto`],
        correct: 1,
      },
      {
        q: `¿Cuál afirmación sobre modelos Transformer (BERT) para trading es INCORRECTA?`,
        options: [`CryptoBERT está fine-tuned en datos cripto y supera a BERT genérico en sentimiento`, `Los modelos Transformer entienden contexto bidireccional, no solo secuencial`, `BERT requiere entrenamiento desde cero con millones de documentos cripto propios`, `FinBERT se puede usar directamente o con fine-tuning en dataset específico pequeño`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `Why is the crypto market more sensitive to sentiment than traditional markets?`,
        options: [`High proportion of emotionally-driven retail and absence of clear objective fundamentals`, `Because cryptocurrencies only trade on decentralized exchanges without regulation`, `Hedge funds manipulate sentiment with bots and advanced algorithms on social media`, `Trading volume is lower and prices are more volatile by definition`],
        correct: 0,
      },
      {
        q: `A quant fund wants to classify tweets as bullish/bearish with 85-90% accuracy. Which technique is optimal?`,
        options: [`Bag of Words with simple frequency of keywords like 'moon' and 'dump'`, `FinBERT or CryptoBERT fine-tuned on specific crypto data`, `TF-IDF with manually weighted financial terms dictionary`, `Word2Vec trained only on historical tweets from crypto influencers`],
        correct: 1,
      },
      {
        q: `Which statement about Transformer models (BERT) for trading is INCORRECT?`,
        options: [`CryptoBERT is fine-tuned on crypto data and outperforms generic BERT on sentiment`, `Transformer models understand bidirectional context, not just sequential`, `BERT requires training from scratch with millions of your own crypto documents`, `FinBERT can be used directly or with fine-tuning on a small specific dataset`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Prečo je krypto trh citlivejší na sentiment ako tradičné trhy?`,
        options: [`Vysoký podiel emocionálne motivovaného retailu a absencia jasných objektívnych fundamentov`, `Pretože kryptomeny sa obchodujú len na decentralizovaných burzách bez regulácie`, `Hedžové fondy manipulujú sentiment s botmi a pokročilými algoritmami na sociálnych sieťach`, `Objem tradingu je nižší a ceny sú volatilnejšie z definície`],
        correct: 0,
      },
      {
        q: `Kvantový fond chce klasifikovať tweety ako bullish/bearish s 85-90% presnosťou. Ktorá technika je optimálna?`,
        options: [`Bag of Words s jednoduchou frekvenciou kľúčových slov ako 'moon' a 'dump'`, `FinBERT alebo CryptoBERT fine-tuned na špecifických krypto dátach`, `TF-IDF s manuálne váženým slovníkom finančných termínov`, `Word2Vec trénovaný len na historických tweetoch od krypto influencerov`],
        correct: 1,
      },
      {
        q: `Ktoré tvrdenie o Transformer modeloch (BERT) pre trading je NESPRÁVNE?`,
        options: [`CryptoBERT je fine-tuned na krypto dátach a prekonáva generický BERT v sentimente`, `Transformer modely rozumejú obojsmernému kontextu, nie len sekvenčnému`, `BERT vyžaduje tréning od nuly s miliónmi vlastných krypto dokumentov`, `FinBERT sa dá použiť priamo alebo s fine-tuningom na malom špecifickom datasete`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Warum ist der Kryptomarkt empfindlicher gegenüber Stimmungen als traditionelle Märkte?`,
        options: [`Hoher Anteil emotional motivierter Retail-Trader und Fehlen klarer objektiver Fundamentaldaten`, `Weil Kryptowährungen nur auf dezentralen Exchanges ohne Regulierung gehandelt werden`, `Hedgefonds manipulieren die Stimmung mit Bots und fortgeschrittenen Algorithmen in sozialen Netzwerken`, `Das Handelsvolumen ist geringer und die Preise sind per Definition volatiler`],
        correct: 0,
      },
      {
        q: `Ein quantitativer Fonds möchte Tweets mit 85-90% Genauigkeit als bullish/bearish klassifizieren. Welche Technik ist optimal?`,
        options: [`Bag of Words mit einfacher Häufigkeit von Schlüsselwörtern wie 'moon' und 'dump'`, `FinBERT oder CryptoBERT fine-tuned auf kryptospezifischen Daten`, `TF-IDF mit manuell gewichtetem Wörterbuch finanzieller Begriffe`, `Word2Vec trainiert nur auf historischen Tweets von Krypto-Influencern`],
        correct: 1,
      },
      {
        q: `Welche Aussage über Transformer-Modelle (BERT) für Trading ist FALSCH?`,
        options: [`CryptoBERT ist auf Kryptodaten fine-tuned und übertrifft generisches BERT bei Stimmungsanalyse`, `Transformer-Modelle verstehen bidirektionalen Kontext, nicht nur sequenziellen`, `BERT erfordert Training von Grund auf mit Millionen eigener Krypto-Dokumente`, `FinBERT kann direkt verwendet oder mit kleinem spezifischem Dataset fine-tuned werden`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `为什么加密市场比传统市场对情绪更敏感？`,
        options: [`散户比例高且情绪化驱动，缺乏明确的客观基本面`, `因为加密货币只在无监管的去中心化交易所交易`, `对冲基金通过机器人和先进算法在社交网络上操纵情绪`, `交易量较小，价格波动性本质上更高`],
        correct: 0,
      },
      {
        q: `一个量化基金想以85-90%的准确率将推文分类为看涨/看跌。最优技术是什么？`,
        options: [`使用简单关键词频率（如'moon'和'dump'）的词袋模型`, `在加密特定数据上微调的FinBERT或CryptoBERT`, `使用手动加权金融术语词典的TF-IDF`, `仅在加密影响者历史推文上训练的Word2Vec`],
        correct: 1,
      },
      {
        q: `关于用于交易的Transformer模型（BERT），哪个说法是错误的？`,
        options: [`CryptoBERT在加密数据上微调，在情绪分析上优于通用BERT`, `Transformer模型理解双向上下文，而非仅序列化`, `BERT需要用数百万份自有加密文档从零开始训练`, `FinBERT可以直接使用，或在小型特定数据集上微调`],
        correct: 2,
      },
    ],
  },
  L5_5: {
    es: [
      {
        q: `¿Qué mide el Kyle's Lambda en microestructura de mercado?`,
        options: [`Cuánto se mueve el precio por cada unidad de order flow`, `La probabilidad de que un trader tenga información privada`, `El riesgo de inventario del market maker`, `El spread bid-ask promedio del activo`],
        correct: 0,
      },
      {
        q: `¿Por qué el spread BTC/USDT en Binance es menor que el de una altcoin ilíquida?`,
        options: [`Bitcoin tiene mayor volatilidad histórica`, `El riesgo de información asimétrica es menor en Bitcoin`, `Las altcoins tienen más market makers compitiendo`, `Binance cobra menos comisiones en Bitcoin`],
        correct: 1,
      },
      {
        q: `Un VPIN muy alto indica que:`,
        options: [`El mercado está dominado por noise traders y la liquidez aumenta`, `Los market makers reducen spreads para atraer más flujo`, `La probabilidad de movimientos discontinuos aumenta y la liquidez se reduce`, `El order flow tiene baja proporción de traders informados`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `What does Kyle's Lambda measure in market microstructure?`,
        options: [`How much the price moves per unit of order flow`, `The probability that a trader has private information`, `The market maker's inventory risk exposure`, `The average bid-ask spread of the asset`],
        correct: 0,
      },
      {
        q: `Why is the BTC/USDT spread on Binance lower than an illiquid altcoin's?`,
        options: [`Bitcoin has higher historical volatility`, `Asymmetric information risk is lower in Bitcoin`, `Altcoins have more competing market makers`, `Binance charges lower fees on Bitcoin`],
        correct: 1,
      },
      {
        q: `Very high VPIN indicates that:`,
        options: [`The market is dominated by noise traders and liquidity increases`, `Market makers tighten spreads to attract more flow`, `Probability of discontinuous movements rises and liquidity decreases`, `Order flow has a low proportion of informed traders`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Čo meria Kyle's Lambda v trhovej mikroštruktúre?`,
        options: [`O koľko sa posunie cena za jednotku order flow`, `Pravdepodobnosť, že obchodník má súkromné informácie`, `Riziko zásob market makera`, `Priemerný bid-ask spread aktíva`],
        correct: 0,
      },
      {
        q: `Prečo je BTC/USDT spread na Binance nižší ako u nelikvidného altcoinu?`,
        options: [`Bitcoin má vyššiu historickú volatilitu`, `Riziko asymetrických informácií je nižšie v Bitcoine`, `Altcoiny majú viac konkurujúcich market makerov`, `Binance účtuje nižšie poplatky na Bitcoine`],
        correct: 1,
      },
      {
        q: `Veľmi vysoký VPIN indikuje, že:`,
        options: [`Trh je dominovaný noise traders a likvidita rastie`, `Market makeri znižujú spready, aby prilákali viac toku`, `Pravdepodobnosť diskontinuálnych pohybov rastie a likvidita klesá`, `Order flow má nízky podiel informovaných obchodníkov`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Was misst Kyle's Lambda in der Marktmikrostruktur?`,
        options: [`Wie stark sich der Preis pro Einheit Order Flow bewegt`, `Die Wahrscheinlichkeit, dass ein Trader private Informationen besitzt`, `Das Inventarrisiko des Market Makers`, `Der durchschnittliche Bid-Ask-Spread des Assets`],
        correct: 0,
      },
      {
        q: `Warum ist der Spread BTC/USDT auf Binance geringer als bei einem illiquiden Altcoin?`,
        options: [`Bitcoin hat höhere historische Volatilität`, `Das Risiko asymmetrischer Informationen ist bei Bitcoin geringer`, `Altcoins haben mehr konkurrierende Market Maker`, `Binance erhebt niedrigere Gebühren für Bitcoin`],
        correct: 1,
      },
      {
        q: `Ein sehr hoher VPIN zeigt an, dass:`,
        options: [`Der Markt von Noise Tradern dominiert wird und die Liquidität zunimmt`, `Market Maker die Spreads reduzieren, um mehr Flow anzuziehen`, `Die Wahrscheinlichkeit diskontinuierlicher Bewegungen steigt und die Liquidität abnimmt`, `Der Order Flow einen niedrigen Anteil informierter Trader aufweist`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `Kyle's Lambda在市场微观结构中衡量什么？`,
        options: [`每单位订单流导致价格移动多少`, `交易者拥有私人信息的概率`, `做市商的库存风险`, `资产的平均买卖价差`],
        correct: 0,
      },
      {
        q: `为什么币安的BTC/USDT价差小于流动性差的山寨币？`,
        options: [`Bitcoin的历史波动性更大`, `Bitcoin的信息不对称风险较低`, `山寨币有更多做市商竞争`, `币安对Bitcoin收取更低的手续费`],
        correct: 1,
      },
      {
        q: `非常高的VPIN表明：`,
        options: [`市场由噪音交易者主导，流动性增加`, `做市商降低价差以吸引更多订单流`, `不连续价格波动的概率增加，流动性减少`, `订单流中知情交易者比例较低`],
        correct: 2,
      },
    ],
  },
  L5_6: {
    es: [
      {
        q: `¿Cuál es el primer paso en la jerarquía de análisis del trader completo?`,
        options: [`Marco Macro: liquidez global, ciclo Fed, DXY, NUPL on-chain`, `Señal de Entrada: SMC, Order Block, FVG, Wyckoff Spring`, `Estructura Técnica: HH/HL/LH/LL en semanal y diario`, `Validación Cuantitativa: Confluence Score y régimen ML`],
        correct: 0,
      },
      {
        q: `¿Por qué un trade perfecto en proceso que pierde es mejor que uno impulsivo que gana?`,
        options: [`Porque preserva más capital a largo plazo`, `Porque el trade impulsivo no es reproducible sistemáticamente`, `Porque genera menos estrés emocional para el trader`, `Porque los trades perdedores enseñan más lecciones valiosas`],
        correct: 1,
      },
      {
        q: `¿Cuál de estos NO es un principio inmutable del trading exitoso según la lección?`,
        options: [`La preservación del capital es la prioridad suprema`, `La consistencia supera al genio en el largo plazo`, `Un sistema complejo siempre supera a uno simple`, `El proceso es más importante que el resultado individual`],
        correct: 2,
      },
    ],
    en: [
      {
        q: `What is the first step in the complete trader's analysis hierarchy?`,
        options: [`Macro Framework: global liquidity, Fed cycle, DXY, on-chain NUPL`, `Entry Signal: SMC, Order Block, FVG, Wyckoff Spring`, `Technical Structure: HH/HL/LH/LL on weekly and daily charts`, `Quantitative Validation: Confluence Score and ML regime`],
        correct: 0,
      },
      {
        q: `Why is a perfect process trade that loses better than an impulsive winning trade?`,
        options: [`Because it preserves more capital over the long term`, `Because the impulsive trade is not systematically reproducible`, `Because it generates less emotional stress for the trader`, `Because losing trades teach more valuable lessons overall`],
        correct: 1,
      },
      {
        q: `Which of these is NOT an immutable principle of successful trading per the lesson?`,
        options: [`Capital preservation is the supreme priority`, `Consistency beats genius over the long run`, `A complex system always beats a simple one`, `Process is more important than individual outcome`],
        correct: 2,
      },
    ],
    sk: [
      {
        q: `Aký je prvý krok v hierarchii analýzy kompletného tradera?`,
        options: [`Makro Rámec: globálna likvidita, Fed cyklus, DXY, on-chain NUPL`, `Vstupný Signál: SMC, Order Block, FVG, Wyckoff Spring`, `Technická Štruktúra: HH/HL/LH/LL na týždennom a dennom grafe`, `Kvantitatívna Validácia: Confluence Score a ML režim`],
        correct: 0,
      },
      {
        q: `Prečo je perfektný procesný trade, ktorý stratí, lepší ako impulzívny vyhravajúci?`,
        options: [`Pretože zachováva viac kapitálu na dlhé obdobie`, `Pretože impulzívny trade nie je systematicky reprodukovateľný`, `Pretože generuje menej emocionálneho stresu pre tradera`, `Pretože stratové trady učia celkovo cennejším lekciám`],
        correct: 1,
      },
      {
        q: `Ktorý z týchto NIE JE nemenný princíp úspešného tradingu podľa lekcie?`,
        options: [`Zachovanie kapitálu je najvyššia priorita`, `Konzistentnosť prekonáva génia v dlhodobom horizonte`, `Zložitý systém vždy prekonáva jednoduchý systém`, `Proces je dôležitejší ako individuálny výsledok`],
        correct: 2,
      },
    ],
    de: [
      {
        q: `Was ist der erste Schritt in der Analysehierarchie des vollständigen Traders?`,
        options: [`Makro-Rahmen: globale Liquidität, Fed-Zyklus, DXY, NUPL on-chain`, `Einstiegssignal: SMC, Order Block, FVG, Wyckoff Spring`, `Technische Struktur: HH/HL/LH/LL auf Wochen- und Tagesbasis`, `Quantitative Validierung: Confluence Score und ML-Regime`],
        correct: 0,
      },
      {
        q: `Warum ist ein perfekter Trade im Prozess, der verliert, besser als ein impulsiver, der gewinnt?`,
        options: [`Weil er langfristig mehr Kapital bewahrt`, `Weil der impulsive Trade nicht systematisch reproduzierbar ist`, `Weil er weniger emotionalen Stress für den Trader erzeugt`, `Weil verlierende Trades wertvollere Lektionen lehren`],
        correct: 1,
      },
      {
        q: `Welches davon ist KEIN unveränderliches Prinzip erfolgreichen Tradings laut der Lektion?`,
        options: [`Die Kapitalerhaltung ist die oberste Priorität`, `Konsistenz übertrifft Genialität auf lange Sicht`, `Ein komplexes System übertrifft immer ein einfaches`, `Der Prozess ist wichtiger als das individuelle Ergebnis`],
        correct: 2,
      },
    ],
    "zh-CN": [
      {
        q: `完整交易者分析层级中的第一步是什么？`,
        options: [`宏观框架：全球流动性、美联储周期、DXY、链上NUPL`, `入场信号：SMC、Order Block、FVG、Wyckoff Spring`, `技术结构：周线和日线的HH/HL/LH/LL`, `量化验证：Confluence Score和ML市场状态`],
        correct: 0,
      },
      {
        q: `为什么流程完美但亏损的交易优于冲动但盈利的交易？`,
        options: [`因为长期保留更多资本`, `因为冲动交易无法系统性复制`, `因为给交易者带来更少的情绪压力`, `因为亏损交易能教会更多宝贵经验`],
        correct: 1,
      },
      {
        q: `根据本课，以下哪项不是成功交易的不变原则？`,
        options: [`资本保护是最高优先级`, `长期来看，一致性胜过天才`, `复杂系统总是优于简单系统`, `流程比单次结果更重要`],
        correct: 2,
      },
    ],
  },
};
